import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  SafeInt: any;
};

export type AmlResponse = {
  __typename?: 'AMLResponse';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<User>>>;
};

export type AboutUsMember = {
  __typename?: 'AboutUsMember';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  section?: Maybe<AboutUsMemberSection>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AboutUsMemberInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum AboutUsMemberSection {
  BOARD = 'BOARD',
  TEAM = 'TEAM'
}

export type AddCampaignFollowersAdminResponse = {
  __typename?: 'AddCampaignFollowersAdminResponse';
  addedFollowersCount?: Maybe<Scalars['Int']>;
  existingEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  invalidEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type AdminComment = {
  __typename?: 'AdminComment';
  _id?: Maybe<Scalars['ID']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<AdminUser>;
  parent?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['ID']>;
  version?: Maybe<Scalars['String']>;
};

export type AdminError = {
  __typename?: 'AdminError';
  _id?: Maybe<Scalars['ID']>;
  adminComments?: Maybe<Array<Maybe<AdminComment>>>;
  appName?: Maybe<Scalars['String']>;
  browserName?: Maybe<Scalars['String']>;
  clientVersion?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['Date']>;
  closedBy?: Maybe<AdminUser>;
  componentStack?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  currentVersion?: Maybe<Scalars['String']>;
  fullVersion?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  majorVersion?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  _id: Scalars['ID'];
  cco?: Maybe<Scalars['Boolean']>;
  ceo?: Maybe<Scalars['Boolean']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  emailSubscriptions?: Maybe<Array<Maybe<EmailSubscription>>>;
  isSuperUser?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  roles: Array<Maybe<AdminUserRole>>;
  twofactor?: Maybe<Twofactor>;
};

export type AdminUserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AdminUserPage = {
  __typename?: 'AdminUserPage';
  items?: Maybe<Array<Maybe<AdminUser>>>;
  timestamp?: Maybe<Scalars['Date']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum AdminUserRole {
  CAPLIST = 'CAPLIST',
  FACILITATOR = 'FACILITATOR',
  MARKETING = 'MARKETING',
  SALES = 'SALES'
}

export type AgendaJob = {
  __typename?: 'AgendaJob';
  _id?: Maybe<Scalars['ID']>;
  campaignTitle?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  lastFinishedAt?: Maybe<Scalars['Date']>;
  lastRunAt?: Maybe<Scalars['Date']>;
  lockedAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  nextRunAt?: Maybe<Scalars['Date']>;
  repeatInterval?: Maybe<Scalars['String']>;
};

export type AllAboutUsMembers = {
  __typename?: 'AllAboutUsMembers';
  cacheIsUpdated?: Maybe<Scalars['Boolean']>;
  members: Array<AboutUsMember>;
};

export type AmlMatchStrength = {
  __typename?: 'AmlMatchStrength';
  certainty?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
};

export type AmlScreening = {
  __typename?: 'AmlScreening';
  _id: Scalars['ID'];
  addresses?: Maybe<Array<Maybe<Scalars['String']>>>;
  aliases?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt: Scalars['Date'];
  createdBy?: Maybe<AdminUser>;
  functionDescription?: Maybe<Scalars['String']>;
  hasSanctions?: Maybe<Scalars['Boolean']>;
  hits?: Maybe<Array<Maybe<ScreeningItem>>>;
  isPep?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  screeningType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AssociatedCompany = {
  __typename?: 'AssociatedCompany';
  name?: Maybe<Scalars['String']>;
  organizationNumber?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
};

export type AssociatedCompanyInput = {
  name?: InputMaybe<Scalars['String']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<Scalars['String']>;
};

export type AssociatedReservationUser = {
  __typename?: 'AssociatedReservationUser';
  _id: Scalars['ID'];
  email: Scalars['String'];
  name: Scalars['String'];
};

export type BasicReservation = {
  __typename?: 'BasicReservation';
  _id: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  campaign: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  shareholder_rejected?: Maybe<Scalars['Boolean']>;
  shares?: Maybe<Scalars['Int']>;
  signee?: Maybe<Signee>;
  userState?: Maybe<Scalars['String']>;
};

export enum BlobContainer {
  CAMPAIGNDOCUMENTS = 'campaigndocuments',
  DOCUMENTS = 'documents',
  FILES = 'files',
  IMAGES = 'images',
  PUBLIC = 'public',
  SIGNATURES = 'signatures',
  VIDEOS = 'videos'
}

export type Bucket = {
  __typename?: 'Bucket';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type Campaign = {
  __typename?: 'Campaign';
  _id?: Maybe<Scalars['String']>;
  accountBankName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  assignedAdmins: Array<Maybe<AdminUser>>;
  board?: Maybe<Array<Maybe<OrganizationMember>>>;
  boardDecisionApproved?: Maybe<Scalars['Boolean']>;
  boardDecisionRequired?: Maybe<Scalars['Boolean']>;
  campaignDocumentStatus?: Maybe<Array<Maybe<RequiredCampaignDocument>>>;
  campaignFieldInfo?: Maybe<Array<Maybe<CampaignFieldInfo>>>;
  campaignOptions?: Maybe<Array<Maybe<CampaignOption>>>;
  campaignProgressCheck?: Maybe<CampaignProgressCheck>;
  campaignSectionData?: Maybe<Array<Maybe<CampaignToolSection>>>;
  campaignVideos?: Maybe<Array<Maybe<CampaignVideo>>>;
  canBeSetToFrozenStatus: Scalars['Boolean'];
  caption?: Maybe<Scalars['String']>;
  chairmanEmail?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['Date']>;
  closeDateRequested?: Maybe<Scalars['Date']>;
  commentCount?: Maybe<Scalars['Int']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyCity?: Maybe<Scalars['String']>;
  companyEmail?: Maybe<Scalars['String']>;
  companyFoundedDate?: Maybe<Scalars['Date']>;
  companyLogo?: Maybe<File>;
  companyLogoSmall?: Maybe<File>;
  companyName?: Maybe<Scalars['String']>;
  companyNumber?: Maybe<Scalars['String']>;
  companyPostcode?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  companyValue?: Maybe<Scalars['Float']>;
  concentsRequired?: Maybe<Array<Maybe<CampaignConcent>>>;
  contributors?: Maybe<Array<Maybe<Contributor>>>;
  coverImage?: Maybe<File>;
  createdAt?: Maybe<Scalars['Date']>;
  dateRequest: DateRequest;
  description?: Maybe<Scalars['String']>;
  descriptionHTML?: Maybe<Scalars['String']>;
  emailInviteSent?: Maybe<Scalars['Boolean']>;
  emailReminderCount?: Maybe<Scalars['Int']>;
  emailReminders?: Maybe<Array<Maybe<CampaignEmailReminder>>>;
  featuredVideo?: Maybe<CampaignVideo>;
  filesOptional?: Maybe<Array<Maybe<File>>>;
  filesOptionalData?: Maybe<Array<Maybe<PublicCampaignDocument>>>;
  filesRequired?: Maybe<Array<Maybe<File>>>;
  filesRequiredData?: Maybe<Array<Maybe<PublicCampaignDocument>>>;
  finalizedReservationsList?: Maybe<Scalars['Boolean']>;
  fundedStatus?: Maybe<Scalars['String']>;
  generalAssembly?: Maybe<GeneralAssembly>;
  hasDeniedMandate?: Maybe<Scalars['Boolean']>;
  hasReceivedPreorderOffer: Array<Maybe<Scalars['String']>>;
  hasSignedRiskEvaluation?: Maybe<Scalars['Boolean']>;
  hasVPS?: Maybe<Scalars['Boolean']>;
  invoiceSent?: Maybe<Array<Maybe<Scalars['Date']>>>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isOutdated?: Maybe<Scalars['Boolean']>;
  licensePaid?: Maybe<Scalars['String']>;
  logo?: Maybe<File>;
  mandates?: Maybe<Array<Maybe<CampaignMandate>>>;
  manualEmailInviteSent?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxVideosCount?: Maybe<Scalars['Int']>;
  maximumInvestment?: Maybe<Scalars['Float']>;
  maximumShareInvestment?: Maybe<Scalars['Int']>;
  minimumInvestment?: Maybe<Scalars['Float']>;
  minimumShareInvestment?: Maybe<Scalars['Int']>;
  nominalShareValue?: Maybe<Scalars['Float']>;
  numberOfCurrentShares?: Maybe<Scalars['Int']>;
  onboarding?: Maybe<Onboarding>;
  onboardingCompleted?: Maybe<Scalars['Boolean']>;
  owners?: Maybe<Array<Owner>>;
  pageViews?: Maybe<Scalars['Int']>;
  pageViewsArray?: Maybe<Array<Maybe<Scalars['Date']>>>;
  partners?: Maybe<Array<Maybe<OrganizationMember>>>;
  paymentRemindersDisabled?: Maybe<Scalars['Boolean']>;
  paymentRemindersSentAt?: Maybe<Scalars['Date']>;
  paymentRemindersSentCount?: Maybe<Scalars['Int']>;
  pendingDocumentsCount?: Maybe<Scalars['Int']>;
  preAllocationAmount?: Maybe<Scalars['Float']>;
  preAllocationGoal?: Maybe<Scalars['Float']>;
  preAllocationGoalMet?: Maybe<Scalars['Boolean']>;
  preAllocationPts?: Maybe<Scalars['Float']>;
  pricePerShare?: Maybe<Scalars['Float']>;
  prospectusNeeded?: Maybe<Scalars['Boolean']>;
  publishApproval?: Maybe<PublishApprovalItem>;
  publishDate?: Maybe<Scalars['Date']>;
  raisingAmountMaximum?: Maybe<Scalars['Float']>;
  raisingAmountMinimum?: Maybe<Scalars['Float']>;
  raisingSharesMaximum?: Maybe<Scalars['Int']>;
  raisingSharesMinimum?: Maybe<Scalars['Int']>;
  recentFollowers?: Maybe<Scalars['Int']>;
  recentReservationsCount?: Maybe<Scalars['Int']>;
  recentViews?: Maybe<Scalars['Int']>;
  referralsAmount?: Maybe<CampaignReferrals>;
  reservations?: Maybe<Array<Reservation>>;
  reservationsList?: Maybe<Array<ReservationsListItem>>;
  reservationsSummary?: Maybe<ReservationsSummary>;
  riskEvaluation?: Maybe<RiskEvaluationItem>;
  scheduledPaymentReminderDate?: Maybe<Scalars['Date']>;
  selfreportData?: Maybe<Array<Maybe<SelfReportItemData>>>;
  selfreportlist?: Maybe<Array<Maybe<SelfreportItem>>>;
  shareholdersApprovalPending?: Maybe<Scalars['Boolean']>;
  shareholdersApproved?: Maybe<Scalars['Boolean']>;
  sharesCapital?: Maybe<Scalars['Float']>;
  signed?: Maybe<Scalars['Boolean']>;
  signedRiskEvaluationCount?: Maybe<Scalars['Int']>;
  singlePurposeVehicle?: Maybe<SinglePurposeVehicle>;
  singlePurposeVehicleEnabled?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  team?: Maybe<Array<Maybe<OrganizationMember>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
  verifiedAccountNumber?: Maybe<Scalars['Boolean']>;
  willAcceptPreorderOffers: Array<Maybe<WillAcceptPreorderItem>>;
};

export type CampaignAdminInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  board?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
  boardDecisionApproved?: InputMaybe<Scalars['Boolean']>;
  boardDecisionRequired?: InputMaybe<Scalars['Boolean']>;
  campaignOptions?: InputMaybe<Array<InputMaybe<CampaignOptionInput>>>;
  campaignVideo?: InputMaybe<CampaignVideoInput>;
  caption?: InputMaybe<Scalars['String']>;
  chairmanEmail?: InputMaybe<Scalars['String']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyCity?: InputMaybe<Scalars['String']>;
  companyEmail?: InputMaybe<Scalars['String']>;
  companyFoundedDate?: InputMaybe<Scalars['Date']>;
  companyLogo?: InputMaybe<FileInput>;
  companyLogoSmall?: InputMaybe<FileInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companyNumber?: InputMaybe<Scalars['String']>;
  companyPostcode?: InputMaybe<Scalars['String']>;
  companyURL?: InputMaybe<Scalars['String']>;
  companyValue?: InputMaybe<Scalars['Float']>;
  contributors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  coverImage?: InputMaybe<FileInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHTML?: InputMaybe<Scalars['String']>;
  featuredVideoId?: InputMaybe<Scalars['String']>;
  filesOptional?: InputMaybe<Array<InputMaybe<FileInput>>>;
  filesRequired?: InputMaybe<Array<InputMaybe<FileInput>>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  licensePaid?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<FileInput>;
  logoSmall?: InputMaybe<FileInput>;
  maximumInvestment?: InputMaybe<Scalars['Float']>;
  maximumShareInvestment?: InputMaybe<Scalars['Int']>;
  minimumInvestment?: InputMaybe<Scalars['Float']>;
  minimumShareInvestment?: InputMaybe<Scalars['Int']>;
  nominalShareValue?: InputMaybe<Scalars['Float']>;
  numberOfCurrentShares?: InputMaybe<Scalars['Int']>;
  owners?: InputMaybe<Array<InputMaybe<OwnerInput>>>;
  partners?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
  preAllocationAmount?: InputMaybe<Scalars['Float']>;
  preAllocationGoal?: InputMaybe<Scalars['Float']>;
  pricePerShare?: InputMaybe<Scalars['Float']>;
  publishDate?: InputMaybe<Scalars['Date']>;
  raisingAmountMaximum?: InputMaybe<Scalars['Float']>;
  raisingAmountMinimum?: InputMaybe<Scalars['Float']>;
  raisingSharesMaximum?: InputMaybe<Scalars['Int']>;
  raisingSharesMinimum?: InputMaybe<Scalars['Int']>;
  riskEvaluation?: InputMaybe<RiskEvaluationItemInput>;
  selfreportlist?: InputMaybe<Array<InputMaybe<SelfreportItemInput>>>;
  sharesCapital?: InputMaybe<Scalars['Float']>;
  signed?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type CampaignCard = {
  __typename?: 'CampaignCard';
  caption?: Maybe<Scalars['String']>;
  dates?: Maybe<CampaignDates>;
  finishedCampaignData?: Maybe<FinishedCampaignCardCampaignData>;
  finishedSuccessfully?: Maybe<Scalars['Boolean']>;
  followerCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  recentPageViewsCount: Scalars['Int'];
  recentReservationsCount: Scalars['Int'];
  reservationsCount?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  state: CampaignCardState;
  title?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export enum CampaignCardState {
  ARCHIVED = 'ARCHIVED',
  COMING_SOON = 'COMING_SOON',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING',
  UPCOMING = 'UPCOMING'
}

export type CampaignCheckResponse = {
  __typename?: 'CampaignCheckResponse';
  exists?: Maybe<Scalars['Boolean']>;
  isOwnerOrContributor?: Maybe<Scalars['Boolean']>;
  onboardingCompleted?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
};

export type CampaignConcent = {
  __typename?: 'CampaignConcent';
  content?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CampaignConfigOption = {
  __typename?: 'CampaignConfigOption';
  defaultText?: Maybe<Scalars['String']>;
  disabledIfChecked?: Maybe<Array<Maybe<Scalars['String']>>>;
  helperText?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  needsConfirmation?: Maybe<Scalars['Boolean']>;
  section?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CampaignDates = {
  __typename?: 'CampaignDates';
  close?: Maybe<Scalars['Date']>;
  open?: Maybe<Scalars['Date']>;
  publish?: Maybe<Scalars['Date']>;
};

export type CampaignDocument = {
  __typename?: 'CampaignDocument';
  _id?: Maybe<Scalars['ID']>;
  actionsPerformed?: Maybe<Array<Maybe<CampaignDocumentAction>>>;
  actionsRequired?: Maybe<Array<Maybe<CampaignDocumentAction>>>;
  approved?: Maybe<Scalars['Boolean']>;
  blobName?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['ID']>;
  category?: Maybe<CampaignDocumentCategoryEnum>;
  categoryNorwegianString?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<Maybe<DocumentComment>>>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  fileSize?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Date']>;
  processedBy?: Maybe<Scalars['String']>;
  rejected?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
};

export type CampaignDocumentAction = {
  __typename?: 'CampaignDocumentAction';
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  name: CampaignDocumentActionEnum;
};

export enum CampaignDocumentActionEnum {
  CONFIRMATION = 'CONFIRMATION',
  SIGNATURE = 'SIGNATURE'
}

export type CampaignDocumentCategory = {
  __typename?: 'CampaignDocumentCategory';
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum CampaignDocumentCategoryEnum {
  ACCOUNT_CONFIRMATION = 'ACCOUNT_CONFIRMATION',
  BRREG_EMISSION_CONFIRMATION = 'BRREG_EMISSION_CONFIRMATION',
  COMPLETENESS_DECLARATION = 'COMPLETENESS_DECLARATION',
  CUSTOMER_AGREEMENT = 'CUSTOMER_AGREEMENT',
  DETAILED_BUDGET_SHORT_TERM = 'DETAILED_BUDGET_SHORT_TERM',
  GENERAL_ASSEMBLY_PROTOCOL = 'GENERAL_ASSEMBLY_PROTOCOL',
  INTERIM_REPORT = 'INTERIM_REPORT',
  LAST_YEARS_AUDIT = 'LAST_YEARS_AUDIT',
  LAST_YEARS_AUDIT_ACCOUNT_SPECIFIED = 'LAST_YEARS_AUDIT_ACCOUNT_SPECIFIED',
  LOAN_AGREEEMENTS = 'LOAN_AGREEEMENTS',
  NO_CATEGORY = 'NO_CATEGORY',
  OVERALL_BUDGET_LONG_TERM = 'OVERALL_BUDGET_LONG_TERM',
  PREALLOCATION_LIST = 'PREALLOCATION_LIST'
}

export type CampaignDocumentInput = {
  actionsRequired?: InputMaybe<Array<InputMaybe<CampaignDocumentActionEnum>>>;
  blobName?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<CampaignDocumentCategoryEnum>;
  comment?: InputMaybe<Scalars['String']>;
  fileSize?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  originalName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum CampaignDocumentStatusEnum {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export type CampaignEmailReminder = {
  __typename?: 'CampaignEmailReminder';
  _id?: Maybe<Scalars['ID']>;
  campaign?: Maybe<Campaign>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  reminderSent?: Maybe<Array<Maybe<Scalars['Date']>>>;
  user?: Maybe<User>;
};

export type CampaignFieldInfo = {
  __typename?: 'CampaignFieldInfo';
  comment?: Maybe<Scalars['String']>;
  denied?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  isValid?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  section?: Maybe<Scalars['String']>;
  sectionLabel?: Maybe<Scalars['String']>;
  subFields?: Maybe<Array<Maybe<CampaignFieldInfo>>>;
  updated?: Maybe<Scalars['Boolean']>;
};

export type CampaignFilter = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CampaignFollower = {
  __typename?: 'CampaignFollower';
  _id?: Maybe<Scalars['ID']>;
  campaign?: Maybe<Campaign>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  hasReceivedPreorderOffer?: Maybe<Scalars['Boolean']>;
  reminderSent?: Maybe<Array<Maybe<Scalars['Date']>>>;
  user?: Maybe<User>;
  willAcceptPreorderOffer?: Maybe<Scalars['Boolean']>;
};

export type CampaignJson = {
  __typename?: 'CampaignJSON';
  _id: Scalars['ID'];
  campaign?: Maybe<Campaign>;
  ignoredFields: Array<Maybe<Scalars['String']>>;
  json?: Maybe<Scalars['String']>;
};

export type CampaignMandate = {
  __typename?: 'CampaignMandate';
  approved?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<AdminUser>;
  denied?: Maybe<Scalars['Boolean']>;
};

export type CampaignMandateInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  denied?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignOption = {
  __typename?: 'CampaignOption';
  checked?: Maybe<Scalars['Boolean']>;
  labelText?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type CampaignOptionInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  labelText?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type CampaignPage = {
  __typename?: 'CampaignPage';
  items?: Maybe<Array<Maybe<Campaign>>>;
  timestamp?: Maybe<Scalars['Date']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CampaignProgressCheck = {
  __typename?: 'CampaignProgressCheck';
  createdAt?: Maybe<Scalars['Date']>;
  reservationsSummary?: Maybe<ReservationsSummary>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CampaignReferrals = {
  __typename?: 'CampaignReferrals';
  registered?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Int']>;
};

export type CampaignSignatureType = {
  __typename?: 'CampaignSignatureType';
  actionName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CampaignSigneeData = {
  __typename?: 'CampaignSigneeData';
  campaignMax?: Maybe<Scalars['Int']>;
  maxPerSignee?: Maybe<Scalars['Int']>;
  maxSharesLeft?: Maybe<Scalars['Int']>;
  minPerSignee?: Maybe<Scalars['Int']>;
  signeeCurrentShares?: Maybe<Scalars['Int']>;
  totalSharesLeft?: Maybe<Scalars['Int']>;
};

export type CampaignToolSection = {
  __typename?: 'CampaignToolSection';
  disabled?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type CampaignVideo = {
  __typename?: 'CampaignVideo';
  blobName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  privacyStatus?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  youtubeId?: Maybe<Scalars['String']>;
};

export type CampaignVideoInput = {
  blobName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  privacyStatus?: InputMaybe<Scalars['String']>;
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CardRequestResult = {
  __typename?: 'CardRequestResult';
  amount?: Maybe<Scalars['Int']>;
  index?: Maybe<Scalars['Int']>;
  list: Array<Maybe<Campaign>>;
  total?: Maybe<Scalars['Int']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  _id?: Maybe<Scalars['ID']>;
  assignedAdmins: Array<Maybe<AdminUser>>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']>;
  comments?: Maybe<Array<Maybe<AdminComment>>>;
  createdAt?: Maybe<Scalars['Date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  lastStep?: Maybe<ChecklistItem>;
  list?: Maybe<Array<Maybe<ChecklistItem>>>;
  nextStep?: Maybe<ChecklistItem>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updates?: Maybe<Array<Maybe<ChecklistUpdateItem>>>;
};

export type ChecklistInput = {
  name?: InputMaybe<Scalars['String']>;
  stringValue?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  automatic?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Array<Maybe<Scalars['String']>>>;
  index?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ChecklistSimple = {
  __typename?: 'ChecklistSimple';
  _id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ChecklistUpdateItem = {
  __typename?: 'ChecklistUpdateItem';
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type ComingSoonItem = {
  __typename?: 'ComingSoonItem';
  _id?: Maybe<Scalars['ID']>;
  activeIndex?: Maybe<Scalars['Int']>;
  campaign?: Maybe<Campaign>;
  caption?: Maybe<Scalars['String']>;
  coverImage?: Maybe<File>;
  title?: Maybe<Scalars['String']>;
  websiteURL?: Maybe<Scalars['String']>;
};

export type ComingSoonItemInput = {
  campaignId: Scalars['ID'];
  caption?: InputMaybe<Scalars['String']>;
  coverImage?: InputMaybe<FileInput>;
  title?: InputMaybe<Scalars['String']>;
  websiteURL?: InputMaybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  _id: Scalars['ID'];
  campaign?: Maybe<Campaign>;
  children?: Maybe<Array<Maybe<Comment>>>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  likes?: Maybe<Array<Scalars['ID']>>;
  parent?: Maybe<Scalars['ID']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
  userStatus?: Maybe<Scalars['String']>;
};

export type CommentJson = {
  __typename?: 'CommentJSON';
  comment?: Maybe<Comment>;
  json?: Maybe<Scalars['String']>;
};

export type CommentPage = {
  __typename?: 'CommentPage';
  items?: Maybe<Array<Maybe<Comment>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Company = {
  __typename?: 'Company';
  _id?: Maybe<Scalars['ID']>;
  address?: Maybe<Scalars['String']>;
  certificate?: Maybe<File>;
  certificates: Array<Maybe<CompanyCertificate>>;
  city?: Maybe<Scalars['String']>;
  foundedDate?: Maybe<Scalars['Date']>;
  hasNoOwners: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  organizationNumber: Scalars['String'];
  organizationType: Scalars['String'];
  owners?: Maybe<Array<Maybe<CompanyOwner>>>;
  postcode?: Maybe<Scalars['String']>;
  removedUsers: Array<Maybe<CompanyUser>>;
  userStatus?: Maybe<Scalars['String']>;
  users: Array<Maybe<CompanyUser>>;
  verified?: Maybe<Scalars['Date']>;
};

export type CompanyCertificate = {
  __typename?: 'CompanyCertificate';
  _id?: Maybe<Scalars['ID']>;
  approved?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  file: File;
  processed?: Maybe<Scalars['Boolean']>;
  processedAt?: Maybe<Scalars['Date']>;
  processedBy?: Maybe<Scalars['String']>;
  submitDate?: Maybe<Scalars['Date']>;
  submitUser?: Maybe<User>;
  submitUserId?: Maybe<Scalars['ID']>;
};

export enum CompanyCountryCodeEnum {
  DK = 'DK',
  NO = 'NO',
  SE = 'SE'
}

export type CompanyOwner = {
  __typename?: 'CompanyOwner';
  _id?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  removedAt?: Maybe<Scalars['Date']>;
  removedBy?: Maybe<User>;
};

export type CompanySearchResult = {
  __typename?: 'CompanySearchResult';
  countryCode: CompanyCountryCodeEnum;
  hitCount: Scalars['Int'];
  hits: Array<Maybe<CompanySearchResultItem>>;
  next?: Maybe<Scalars['String']>;
  pageIndex: Scalars['Int'];
  previous?: Maybe<Scalars['String']>;
  totalPages: Scalars['Int'];
};

export type CompanySearchResultItem = {
  __typename?: 'CompanySearchResultItem';
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  legalGroupCode?: Maybe<Scalars['String']>;
  legalGroupText?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  addedBy?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['Boolean']>;
  removedBy?: Maybe<Scalars['String']>;
};

export type Concent = {
  __typename?: 'Concent';
  createdAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type Contributor = {
  __typename?: 'Contributor';
  bankidverified?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type CreateCampaignInput = {
  companyAddress: Scalars['String'];
  companyCity: Scalars['String'];
  companyName: Scalars['String'];
  companyNumber: Scalars['String'];
  companyPostcode: Scalars['String'];
  title: Scalars['String'];
};

export type CreateCommentInput = {
  content?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateSignatureInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<SignatureCategoryEnum>;
  signers?: InputMaybe<Array<InputMaybe<SignerInput>>>;
};

export type CustomRequiredDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  title: Scalars['String'];
};

export type CustomerAgreementInput = {
  blobName: Scalars['String'];
  campaignId: Scalars['ID'];
  containerName: BlobContainer;
  filesize: Scalars['Int'];
  mimetype: Scalars['String'];
  originalFilename: Scalars['String'];
  signers: Array<InputMaybe<SignaturUserInput>>;
};

export type DateRequest = {
  __typename?: 'DateRequest';
  approved?: Maybe<Scalars['Boolean']>;
  closeDate?: Maybe<Scalars['Date']>;
  comment?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Date']>;
  processedBy?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['Date']>;
  requested?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type DateRequestInput = {
  closeDate?: InputMaybe<Scalars['Date']>;
  publishDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type DeletePayload = {
  __typename?: 'DeletePayload';
  campaigns?: Maybe<Scalars['Int']>;
  commentSubscriptions?: Maybe<Scalars['Int']>;
  companyUsers?: Maybe<Scalars['Int']>;
  emailReminders?: Maybe<Scalars['Int']>;
  users?: Maybe<Scalars['Int']>;
};

export type DocumentComment = {
  __typename?: 'DocumentComment';
  commentId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['ID']>;
};

export type DocumentLockInput = {
  documentId: Scalars['String'];
  hidden?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
};

export type EditInvestorRelationsEventInput = {
  dateOfEvent?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  endDateOfEvent?: InputMaybe<Scalars['Date']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EditInvestorRelationsHighlights = {
  dateOfHighlight?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EmailPreferences = {
  __typename?: 'EmailPreferences';
  email?: Maybe<Scalars['String']>;
  notifyInterval?: Maybe<Scalars['String']>;
  receiveNewsletter?: Maybe<Scalars['Boolean']>;
};

export type EmailPreferencesInput = {
  email: Scalars['String'];
  notifyInterval?: InputMaybe<Scalars['String']>;
  receiveNewsletter?: InputMaybe<Scalars['Boolean']>;
};

export type EmailSent = {
  __typename?: 'EmailSent';
  _id?: Maybe<Scalars['ID']>;
  consignment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  data?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type EmailSpamReport = {
  __typename?: 'EmailSpamReport';
  created?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
};

export type EmailSubscription = {
  __typename?: 'EmailSubscription';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<RecipientTypeEnum>;
};

export type EmailSubscriptionType = {
  __typename?: 'EmailSubscriptionType';
  bcc?: Maybe<Array<Maybe<AdminUser>>>;
  cc?: Maybe<Array<Maybe<AdminUser>>>;
  description?: Maybe<Scalars['String']>;
  ignoreEmptyRecipients?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  to?: Maybe<Array<Maybe<AdminUser>>>;
};

export type EmailSubscriptionsInput = {
  recipientType: RecipientTypeEnum;
  subscriptionType: Scalars['String'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  testData?: Maybe<Scalars['String']>;
};

export type EmailsSentPage = {
  __typename?: 'EmailsSentPage';
  items?: Maybe<Array<Maybe<EmailSent>>>;
  timestamp?: Maybe<Scalars['Date']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ErrorInput = {
  appName?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  clientVersion?: InputMaybe<Scalars['String']>;
  componentStack?: InputMaybe<Scalars['String']>;
  currentVersion?: InputMaybe<Scalars['String']>;
  fullVersion?: InputMaybe<Scalars['String']>;
  majorVersion?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  stack?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type EventLog = {
  __typename?: 'EventLog';
  _id?: Maybe<Scalars['ID']>;
  admin?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<Scalars['ID']>;
  createdByAdmin?: Maybe<AdminUser>;
  createdByUser?: Maybe<User>;
  data: Array<Maybe<EventLogData>>;
  event?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['ID']>;
};

export type EventLogData = {
  __typename?: 'EventLogData';
  field?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EventLogQuery = {
  __typename?: 'EventLogQuery';
  _id?: Maybe<Scalars['ID']>;
  event?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['ID']>;
  toDate?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['String']>;
};

export type EventLogQueryInput = {
  _id?: InputMaybe<Scalars['ID']>;
  event?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Scalars['ID']>;
  toDate?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EventLogQueryResponse = {
  __typename?: 'EventLogQueryResponse';
  list: Array<Maybe<EventLog>>;
  query?: Maybe<EventLogQuery>;
  searchCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Expediency = {
  __typename?: 'Expediency';
  _id?: Maybe<Scalars['ID']>;
  approved?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  fields?: Maybe<Array<Maybe<ExpediencyField>>>;
  outdatedApproval?: Maybe<Scalars['Boolean']>;
  profileConfirmed?: Maybe<Scalars['Boolean']>;
  signed?: Maybe<Scalars['Date']>;
  totalAttempts?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export type ExpediencyField = {
  __typename?: 'ExpediencyField';
  answer?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export type ExpediencyFieldInput = {
  answer?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ExpediencyFieldStats = {
  __typename?: 'ExpediencyFieldStats';
  _id?: Maybe<Scalars['String']>;
  countFalse?: Maybe<Scalars['Int']>;
  countTrue?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ExpediencyInput = {
  _id?: InputMaybe<Scalars['ID']>;
  fields?: InputMaybe<Array<InputMaybe<ExpediencyFieldInput>>>;
  profileConfirmed?: InputMaybe<Scalars['Boolean']>;
};

export type ExpediencyResponse = {
  __typename?: 'ExpediencyResponse';
  outdatedApproval?: Maybe<Scalars['Boolean']>;
  result?: Maybe<Scalars['Boolean']>;
  signed?: Maybe<Scalars['Boolean']>;
  signedDate?: Maybe<Scalars['Date']>;
  testId?: Maybe<Scalars['ID']>;
  totalAttempts?: Maybe<Scalars['Int']>;
};

export type ExpediencyStats = {
  __typename?: 'ExpediencyStats';
  abortedAtConclusion?: Maybe<Scalars['Int']>;
  approved?: Maybe<Scalars['Int']>;
  averageTimeSpent?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  fields?: Maybe<Array<Maybe<ExpediencyFieldStats>>>;
  incomplete?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  signedFields?: Maybe<Array<Maybe<SignedExpediencyFieldStats>>>;
  total?: Maybe<Scalars['Int']>;
  totalTimeSpent?: Maybe<Scalars['SafeInt']>;
};

export type FeedbackResult = {
  __typename?: 'FeedbackResult';
  average?: Maybe<Scalars['Float']>;
  list?: Maybe<Array<Maybe<ReservationFeedback>>>;
};

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FileInput = {
  id?: InputMaybe<Scalars['ID']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FinishedCampaignCardCampaignData = {
  __typename?: 'FinishedCampaignCardCampaignData';
  _id: Scalars['ID'];
  raisingAmountMaximum?: Maybe<Scalars['Float']>;
  raisingAmountMinimum?: Maybe<Scalars['Float']>;
  raisingSharesMaximum?: Maybe<Scalars['Int']>;
  raisingSharesMinimum?: Maybe<Scalars['Int']>;
  reservationsSummary?: Maybe<ReservationsSummary>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type FollowersForCampaignInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  ignoreLimit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortfield?: InputMaybe<Scalars['String']>;
};

export type FollowersForCampaignReponse = {
  __typename?: 'FollowersForCampaignReponse';
  done?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<Maybe<CampaignFollower>>>;
  next?: Maybe<PaginationOutput>;
  totalcount?: Maybe<Scalars['Int']>;
};

export type GeneralAssembly = {
  __typename?: 'GeneralAssembly';
  approved?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  file?: Maybe<File>;
  processedAt?: Maybe<Scalars['Date']>;
  processedBy?: Maybe<Scalars['String']>;
};

export type GetSignatureInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<SignatureCategoryEnum>;
  documentId?: InputMaybe<Scalars['String']>;
};

export type GlobalConfig = {
  __typename?: 'GlobalConfig';
  _id?: Maybe<Scalars['ID']>;
  name?: Maybe<GlobalConfigEnum>;
  value?: Maybe<Scalars['Boolean']>;
};

export enum GlobalConfigEnum {
  AUTOMATIC_COMING_SOON_SORTING = 'AUTOMATIC_COMING_SOON_SORTING',
  ENABLE_SPECIAL_FRONT_PAGE = 'ENABLE_SPECIAL_FRONT_PAGE',
  NOTIFY_AUTOMATICALLY_APPROVED_CERTIFICATES_TO_ALTERNATIVE_SLACK_CHANNEL = 'NOTIFY_AUTOMATICALLY_APPROVED_CERTIFICATES_TO_ALTERNATIVE_SLACK_CHANNEL'
}

export type GlobalConfigInput = {
  name: GlobalConfigEnum;
  value: Scalars['Boolean'];
};

export type HomeStatsResponse = {
  __typename?: 'HomeStatsResponse';
  items?: Maybe<Array<Maybe<StatisticsItem>>>;
  lastUpdate?: Maybe<Scalars['Date']>;
};

export enum InterestedCompanyCountryEnum {
  DK = 'DK',
  NO = 'NO',
  SE = 'SE'
}

export type IntervalData = {
  __typename?: 'IntervalData';
  changesLastDay?: Maybe<Scalars['Int']>;
  changesLastMonth?: Maybe<Scalars['Int']>;
  changesLastWeek?: Maybe<Scalars['Int']>;
  changesTotal?: Maybe<Scalars['Int']>;
  current?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type IntervalLists = {
  __typename?: 'IntervalLists';
  all: Array<Maybe<UserEmailData>>;
  monthly: Array<Maybe<UserEmailData>>;
  weekly: Array<Maybe<UserEmailData>>;
};

export type InvestmentCompanySearchInput = {
  countryCode: CompanyCountryCodeEnum;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
};

export type InvestorRelationsEvent = {
  __typename?: 'InvestorRelationsEvent';
  _id?: Maybe<Scalars['ID']>;
  dateOfEvent?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  endDateOfEvent?: Maybe<Scalars['Date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type InvestorRelationsEventInput = {
  dateOfEvent: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  endDateOfEvent: Scalars['Date'];
  hidden: Scalars['Boolean'];
  title: Scalars['String'];
};

export type InvestorRelationsEventPage = {
  __typename?: 'InvestorRelationsEventPage';
  events?: Maybe<Array<Maybe<InvestorRelationsEvent>>>;
  pageIndex?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvestorRelationsHeader = {
  __typename?: 'InvestorRelationsHeader';
  _id?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<AdminUser>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type InvestorRelationsHeaderInput = {
  description: Scalars['String'];
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  videoUrl: Scalars['String'];
};

export type InvestorRelationsHighlight = {
  __typename?: 'InvestorRelationsHighlight';
  _id?: Maybe<Scalars['ID']>;
  dateOfHighlight?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type InvestorRelationsHighlightInput = {
  dateOfHighlight: Scalars['Date'];
  description: Scalars['String'];
  linkUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type InvestorRelationsHighlightPage = {
  __typename?: 'InvestorRelationsHighlightPage';
  highlights?: Maybe<Array<Maybe<InvestorRelationsHighlight>>>;
  pageIndex?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InvitePayload = {
  __typename?: 'InvitePayload';
  campaign?: Maybe<Campaign>;
  count?: Maybe<Scalars['Int']>;
  errors?: Maybe<Scalars['Int']>;
};

export type JobListing = {
  __typename?: 'JobListing';
  apply_link?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  contact?: Maybe<JobListingContact>;
  country?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  posting_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type JobListingContact = {
  __typename?: 'JobListingContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type Link = {
  __typename?: 'Link';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type LinkInput = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ManualInvitePayload = {
  __typename?: 'ManualInvitePayload';
  campaign?: Maybe<Campaign>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  sent?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MediaMention = {
  __typename?: 'MediaMention';
  _id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};

export type MediaMentionInput = {
  _id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _dangerouslyDeleteExpediencyTests?: Maybe<User>;
  abortPublishedCampaignAndSetToDraft: Campaign;
  acceptTerms?: Maybe<Scalars['Boolean']>;
  activateCampaignProgressCheck?: Maybe<Scalars['Boolean']>;
  activateDailyStats?: Maybe<Scalars['Boolean']>;
  activateWeeklyStatsToSlack?: Maybe<Scalars['Boolean']>;
  addAboutUsMember: AboutUsMember;
  addAboutUsMembersByJSON?: Maybe<Scalars['Boolean']>;
  addAdminComment?: Maybe<Scalars['Boolean']>;
  addAdminUser?: Maybe<Scalars['Boolean']>;
  addCampaignDocument?: Maybe<CampaignDocument>;
  addCampaignFollowersAdmin?: Maybe<AddCampaignFollowersAdminResponse>;
  addCampaignMandate?: Maybe<Campaign>;
  addComment?: Maybe<Comment>;
  addCommentToCampaignDocument?: Maybe<CampaignDocument>;
  addCompanyCertificate?: Maybe<Company>;
  addCompanyOwner?: Maybe<Company>;
  addCompanyToUserProfile?: Maybe<Scalars['Boolean']>;
  addCompanyUser?: Maybe<Company>;
  addContributor?: Maybe<Scalars['Boolean']>;
  addInvestmentCompanyToProfile?: Maybe<Company>;
  addInvestmentsPageVisitor?: Maybe<Scalars['Boolean']>;
  addInvestorRelationsEvent?: Maybe<InvestorRelationsEvent>;
  addInvestorRelationsHeader?: Maybe<InvestorRelationsHeader>;
  addInvestorRelationsHighlight?: Maybe<InvestorRelationsHighlight>;
  addPublicDocument?: Maybe<PublicDocument>;
  addRiskHistoryComment?: Maybe<Scalars['Boolean']>;
  addService?: Maybe<Scalars['Boolean']>;
  addTestimonial?: Maybe<Testimonial>;
  addVideo?: Maybe<Scalars['Boolean']>;
  amlScreenNameForRiskEval?: Maybe<RiskEvaluationScreening>;
  approveCampaign?: Maybe<Campaign>;
  approveCompanyCertificate?: Maybe<User>;
  approveOnboarding?: Maybe<Campaign>;
  approveShareholders?: Maybe<Campaign>;
  approveUserForPreorder?: Maybe<Scalars['Boolean']>;
  archiveCompanyCertificate?: Maybe<Company>;
  assignAdminsToCampaign?: Maybe<Campaign>;
  assignAdminsToChecklist?: Maybe<Checklist>;
  assignCampaignToChecklist?: Maybe<Checklist>;
  blockUserLogin?: Maybe<User>;
  bulkMarkPreorderOffersSent?: Maybe<Campaign>;
  cancelAgendaJob?: Maybe<Scalars['Boolean']>;
  cancelCustomerAgreementSignatureProcess?: Maybe<Scalars['Boolean']>;
  cancelRejectReservation?: Maybe<Reservation>;
  cancelReservation?: Maybe<Reservation>;
  cancelSignature?: Maybe<Signature>;
  changeEmailAddressForUser?: Maybe<User>;
  changePassword: Scalars['Boolean'];
  cleanCampaignDocumentBlobName?: Maybe<CampaignDocument>;
  cleanVideoBlobName: CampaignVideo;
  closeError?: Maybe<AdminError>;
  confirmTwofactorQR?: Maybe<Scalars['Boolean']>;
  createCampaign?: Maybe<Campaign>;
  createCampaignChecklist?: Maybe<Scalars['Boolean']>;
  createCustomerAgreement?: Maybe<Scalars['Boolean']>;
  createPushmessage?: Maybe<Pushmessage>;
  deleteAboutUsMember: Scalars['Boolean'];
  deleteAdminComment?: Maybe<Scalars['Boolean']>;
  deleteAdminUser?: Maybe<AdminUser>;
  deleteCampaign?: Maybe<Scalars['Boolean']>;
  deleteCampaignDocument?: Maybe<CampaignDocument>;
  deleteCampaignDocumentComment?: Maybe<CampaignDocument>;
  deleteCampaignVideo?: Maybe<Campaign>;
  deleteComingSoon?: Maybe<Scalars['Boolean']>;
  deleteComment?: Maybe<Scalars['Boolean']>;
  deleteCompanyCertificate?: Maybe<Company>;
  deleteCustomRequiredDocument?: Maybe<Campaign>;
  deleteInvestorRelationsEvent?: Maybe<Scalars['Boolean']>;
  deleteInvestorRelationsHighlight?: Maybe<Scalars['Boolean']>;
  deleteMediaMention?: Maybe<Scalars['Boolean']>;
  deletePressRelease?: Maybe<Scalars['Boolean']>;
  deletePublicDocument?: Maybe<Scalars['Boolean']>;
  deleteRedisItem?: Maybe<Scalars['String']>;
  deleteReservationAdmin?: Maybe<Scalars['Boolean']>;
  deleteRiskEvaluation?: Maybe<Scalars['Boolean']>;
  deleteRiskEvaluationRRH?: Maybe<Scalars['Boolean']>;
  deleteRiskHistoryComment?: Maybe<Scalars['Boolean']>;
  deleteSpamReport?: Maybe<User>;
  deleteTestimonial?: Maybe<Scalars['Boolean']>;
  deleteVideo?: Maybe<Scalars['Boolean']>;
  denyCampaign?: Maybe<Campaign>;
  editAdminUserEmailNotifications?: Maybe<AdminUser>;
  editCustomRequiredDocment?: Maybe<Campaign>;
  editEmailPreferences?: Maybe<Scalars['Boolean']>;
  editInvestorRelationsEvent?: Maybe<InvestorRelationsEvent>;
  editInvestorRelationsHighlight?: Maybe<InvestorRelationsHighlight>;
  editPublicDocument?: Maybe<PublicDocument>;
  editPublicDocumentsSettings?: Maybe<Campaign>;
  editRiskEvaluation?: Maybe<Scalars['Boolean']>;
  editTestimonial?: Maybe<Testimonial>;
  editVideo?: Maybe<Scalars['Boolean']>;
  flushRedisData?: Maybe<Scalars['String']>;
  forceMarkReservationsForSPVByCampaignId: Array<Reservation>;
  freezeCampaign?: Maybe<Campaign>;
  generateCampaignStatsCSV?: Maybe<Scalars['String']>;
  generateReservationStatsCSV?: Maybe<Scalars['String']>;
  generateRiskEvaluation?: Maybe<Scalars['Boolean']>;
  generateUserStatsCSV?: Maybe<Scalars['String']>;
  getDocumentDownloadUrl?: Maybe<Scalars['String']>;
  hideAndMarkReservationsAsDeletedByCampaignId?: Maybe<Scalars['Boolean']>;
  hideReservation?: Maybe<Reservation>;
  highlightVideo?: Maybe<Scalars['Boolean']>;
  incrementCampaignViews?: Maybe<Scalars['Int']>;
  interestedCompanyNotification?: Maybe<Scalars['Boolean']>;
  markReservationsAsMissedPayment?: Maybe<Array<Maybe<Reservation>>>;
  markReservationsAsPaid?: Maybe<Array<Maybe<Reservation>>>;
  notifyAboutError?: Maybe<Scalars['String']>;
  passwordReset: ResetPasswordPayload;
  passwordResetAdmin?: Maybe<Scalars['Boolean']>;
  pdf2csv?: Maybe<Scalars['String']>;
  pendingSignDeal?: Maybe<Campaign>;
  performCampaignDocumentAction?: Maybe<CampaignDocument>;
  previewEmail?: Maybe<Scalars['Boolean']>;
  processCampaignDocument?: Maybe<CampaignDocument>;
  processCompanyCertificate?: Maybe<Company>;
  processDateRequest?: Maybe<Campaign>;
  processGFProtocol?: Maybe<Campaign>;
  processPepUser?: Maybe<Scalars['Boolean']>;
  processPostponement?: Maybe<Campaign>;
  processRejectionRequest?: Maybe<Reservation>;
  processShareholderList?: Maybe<Campaign>;
  reSendInvoice?: Maybe<Scalars['Boolean']>;
  refreshAboutUsCache: Scalars['Boolean'];
  registerEmailReminderCampaign?: Maybe<Scalars['Boolean']>;
  rejectCompanyCertificate?: Maybe<User>;
  rejectOnboarding?: Maybe<Campaign>;
  removeCompany?: Maybe<User>;
  removeCompanyOwner?: Maybe<Company>;
  removeCompanyUser?: Maybe<Company>;
  removeContributor?: Maybe<Scalars['Boolean']>;
  removeService?: Maybe<Scalars['Boolean']>;
  removeTwofactor?: Maybe<Scalars['Boolean']>;
  requestApproval?: Maybe<Campaign>;
  requestEmailReVerification?: Maybe<Scalars['Boolean']>;
  requestEmailVerification?: Maybe<Scalars['Boolean']>;
  requestPostponement?: Maybe<Campaign>;
  rerunAgendaJob?: Maybe<Scalars['Boolean']>;
  resendEmailById?: Maybe<Scalars['Boolean']>;
  reserveShares?: Maybe<Reservation>;
  resetAdminHomeStats: Scalars['Boolean'];
  resetApproval?: Maybe<Campaign>;
  resetBankId?: Maybe<Scalars['Boolean']>;
  revokeTerms?: Maybe<Scalars['Boolean']>;
  runAgendaIntervalTest?: Maybe<Scalars['String']>;
  runAgendaTest?: Maybe<Scalars['String']>;
  saveComingSoon?: Maybe<ComingSoonItem>;
  screenUserForPepAndSanctions?: Maybe<Scalars['Boolean']>;
  sendApprovalUpdate?: Maybe<Campaign>;
  sendInvoice?: Maybe<Campaign>;
  sendInvoiceShareholders?: Maybe<Campaign>;
  setAboutUsMemberOrder: Scalars['Boolean'];
  setActiveComingSoonIndex?: Maybe<Scalars['Boolean']>;
  setCampaignChecklistVisibility?: Maybe<Checklist>;
  setCampaignToDraft?: Maybe<Scalars['Boolean']>;
  setCampaignVisibility?: Maybe<Campaign>;
  setCompanyOwnerAmlComment?: Maybe<Scalars['Boolean']>;
  setEmailReminder?: Maybe<Scalars['Boolean']>;
  setGlobalConfig?: Maybe<GlobalConfig>;
  setNotifyInterval?: Maybe<User>;
  setPassword: Scalars['Boolean'];
  setPasswordAdmin: Scalars['Boolean'];
  setPushmessageInactive?: Maybe<Pushmessage>;
  setReservationFeedbackComment?: Maybe<Scalars['Boolean']>;
  setReservationFeedbackScore?: Maybe<Scalars['Boolean']>;
  setReservationTags?: Maybe<Reservation>;
  setVideoThumbnail?: Maybe<CampaignVideo>;
  setVideoVisibility?: Maybe<Scalars['Boolean']>;
  setupTwofactorGetQR?: Maybe<Scalars['String']>;
  signExpediency?: Maybe<User>;
  signRiskEvaluation?: Maybe<Scalars['Boolean']>;
  stopAgendaTests?: Maybe<Scalars['String']>;
  submitDateRequest?: Maybe<Scalars['Boolean']>;
  submitExpediency?: Maybe<Expediency>;
  submitFinalizedReservationsList?: Maybe<Campaign>;
  submitOnboarding?: Maybe<Campaign>;
  submitRejectReservation?: Maybe<Reservation>;
  testEmailTemplate?: Maybe<Scalars['Boolean']>;
  toggleCommentLike?: Maybe<Comment>;
  toggleNoCompanyOwners?: Maybe<Company>;
  togglePaymentRemindersForCampaign?: Maybe<Scalars['Boolean']>;
  transferCampaignOwner?: Maybe<SuccessResponse>;
  undoMarkReservationsAsPaid?: Maybe<Array<Maybe<Reservation>>>;
  unregisterEmailReminderCampaign?: Maybe<Scalars['Boolean']>;
  unsubscribeEmail?: Maybe<Scalars['Boolean']>;
  unsubscribeUser?: Maybe<User>;
  updateAboutUsMember: AboutUsMember;
  updateAdminUser?: Maybe<AdminUser>;
  updateApproval?: Maybe<Campaign>;
  updateApprovalSection?: Maybe<Campaign>;
  updateCampaign?: Maybe<Campaign>;
  updateCampaignAdmin?: Maybe<Campaign>;
  updateCampaignChecklist?: Maybe<Checklist>;
  updateCampaignComment?: Maybe<Comment>;
  updateCampaignDocument?: Maybe<CampaignDocument>;
  updateCampaignJSON?: Maybe<CampaignJson>;
  updateComment?: Maybe<Comment>;
  updateCommentJSON?: Maybe<CommentJson>;
  updateCommentSubscription?: Maybe<Comment>;
  updateCompanyUser?: Maybe<Company>;
  updateExpediency?: Maybe<ExpediencyResponse>;
  updateMeAdmin?: Maybe<AdminUser>;
  updateMediaMention?: Maybe<MediaMention>;
  updateOnboarding?: Maybe<Scalars['Boolean']>;
  updatePressRelease?: Maybe<PressRelease>;
  updateProfile?: Maybe<Scalars['Boolean']>;
  updateReservationJSON?: Maybe<Scalars['Boolean']>;
  updateRiskEvalScreeningComment?: Maybe<Scalars['Boolean']>;
  updateRiskEvaluation?: Maybe<Campaign>;
  updateRiskEvaluationRRH?: Maybe<Scalars['Boolean']>;
  updateSPVMarkForInvestorByReservationId?: Maybe<SpvMarkedResult>;
  updateSinglePurposeVehicleData?: Maybe<Campaign>;
  updateUserJSON?: Maybe<UserJson>;
  updateUserRoles?: Maybe<User>;
  uploadCampaignVideo?: Maybe<Campaign>;
  userCreateSignature?: Maybe<Signature>;
  verifyCampaignAccountNumber?: Maybe<Campaign>;
  verifyEmail?: Maybe<SuccessResponse>;
  visitDashboard?: Maybe<Scalars['Boolean']>;
};


export type Mutation_DangerouslyDeleteExpediencyTestsArgs = {
  userId: Scalars['ID'];
};


export type MutationAbortPublishedCampaignAndSetToDraftArgs = {
  campaignId: Scalars['ID'];
};


export type MutationAcceptTermsArgs = {
  pep?: InputMaybe<Scalars['Boolean']>;
  termsVersion?: InputMaybe<Scalars['String']>;
};


export type MutationAddAboutUsMemberArgs = {
  section: AboutUsMemberSection;
};


export type MutationAddAboutUsMembersByJsonArgs = {
  json: Scalars['String'];
  section: AboutUsMemberSection;
};


export type MutationAddAdminCommentArgs = {
  content?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['String']>;
  ref: Scalars['ID'];
};


export type MutationAddAdminUserArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationAddCampaignDocumentArgs = {
  input: CampaignDocumentInput;
};


export type MutationAddCampaignFollowersAdminArgs = {
  acceptPreorder: Scalars['Boolean'];
  campaignId?: InputMaybe<Scalars['ID']>;
  emails: Array<Scalars['String']>;
};


export type MutationAddCampaignMandateArgs = {
  campaignId: Scalars['ID'];
  input: CampaignMandateInput;
};


export type MutationAddCommentArgs = {
  campaignId: Scalars['ID'];
  input: CreateCommentInput;
};


export type MutationAddCommentToCampaignDocumentArgs = {
  content?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
};


export type MutationAddCompanyCertificateArgs = {
  date?: InputMaybe<Scalars['Date']>;
  file: FileInput;
  organizationNumber: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddCompanyOwnerArgs = {
  name: Scalars['String'];
  organizationNumber: Scalars['String'];
};


export type MutationAddCompanyToUserProfileArgs = {
  organizationNumber: Scalars['String'];
  userEmail: Scalars['String'];
};


export type MutationAddCompanyUserArgs = {
  email: Scalars['String'];
  organizationNumber: Scalars['String'];
  owner?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddContributorArgs = {
  campaignId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationAddInvestmentCompanyToProfileArgs = {
  companyId: Scalars['String'];
  countryCode: CompanyCountryCodeEnum;
};


export type MutationAddInvestmentsPageVisitorArgs = {
  campaignId: Scalars['String'];
};


export type MutationAddInvestorRelationsEventArgs = {
  input: InvestorRelationsEventInput;
};


export type MutationAddInvestorRelationsHeaderArgs = {
  input: InvestorRelationsHeaderInput;
};


export type MutationAddInvestorRelationsHighlightArgs = {
  input?: InputMaybe<InvestorRelationsHighlightInput>;
};


export type MutationAddPublicDocumentArgs = {
  input: PublicDocumentInput;
};


export type MutationAddRiskHistoryCommentArgs = {
  campaignId: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};


export type MutationAddServiceArgs = {
  serviceName: Scalars['String'];
  token: Scalars['String'];
};


export type MutationAddTestimonialArgs = {
  input?: InputMaybe<TestimonialInput>;
};


export type MutationAddVideoArgs = {
  input?: InputMaybe<VideoInput>;
};


export type MutationAmlScreenNameForRiskEvalArgs = {
  campaignId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationApproveCampaignArgs = {
  _id: Scalars['ID'];
};


export type MutationApproveCompanyCertificateArgs = {
  companyIdx?: InputMaybe<Scalars['Int']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationApproveOnboardingArgs = {
  _id: Scalars['ID'];
};


export type MutationApproveShareholdersArgs = {
  campaignId: Scalars['ID'];
};


export type MutationApproveUserForPreorderArgs = {
  campaignId: Scalars['ID'];
};


export type MutationArchiveCompanyCertificateArgs = {
  archived: Scalars['Boolean'];
  certificateID: Scalars['ID'];
  organizationNumber: Scalars['String'];
};


export type MutationAssignAdminsToCampaignArgs = {
  adminIds: Array<InputMaybe<Scalars['ID']>>;
  campaignId: Scalars['ID'];
};


export type MutationAssignAdminsToChecklistArgs = {
  adminIds: Array<InputMaybe<Scalars['ID']>>;
  checklistId: Scalars['ID'];
};


export type MutationAssignCampaignToChecklistArgs = {
  campaignId: Scalars['ID'];
  checklistId: Scalars['ID'];
};


export type MutationBlockUserLoginArgs = {
  blocked: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationBulkMarkPreorderOffersSentArgs = {
  campaignId: Scalars['ID'];
  emails: Array<Scalars['String']>;
};


export type MutationCancelAgendaJobArgs = {
  _id: Scalars['ID'];
};


export type MutationCancelCustomerAgreementSignatureProcessArgs = {
  signatureId: Scalars['ID'];
};


export type MutationCancelRejectReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationCancelReservationArgs = {
  reason?: InputMaybe<ReservationCancelReasonInput>;
  reservationId: Scalars['ID'];
};


export type MutationCancelSignatureArgs = {
  documentId: Scalars['String'];
};


export type MutationChangeEmailAddressForUserArgs = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCleanCampaignDocumentBlobNameArgs = {
  documentId: Scalars['ID'];
};


export type MutationCleanVideoBlobNameArgs = {
  videoId: Scalars['String'];
};


export type MutationCloseErrorArgs = {
  errorId?: InputMaybe<Scalars['ID']>;
};


export type MutationConfirmTwofactorQrArgs = {
  token: Scalars['String'];
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCampaignChecklistArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCustomerAgreementArgs = {
  input?: InputMaybe<CustomerAgreementInput>;
};


export type MutationCreatePushmessageArgs = {
  closeDate: Scalars['Date'];
  content: Scalars['String'];
  startDate: Scalars['Date'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAboutUsMemberArgs = {
  memberId: Scalars['ID'];
};


export type MutationDeleteAdminCommentArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteAdminUserArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCampaignDocumentArgs = {
  documentId: Scalars['ID'];
  restore?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteCampaignDocumentCommentArgs = {
  commentId: Scalars['String'];
  documentId: Scalars['ID'];
};


export type MutationDeleteCampaignVideoArgs = {
  blobName: Scalars['String'];
  campaignId: Scalars['ID'];
  videoId: Scalars['String'];
};


export type MutationDeleteComingSoonArgs = {
  campaignId: Scalars['ID'];
};


export type MutationDeleteCommentArgs = {
  _id: Scalars['ID'];
};


export type MutationDeleteCompanyCertificateArgs = {
  certificateID: Scalars['ID'];
  organizationNumber: Scalars['String'];
};


export type MutationDeleteCustomRequiredDocumentArgs = {
  campaignId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationDeleteInvestorRelationsEventArgs = {
  eventId: Scalars['ID'];
};


export type MutationDeleteInvestorRelationsHighlightArgs = {
  highlightId: Scalars['ID'];
};


export type MutationDeleteMediaMentionArgs = {
  mediaMentionId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeletePressReleaseArgs = {
  pressReleaseId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeletePublicDocumentArgs = {
  publicDocumentId: Scalars['ID'];
};


export type MutationDeleteRedisItemArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteReservationAdminArgs = {
  _id: Scalars['ID'];
  sendEmails?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
  signedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteRiskEvaluationRrhArgs = {
  campaignId: Scalars['ID'];
  fieldId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteRiskHistoryCommentArgs = {
  campaignId: Scalars['ID'];
  commentId: Scalars['ID'];
};


export type MutationDeleteSpamReportArgs = {
  userId: Scalars['ID'];
};


export type MutationDeleteTestimonialArgs = {
  testimonialId: Scalars['ID'];
};


export type MutationDeleteVideoArgs = {
  videoId: Scalars['ID'];
};


export type MutationDenyCampaignArgs = {
  _id: Scalars['ID'];
};


export type MutationEditAdminUserEmailNotificationsArgs = {
  adminUserId: Scalars['ID'];
  input: EmailSubscriptionsInput;
};


export type MutationEditCustomRequiredDocmentArgs = {
  campaignId: Scalars['ID'];
  input: CustomRequiredDocumentInput;
};


export type MutationEditEmailPreferencesArgs = {
  input?: InputMaybe<EmailPreferencesInput>;
};


export type MutationEditInvestorRelationsEventArgs = {
  eventId: Scalars['ID'];
  input: EditInvestorRelationsEventInput;
};


export type MutationEditInvestorRelationsHighlightArgs = {
  highlightId: Scalars['ID'];
  input?: InputMaybe<InvestorRelationsHighlightInput>;
};


export type MutationEditPublicDocumentArgs = {
  input: PublicDocumentInput;
  publicDocumentId: Scalars['ID'];
};


export type MutationEditPublicDocumentsSettingsArgs = {
  campaignId: Scalars['ID'];
  input: Array<InputMaybe<DocumentLockInput>>;
};


export type MutationEditRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
  checked?: InputMaybe<Scalars['Boolean']>;
  fieldId: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};


export type MutationEditTestimonialArgs = {
  input?: InputMaybe<TestimonialInput>;
  testimonialId: Scalars['ID'];
};


export type MutationEditVideoArgs = {
  input: VideoInput;
  videoId: Scalars['ID'];
};


export type MutationForceMarkReservationsForSpvByCampaignIdArgs = {
  campaignId: Scalars['ID'];
};


export type MutationFreezeCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationGenerateRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};


export type MutationGetDocumentDownloadUrlArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
};


export type MutationHideAndMarkReservationsAsDeletedByCampaignIdArgs = {
  campaignId: Scalars['ID'];
};


export type MutationHideReservationArgs = {
  reservationId: Scalars['ID'];
};


export type MutationHighlightVideoArgs = {
  section: VideoSection;
  videoId: Scalars['ID'];
};


export type MutationIncrementCampaignViewsArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type MutationInterestedCompanyNotificationArgs = {
  companyName: Scalars['String'];
  country: InterestedCompanyCountryEnum;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};


export type MutationMarkReservationsAsMissedPaymentArgs = {
  campaignId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};


export type MutationMarkReservationsAsPaidArgs = {
  campaignId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};


export type MutationNotifyAboutErrorArgs = {
  error?: InputMaybe<ErrorInput>;
};


export type MutationPasswordResetArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationPasswordResetAdminArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationPdf2csvArgs = {
  buffer?: InputMaybe<Scalars['String']>;
};


export type MutationPendingSignDealArgs = {
  _id: Scalars['ID'];
};


export type MutationPerformCampaignDocumentActionArgs = {
  action: CampaignDocumentActionEnum;
  documentId: Scalars['ID'];
};


export type MutationPreviewEmailArgs = {
  _id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
};


export type MutationProcessCampaignDocumentArgs = {
  documentId: Scalars['ID'];
  input: ProcessCampaignDocumentInput;
};


export type MutationProcessCompanyCertificateArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  certificateID: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  organizationNumber: Scalars['String'];
};


export type MutationProcessDateRequestArgs = {
  campaignId: Scalars['ID'];
  input: ProcessDateRequestInput;
};


export type MutationProcessGfProtocolArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  campaignId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  fileId: Scalars['ID'];
};


export type MutationProcessPepUserArgs = {
  approved: Scalars['Boolean'];
  comment?: InputMaybe<Scalars['String']>;
  pep: Scalars['Boolean'];
  sanctions: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type MutationProcessPostponementArgs = {
  approved: Scalars['Boolean'];
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type MutationProcessRejectionRequestArgs = {
  approved: Scalars['Boolean'];
  reservationId: Scalars['ID'];
};


export type MutationProcessShareholderListArgs = {
  campaignId: Scalars['ID'];
  sendEmail: Scalars['Boolean'];
};


export type MutationReSendInvoiceArgs = {
  reservationId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterEmailReminderCampaignArgs = {
  acceptPreorderOffer?: InputMaybe<Scalars['Boolean']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
};


export type MutationRejectCompanyCertificateArgs = {
  companyIdx?: InputMaybe<Scalars['Int']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationRejectOnboardingArgs = {
  _id: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveCompanyArgs = {
  organizationNumber: Scalars['String'];
};


export type MutationRemoveCompanyOwnerArgs = {
  _id: Scalars['ID'];
  organizationNumber: Scalars['String'];
};


export type MutationRemoveCompanyUserArgs = {
  email: Scalars['String'];
  organizationNumber: Scalars['String'];
};


export type MutationRemoveContributorArgs = {
  campaignId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveServiceArgs = {
  serviceName: Scalars['String'];
};


export type MutationRemoveTwofactorArgs = {
  _id: Scalars['ID'];
};


export type MutationRequestApprovalArgs = {
  _id: Scalars['ID'];
};


export type MutationRequestPostponementArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
};


export type MutationRerunAgendaJobArgs = {
  _id: Scalars['ID'];
};


export type MutationResendEmailByIdArgs = {
  emailSentId: Scalars['ID'];
};


export type MutationReserveSharesArgs = {
  campaignId: Scalars['ID'];
  input: ReserveSharesInput;
};


export type MutationResetAdminHomeStatsArgs = {
  key?: InputMaybe<Scalars['String']>;
};


export type MutationResetApprovalArgs = {
  _id: Scalars['ID'];
};


export type MutationRunAgendaIntervalTestArgs = {
  seconds?: InputMaybe<Scalars['Float']>;
};


export type MutationRunAgendaTestArgs = {
  seconds?: InputMaybe<Scalars['Float']>;
};


export type MutationSaveComingSoonArgs = {
  input: ComingSoonItemInput;
};


export type MutationScreenUserForPepAndSanctionsArgs = {
  userId: Scalars['ID'];
};


export type MutationSendApprovalUpdateArgs = {
  _id: Scalars['ID'];
};


export type MutationSendInvoiceArgs = {
  _id: Scalars['ID'];
};


export type MutationSendInvoiceShareholdersArgs = {
  _id: Scalars['ID'];
  override?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetAboutUsMemberOrderArgs = {
  memberIds: Array<Scalars['ID']>;
  section: AboutUsMemberSection;
};


export type MutationSetActiveComingSoonIndexArgs = {
  list: Array<Scalars['ID']>;
};


export type MutationSetCampaignChecklistVisibilityArgs = {
  checklistId: Scalars['ID'];
  toggle: Scalars['Boolean'];
};


export type MutationSetCampaignToDraftArgs = {
  campaignId: Scalars['ID'];
};


export type MutationSetCampaignVisibilityArgs = {
  campaignId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};


export type MutationSetCompanyOwnerAmlCommentArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type MutationSetEmailReminderArgs = {
  email: Scalars['String'];
};


export type MutationSetGlobalConfigArgs = {
  input: GlobalConfigInput;
};


export type MutationSetNotifyIntervalArgs = {
  interval: Scalars['String'];
};


export type MutationSetPasswordArgs = {
  password: Scalars['String'];
  resettoken: Scalars['String'];
};


export type MutationSetPasswordAdminArgs = {
  password: Scalars['String'];
  resettoken: Scalars['String'];
};


export type MutationSetPushmessageInactiveArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};


export type MutationSetReservationFeedbackCommentArgs = {
  comment?: InputMaybe<Scalars['String']>;
  reservationID: Scalars['ID'];
};


export type MutationSetReservationFeedbackScoreArgs = {
  reservationID: Scalars['ID'];
  score?: InputMaybe<Scalars['Int']>;
};


export type MutationSetReservationTagsArgs = {
  reservationID: Scalars['ID'];
  tags: Array<InputMaybe<Scalars['String']>>;
};


export type MutationSetVideoThumbnailArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  videoId: Scalars['String'];
};


export type MutationSetVideoVisibilityArgs = {
  videoId: Scalars['ID'];
  visible: Scalars['Boolean'];
};


export type MutationSignExpediencyArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  approved?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSignRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  risk?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitDateRequestArgs = {
  campaignId: Scalars['ID'];
  dates: DateRequestInput;
};


export type MutationSubmitExpediencyArgs = {
  input?: InputMaybe<ExpediencyInput>;
};


export type MutationSubmitFinalizedReservationsListArgs = {
  campaignId: Scalars['ID'];
};


export type MutationSubmitOnboardingArgs = {
  _id: Scalars['ID'];
};


export type MutationSubmitRejectReservationArgs = {
  input: RejectReservationInput;
  reservationId: Scalars['ID'];
};


export type MutationTestEmailTemplateArgs = {
  input: TestEmailInput;
};


export type MutationToggleCommentLikeArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
};


export type MutationToggleNoCompanyOwnersArgs = {
  hasNoOwners: Scalars['Boolean'];
  organizationNumber: Scalars['String'];
};


export type MutationTogglePaymentRemindersForCampaignArgs = {
  campaignId: Scalars['ID'];
  disabled: Scalars['Boolean'];
};


export type MutationTransferCampaignOwnerArgs = {
  campaignId: Scalars['ID'];
  newOwnerId: Scalars['ID'];
};


export type MutationUndoMarkReservationsAsPaidArgs = {
  campaignId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};


export type MutationUnregisterEmailReminderCampaignArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type MutationUnsubscribeEmailArgs = {
  _id: Scalars['ID'];
};


export type MutationUnsubscribeUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateAboutUsMemberArgs = {
  input: AboutUsMemberInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateAdminUserArgs = {
  _id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<AdminUserRole>>>;
};


export type MutationUpdateApprovalArgs = {
  _id: Scalars['ID'];
  updatedSections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationUpdateApprovalSectionArgs = {
  _id: Scalars['ID'];
  section: PublishApprovalSectionInput;
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['ID'];
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignAdminArgs = {
  campaignId: Scalars['ID'];
  input: CampaignAdminInput;
};


export type MutationUpdateCampaignChecklistArgs = {
  checklistId: Scalars['ID'];
  input: ChecklistInput;
};


export type MutationUpdateCampaignCommentArgs = {
  commentId: Scalars['ID'];
  input: UpdateCampaignCommentInput;
};


export type MutationUpdateCampaignDocumentArgs = {
  documentId: Scalars['ID'];
  input: UpdateCampaignDocumentInput;
};


export type MutationUpdateCampaignJsonArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  json?: InputMaybe<Scalars['String']>;
  whitelistIgnoredFields?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateCommentArgs = {
  _id: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCommentJsonArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  json?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCommentSubscriptionArgs = {
  commentID?: InputMaybe<Scalars['ID']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCompanyUserArgs = {
  addedBy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  organizationNumber: Scalars['String'];
  owner?: InputMaybe<Scalars['Boolean']>;
  removedAt?: InputMaybe<Scalars['Date']>;
  removedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateExpediencyArgs = {
  result?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateMeAdminArgs = {
  input: AdminUserInput;
};


export type MutationUpdateMediaMentionArgs = {
  input: MediaMentionInput;
};


export type MutationUpdateOnboardingArgs = {
  _id: Scalars['ID'];
  onboarding: OnboardingInput;
};


export type MutationUpdatePressReleaseArgs = {
  input: PressReleaseInput;
};


export type MutationUpdateProfileArgs = {
  input: ProfileUpdateInput;
};


export type MutationUpdateReservationJsonArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  json?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateRiskEvalScreeningCommentArgs = {
  campaignId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  riskEvaluationScreeningID: Scalars['ID'];
};


export type MutationUpdateRiskEvaluationArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  riskEvaluation?: InputMaybe<RiskEvaluationItemInput>;
};


export type MutationUpdateRiskEvaluationRrhArgs = {
  campaignId: Scalars['ID'];
  data?: InputMaybe<RiskEvaluationRrhItemInput>;
  version?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSpvMarkForInvestorByReservationIdArgs = {
  reservationId: Scalars['ID'];
  taggedForSinglePurposeVehicle: Scalars['Boolean'];
};


export type MutationUpdateSinglePurposeVehicleDataArgs = {
  campaignId: Scalars['ID'];
  input: SinglePurposeVehicleInput;
};


export type MutationUpdateUserJsonArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  json?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserRolesArgs = {
  isEntrepreneur?: InputMaybe<Scalars['Boolean']>;
  isInvestor?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUploadCampaignVideoArgs = {
  blobName: Scalars['String'];
  campaignId: Scalars['ID'];
  fileName: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUserCreateSignatureArgs = {
  input: CreateSignatureInput;
};


export type MutationVerifyCampaignAccountNumberArgs = {
  accountNumber: Scalars['String'];
  campaignId: Scalars['ID'];
};


export type MutationVerifyEmailArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type MutationVisitDashboardArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export enum Nationality {
  DANISH = 'DANISH',
  NORWEGIAN = 'NORWEGIAN',
  SWEDISH = 'SWEDISH'
}

export type NotifyIntervalStats = {
  __typename?: 'NotifyIntervalStats';
  all: Array<Maybe<Scalars['Date']>>;
  fromDate?: Maybe<Scalars['Date']>;
  monthly: Array<Maybe<Scalars['Date']>>;
  never: Array<Maybe<Scalars['Date']>>;
  toDate?: Maybe<Scalars['Date']>;
  total?: Maybe<Scalars['Int']>;
  weekly: Array<Maybe<Scalars['Date']>>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  approved?: Maybe<Scalars['Boolean']>;
  assumedValue?: Maybe<Scalars['Float']>;
  ceoName?: Maybe<Scalars['String']>;
  certificate?: Maybe<File>;
  chairmanEmail?: Maybe<Scalars['String']>;
  chairmanName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  handledBy?: Maybe<Scalars['String']>;
  handledDate?: Maybe<Scalars['Date']>;
  investmentAmount?: Maybe<Scalars['Float']>;
  isAS?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notOnStockMarked?: Maybe<Scalars['Boolean']>;
  organizationNumber?: Maybe<Scalars['String']>;
  recentEmissions?: Maybe<Array<Maybe<RecentEmission>>>;
  recentEmissionsAmount?: Maybe<Scalars['Float']>;
  rejected?: Maybe<Scalars['Boolean']>;
  structure?: Maybe<Array<Maybe<AssociatedCompany>>>;
  submitDate?: Maybe<Scalars['Date']>;
  timeframe?: Maybe<Scalars['String']>;
};

export type OnboardingInput = {
  assumedValue?: InputMaybe<Scalars['Float']>;
  ceoName?: InputMaybe<Scalars['String']>;
  certificate?: InputMaybe<FileInput>;
  chairmanEmail?: InputMaybe<Scalars['String']>;
  chairmanName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  investmentAmount?: InputMaybe<Scalars['Float']>;
  isAS?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notOnStockMarked?: InputMaybe<Scalars['Boolean']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
  recentEmissions?: InputMaybe<Array<InputMaybe<RecentEmissionInput>>>;
  structure?: InputMaybe<Array<InputMaybe<AssociatedCompanyInput>>>;
  timeframe?: InputMaybe<Scalars['String']>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  bio?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<File>;
  role?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type OrganizationMemberInput = {
  bio?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<FileInput>;
  role?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type Owner = {
  __typename?: 'Owner';
  name: Scalars['String'];
  shares: Scalars['Int'];
  userIds?: Maybe<Array<Scalars['ID']>>;
};

export type OwnerInput = {
  name: Scalars['String'];
  shares: Scalars['Int'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PageQueryInput = {
  filters?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type PaginatedFinishedCampaignCards = {
  __typename?: 'PaginatedFinishedCampaignCards';
  index?: Maybe<Scalars['Int']>;
  list: Array<Maybe<CampaignCard>>;
  pageSize?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortfield?: InputMaybe<Scalars['String']>;
};

export type PaginationOutput = {
  __typename?: 'PaginationOutput';
  asc?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  sortfield?: Maybe<Scalars['String']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  accountNumber?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  duedate?: Maybe<Scalars['Date']>;
  organizationNumber?: Maybe<Scalars['String']>;
  pricePerShare?: Maybe<Scalars['Float']>;
  refcode?: Maybe<Scalars['String']>;
  vpsAndAccountToggled?: Maybe<Scalars['Boolean']>;
};

export type PepData = {
  __typename?: 'PepData';
  approved?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  handledAt?: Maybe<Scalars['Date']>;
  handledBy?: Maybe<Scalars['String']>;
  pepWarningSentAt?: Maybe<Scalars['Date']>;
};

export type PepHistoryItem = {
  __typename?: 'PepHistoryItem';
  approved?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  handledAt?: Maybe<Scalars['Date']>;
  handledBy?: Maybe<Scalars['String']>;
  pep?: Maybe<Scalars['Boolean']>;
  sanctions?: Maybe<Scalars['Boolean']>;
};

export type PreorderSummary = {
  __typename?: 'PreorderSummary';
  count?: Maybe<Scalars['Int']>;
  list: Array<ReservationsListItem>;
  shares?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
};

export type PressRelease = {
  __typename?: 'PressRelease';
  _id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
};

export type PressReleaseInput = {
  _id?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProcessCampaignDocumentInput = {
  comment?: InputMaybe<Scalars['String']>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  status: CampaignDocumentStatusEnum;
};

export type ProcessDateRequestInput = {
  approved: Scalars['Boolean'];
  closeDate?: InputMaybe<Scalars['Date']>;
  comment?: InputMaybe<Scalars['String']>;
  publishDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type ProfileAddress = {
  __typename?: 'ProfileAddress';
  countryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  postalTown?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type ProfileAddressInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalTown?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ProfileUpdateInput = {
  addressFields?: InputMaybe<ProfileAddressInput>;
  birthdate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ignoreBankIdDuplicates?: InputMaybe<Scalars['Boolean']>;
  isEntrepreneur?: InputMaybe<Scalars['Boolean']>;
  isInvestor?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notifyInterval?: InputMaybe<Scalars['String']>;
  pendingEmailChange?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receiveNewsletter?: InputMaybe<Scalars['Boolean']>;
  termsVersion?: InputMaybe<Scalars['String']>;
};

export type ProgressItem = {
  __typename?: 'ProgressItem';
  createdAt?: Maybe<Scalars['Date']>;
  current?: Maybe<Scalars['Int']>;
  done?: Maybe<Scalars['Boolean']>;
  finishedAt?: Maybe<Scalars['Date']>;
  max?: Maybe<Scalars['Int']>;
};

export type PublicCampaignDocument = {
  __typename?: 'PublicCampaignDocument';
  custom?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  file?: Maybe<File>;
  hidden?: Maybe<Scalars['Boolean']>;
  isValid?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  originalTitle?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type PublicDocument = {
  __typename?: 'PublicDocument';
  _id: Scalars['ID'];
  blobName?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['Date']>;
  section?: Maybe<PublicDocumentSection>;
  title?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type PublicDocumentInput = {
  blobName?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  publishDate?: InputMaybe<Scalars['Date']>;
  section: PublicDocumentSection;
  title?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum PublicDocumentSection {
  FIREPORT = 'FIREPORT',
  QUARTERLYREPORT = 'QUARTERLYREPORT'
}

export type PublishApprovalField = {
  __typename?: 'PublishApprovalField';
  approved?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  denied?: Maybe<Scalars['Boolean']>;
  field?: Maybe<Scalars['String']>;
};

export type PublishApprovalFieldsInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  denied?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<Scalars['String']>;
};

export type PublishApprovalItem = {
  __typename?: 'PublishApprovalItem';
  approved?: Maybe<Scalars['Boolean']>;
  approvedDate?: Maybe<Scalars['Date']>;
  denied?: Maybe<Scalars['Boolean']>;
  requested?: Maybe<Scalars['Boolean']>;
  requestedDate?: Maybe<Scalars['Date']>;
  responses?: Maybe<Array<Maybe<PublishApprovalResponse>>>;
  updated?: Maybe<Scalars['Boolean']>;
  updates?: Maybe<Array<Maybe<PublishApprovalUpdated>>>;
};

export type PublishApprovalResponse = {
  __typename?: 'PublishApprovalResponse';
  comment?: Maybe<Scalars['String']>;
  deniedDate?: Maybe<Scalars['Date']>;
  sections?: Maybe<Array<Maybe<PublishApprovalSection>>>;
};

export type PublishApprovalSection = {
  __typename?: 'PublishApprovalSection';
  comment?: Maybe<Scalars['String']>;
  denied?: Maybe<Scalars['Boolean']>;
  done?: Maybe<Scalars['Boolean']>;
  fields?: Maybe<Array<Maybe<PublishApprovalField>>>;
  section?: Maybe<Scalars['String']>;
};

export type PublishApprovalSectionInput = {
  comment?: InputMaybe<Scalars['String']>;
  denied?: InputMaybe<Scalars['Boolean']>;
  done?: InputMaybe<Scalars['Boolean']>;
  fields?: InputMaybe<Array<InputMaybe<PublishApprovalFieldsInput>>>;
  section?: InputMaybe<Scalars['String']>;
};

export type PublishApprovalUpdated = {
  __typename?: 'PublishApprovalUpdated';
  updatedDate?: Maybe<Scalars['Date']>;
  updatedSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Pushmessage = {
  __typename?: 'Pushmessage';
  _id?: Maybe<Scalars['ID']>;
  closeDate?: Maybe<Scalars['Date']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  expireAt?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Query = {
  __typename?: 'Query';
  Campaign?: Maybe<Campaign>;
  activeCampaignCards: Array<Maybe<CampaignCard>>;
  allComingSoon?: Maybe<Array<Maybe<ComingSoonItem>>>;
  allCommentsByCampaignId: Array<Maybe<Comment>>;
  allCompanies?: Maybe<Array<Maybe<Company>>>;
  allCompanyApproved?: Maybe<Array<Maybe<Company>>>;
  allCompanyCertificatesNeedsApproval?: Maybe<Array<Maybe<Company>>>;
  allCompanyRejected?: Maybe<Array<Maybe<Company>>>;
  allCompanyUncertified?: Maybe<Array<Maybe<Company>>>;
  allOnboarding?: Maybe<Array<Maybe<Campaign>>>;
  campaignCardBySlugOrId?: Maybe<CampaignCard>;
  campaignJSON?: Maybe<CampaignJson>;
  campaignsInDraft?: Maybe<Array<Maybe<Campaign>>>;
  campaignsMetadata: Array<Maybe<Campaign>>;
  campaignsPrePublished?: Maybe<Array<Maybe<Campaign>>>;
  commentJSON?: Maybe<Scalars['String']>;
  currentUserCount: Scalars['Int'];
  emailAddressInUse?: Maybe<Scalars['Boolean']>;
  existingCampaignCheck?: Maybe<CampaignCheckResponse>;
  fetchAMLhits?: Maybe<AmlResponse>;
  fetchAcceptsPreordersList?: Maybe<Array<Maybe<Scalars['String']>>>;
  fetchAdminComments?: Maybe<Array<Maybe<AdminComment>>>;
  fetchAllAgendaJobs?: Maybe<Array<Maybe<AgendaJob>>>;
  fetchCampaignChecklists?: Maybe<Array<Maybe<Checklist>>>;
  fetchCampaignEventLogs?: Maybe<Array<Maybe<EventLog>>>;
  fetchChecklist?: Maybe<Checklist>;
  fetchComingSoonItem?: Maybe<ComingSoonItem>;
  fetchEmailPreferences?: Maybe<EmailPreferences>;
  fetchErrors?: Maybe<Array<Maybe<AdminError>>>;
  fetchEventLogKeys: Array<Maybe<Scalars['String']>>;
  fetchEventLogs?: Maybe<EventLogQueryResponse>;
  fetchExpediencyStats?: Maybe<ExpediencyStats>;
  fetchExpediencyTestById?: Maybe<Expediency>;
  fetchFinishedAgendaJobs?: Maybe<Array<Maybe<AgendaJob>>>;
  fetchRecurringAgendaJobs?: Maybe<Array<Maybe<AgendaJob>>>;
  fetchReservationFeedback?: Maybe<FeedbackResult>;
  fetchReservationTags?: Maybe<Array<Maybe<ReservationTag>>>;
  fetchSigneeDataForCampaign?: Maybe<CampaignSigneeData>;
  fetchUpcomingAgendaJobs?: Maybe<Array<Maybe<AgendaJob>>>;
  fetchUserActivity?: Maybe<UserActivityStats>;
  finishedCampaignCards: PaginatedFinishedCampaignCards;
  finishedCampaigns: CardRequestResult;
  getAboutUsMembers: AllAboutUsMembers;
  getActiveInvestorRelationsHeader?: Maybe<InvestorRelationsHeader>;
  getAdminUser?: Maybe<AdminUser>;
  getAdminUsers?: Maybe<Array<Maybe<AdminUser>>>;
  getAllCommentsForCampaignAdmin: Array<Maybe<Comment>>;
  getAllDocumentsForCampaignAsArchive?: Maybe<Scalars['String']>;
  getAllEmailNotificationTypes?: Maybe<Array<Maybe<EmailSubscriptionType>>>;
  getAllEmailTemplates?: Maybe<Array<Maybe<EmailTemplate>>>;
  getAllEntrepreneurTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  getAllFrontPageTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  getAllInvestorRelationEvents?: Maybe<Array<Maybe<InvestorRelationsEvent>>>;
  getAllInvestorRelationsHighlights?: Maybe<Array<Maybe<InvestorRelationsHighlight>>>;
  getAllInvestorRelationsHiglightsAdmin?: Maybe<InvestorRelationsHighlightPage>;
  getAllLandingPageEntrepreneurTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  getAllMediaMentions: Array<Maybe<MediaMention>>;
  getAllPressReleases: Array<Maybe<PressRelease>>;
  getAllPublicDocuments?: Maybe<Array<Maybe<PublicDocument>>>;
  getAllPublicDocumentsBySection?: Maybe<Array<Maybe<PublicDocument>>>;
  getAllPushmessages: Array<Maybe<Pushmessage>>;
  getAllUsers?: Maybe<Array<Maybe<User>>>;
  getAllVideosBySection?: Maybe<Array<Maybe<Video>>>;
  getApprovalCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getAttentionRequiredCampaigns: Array<Maybe<Campaign>>;
  getBasicReservationsByCampaign: Array<Maybe<BasicReservation>>;
  getBlobUploadSas?: Maybe<Scalars['String']>;
  getCampaign?: Maybe<Campaign>;
  getCampaignDocumentCategories?: Maybe<Array<Maybe<CampaignDocumentCategory>>>;
  getCampaignDocuments?: Maybe<Array<Maybe<CampaignDocument>>>;
  getCampaignOptionsList?: Maybe<Array<Maybe<CampaignConfigOption>>>;
  getCampaignUsers?: Maybe<Array<Maybe<User>>>;
  getCampaignsByOrgNr?: Maybe<Array<Maybe<Campaign>>>;
  getChecklistsWithoutCampaigns?: Maybe<Array<Maybe<ChecklistSimple>>>;
  getComment?: Maybe<Comment>;
  getCompany?: Maybe<Company>;
  getCompanyOwnerAmlComment?: Maybe<Scalars['String']>;
  getCompanyOwnerScreenings?: Maybe<Array<Maybe<AmlScreening>>>;
  getCompanyOwners?: Maybe<Array<Maybe<CompanyOwner>>>;
  getEmailSent?: Maybe<EmailSent>;
  getEmailSubscribersCount?: Maybe<Scalars['Int']>;
  getEntrepreneurTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  getFollowersForCampaign?: Maybe<FollowersForCampaignReponse>;
  getFrontPageTestimonial?: Maybe<Testimonial>;
  getGlobalConfigs?: Maybe<Array<Maybe<GlobalConfig>>>;
  getHomeStatsAdmin?: Maybe<HomeStatsResponse>;
  getInvestorRelationsHeaders: Array<Maybe<InvestorRelationsHeader>>;
  getLandingPageEntrepreneurTestimonial?: Maybe<Testimonial>;
  getMediaMention?: Maybe<MediaMention>;
  getMyCampaignChecklists?: Maybe<Array<Maybe<Checklist>>>;
  getMyReservation?: Maybe<Reservation>;
  getNotifyIntervalLists?: Maybe<IntervalLists>;
  getNotifyIntervalStats?: Maybe<NotifyIntervalStats>;
  getPageOfAdminUsers?: Maybe<AdminUserPage>;
  getPageOfCampaignReservations?: Maybe<ReservationPage>;
  getPageOfCampaigns?: Maybe<CampaignPage>;
  getPageOfComments?: Maybe<CommentPage>;
  getPageOfEmailsSent?: Maybe<EmailsSentPage>;
  getPageOfReservationsAdmin: ReservationPage;
  getPageOfUsers?: Maybe<UserPage>;
  getPressRelease?: Maybe<PressRelease>;
  getPreviousInvestorRelationsEvents?: Maybe<Array<Maybe<InvestorRelationsEvent>>>;
  getPublicDocument?: Maybe<PublicDocument>;
  getPublicDocumentsBySection?: Maybe<Array<Maybe<PublicDocument>>>;
  getPushmessages: Array<Maybe<Pushmessage>>;
  getRedisData?: Maybe<RedisDataResponse>;
  getRequiredDocumentsForCampaign: Array<Maybe<RequiredCampaignDocument>>;
  getReservation?: Maybe<Reservation>;
  getReservationAdmin?: Maybe<Reservation>;
  getReservationsListForCampaign?: Maybe<Array<Maybe<Reservation>>>;
  getReservationsSummaryForCampaign?: Maybe<ReservationsSummary>;
  getRiskEvaluation?: Maybe<RiskEvaluationData>;
  getScreening?: Maybe<AmlScreening>;
  getServerTime: Scalars['Date'];
  getSignature?: Maybe<Signature>;
  getSignedRiskEvaluation: SignedEvaluation;
  getSlugForNewestCampaign?: Maybe<Scalars['String']>;
  getTerms?: Maybe<Terms>;
  getTermsCurrentVersion?: Maybe<Scalars['String']>;
  getUser?: Maybe<User>;
  getUserPermissions?: Maybe<Scalars['String']>;
  getUserScreenings?: Maybe<Array<Maybe<AmlScreening>>>;
  getUsersByName?: Maybe<Array<Maybe<User>>>;
  getUsersNewsletter?: Maybe<Array<Maybe<UserEmailData>>>;
  getUsersNotifyIntervals?: Maybe<UsersNotifyStats>;
  getVideosBySection?: Maybe<Array<Maybe<Video>>>;
  getVisibleInvestorRelationsEvents?: Maybe<InvestorRelationsEventPage>;
  hasOpenCampaigns?: Maybe<Scalars['Boolean']>;
  isSpecialFrontPageEnabled: Scalars['Boolean'];
  isTermsLatestVersion?: Maybe<Scalars['Boolean']>;
  lastPostedCommentByCampaignId?: Maybe<Comment>;
  latestComments: Array<Comment>;
  latestRiskEvaluationVersion?: Maybe<Scalars['String']>;
  me?: Maybe<User>;
  meAdmin?: Maybe<AdminUser>;
  myAssociatedReservations: Array<ReservationByAssociation>;
  myCampaignCardById?: Maybe<CampaignCard>;
  myCampaigns: Array<Maybe<Campaign>>;
  myReservations: Array<Maybe<Reservation>>;
  myServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  ongoingCampaignsAdmin: Array<Maybe<Campaign>>;
  publishedCampaignsCount?: Maybe<Scalars['Int']>;
  reducedCampaignDataForCampaignCard?: Maybe<Campaign>;
  reservationJSON?: Maybe<Scalars['String']>;
  searchForInvestmentCompanies: CompanySearchResult;
  upcomingCampaignsAdmin: Array<Maybe<Campaign>>;
  userExpediencyTests: Array<Maybe<Expediency>>;
  userJSON?: Maybe<UserJson>;
  userNeedsToSign?: Maybe<Scalars['Boolean']>;
  userWithServiceExists?: Maybe<UserWithServiceExistsPayload>;
  usersWithCompanyInProfile: Array<User>;
  visitorSettings?: Maybe<VisitorSettings>;
};


export type QueryCampaignArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryAllComingSoonArgs = {
  admin?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllCommentsByCampaignIdArgs = {
  _id: Scalars['ID'];
};


export type QueryCampaignCardBySlugOrIdArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignJsonArgs = {
  _id: Scalars['ID'];
  whitelistIgnoredFields?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryCampaignsPrePublishedArgs = {
  noChecklist?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommentJsonArgs = {
  _id: Scalars['ID'];
};


export type QueryEmailAddressInUseArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryExistingCampaignCheckArgs = {
  organizationNumber: Scalars['String'];
};


export type QueryFetchAcceptsPreordersListArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryFetchAdminCommentsArgs = {
  ref: Scalars['ID'];
};


export type QueryFetchCampaignEventLogsArgs = {
  campaignId: Scalars['ID'];
};


export type QueryFetchChecklistArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  checklistId?: InputMaybe<Scalars['ID']>;
};


export type QueryFetchComingSoonItemArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryFetchEmailPreferencesArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryFetchErrorsArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFetchEventLogsArgs = {
  input: EventLogQueryInput;
};


export type QueryFetchExpediencyTestByIdArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};


export type QueryFetchSigneeDataForCampaignArgs = {
  campaignId: Scalars['ID'];
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryFetchUserActivityArgs = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};


export type QueryFinishedCampaignCardsArgs = {
  index?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryFinishedCampaignsArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAdminUserArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
};


export type QueryGetAdminUsersArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAllCommentsForCampaignAdminArgs = {
  campaignId: Scalars['ID'];
};


export type QueryGetAllDocumentsForCampaignAsArchiveArgs = {
  campaignId: Scalars['ID'];
};


export type QueryGetAllInvestorRelationsHiglightsAdminArgs = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAllPublicDocumentsBySectionArgs = {
  section: PublicDocumentSection;
};


export type QueryGetAllVideosBySectionArgs = {
  section: VideoSection;
};


export type QueryGetBasicReservationsByCampaignArgs = {
  _id: Scalars['ID'];
};


export type QueryGetBlobUploadSasArgs = {
  blobName: Scalars['String'];
  containerName: BlobContainer;
};


export type QueryGetCampaignArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetCampaignDocumentCategoriesArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCampaignDocumentsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCampaignUsersArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCampaignsByOrgNrArgs = {
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetCommentArgs = {
  _id: Scalars['ID'];
};


export type QueryGetCompanyArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompanyOwnerAmlCommentArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompanyOwnerScreeningsArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompanyOwnersArgs = {
  organizationNumber?: InputMaybe<Scalars['String']>;
};


export type QueryGetEmailSentArgs = {
  _id: Scalars['ID'];
};


export type QueryGetFollowersForCampaignArgs = {
  campaignId: Scalars['ID'];
  options?: InputMaybe<FollowersForCampaignInput>;
};


export type QueryGetMediaMentionArgs = {
  mediaMentionId: Scalars['ID'];
};


export type QueryGetMyReservationArgs = {
  reservationId: Scalars['ID'];
};


export type QueryGetNotifyIntervalStatsArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  toDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetPageOfAdminUsersArgs = {
  input?: InputMaybe<PageQueryInput>;
};


export type QueryGetPageOfCampaignReservationsArgs = {
  campaign?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  paymentState?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPageOfCampaignsArgs = {
  assignedOnly?: InputMaybe<Scalars['Boolean']>;
  input?: InputMaybe<PageQueryInput>;
};


export type QueryGetPageOfCommentsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPageOfEmailsSentArgs = {
  input: PageQueryInput;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPageOfReservationsAdminArgs = {
  input?: InputMaybe<PageQueryInput>;
};


export type QueryGetPageOfUsersArgs = {
  input?: InputMaybe<PageQueryInput>;
};


export type QueryGetPressReleaseArgs = {
  pressReleaseId: Scalars['ID'];
};


export type QueryGetPublicDocumentArgs = {
  publicDocumentId: Scalars['ID'];
};


export type QueryGetPublicDocumentsBySectionArgs = {
  section: PublicDocumentSection;
};


export type QueryGetRequiredDocumentsForCampaignArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetReservationArgs = {
  _id: Scalars['ID'];
};


export type QueryGetReservationAdminArgs = {
  reservationId: Scalars['ID'];
};


export type QueryGetReservationsListForCampaignArgs = {
  campaignId: Scalars['ID'];
  includeAll?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetReservationsSummaryForCampaignArgs = {
  campaignId: Scalars['ID'];
  hideRejected?: InputMaybe<Scalars['Boolean']>;
  includePreorders?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
};


export type QueryGetScreeningArgs = {
  _id: Scalars['ID'];
};


export type QueryGetSignatureArgs = {
  input: GetSignatureInput;
};


export type QueryGetSignedRiskEvaluationArgs = {
  campaignId: Scalars['ID'];
  signedIndex: Scalars['Int'];
};


export type QueryGetSlugForNewestCampaignArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetTermsArgs = {
  latest?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  _id: Scalars['ID'];
};


export type QueryGetUserPermissionsArgs = {
  campaignSlug?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserScreeningsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUsersByNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  verified?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetVideosBySectionArgs = {
  section: VideoSection;
};


export type QueryGetVisibleInvestorRelationsEventsArgs = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryIsTermsLatestVersionArgs = {
  version?: InputMaybe<Scalars['String']>;
};


export type QueryLastPostedCommentByCampaignIdArgs = {
  _id: Scalars['ID'];
};


export type QueryLatestCommentsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryMyCampaignCardByIdArgs = {
  campaignId: Scalars['ID'];
};


export type QueryReducedCampaignDataForCampaignCardArgs = {
  campaignId: Scalars['ID'];
};


export type QueryReservationJsonArgs = {
  _id: Scalars['ID'];
};


export type QuerySearchForInvestmentCompaniesArgs = {
  input?: InputMaybe<InvestmentCompanySearchInput>;
  paginationUrl?: InputMaybe<Scalars['String']>;
};


export type QueryUserExpediencyTestsArgs = {
  _id: Scalars['ID'];
};


export type QueryUserJsonArgs = {
  _id: Scalars['ID'];
};


export type QueryUserNeedsToSignArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryUserWithServiceExistsArgs = {
  serviceName: Scalars['String'];
  token: Scalars['String'];
};


export type QueryUsersWithCompanyInProfileArgs = {
  organizationNumber: Scalars['String'];
};


export type QueryVisitorSettingsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type RecentEmission = {
  __typename?: 'RecentEmission';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
};

export type RecentEmissionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['String']>;
};

export enum RecipientTypeEnum {
  BCC = 'bcc',
  CC = 'cc',
  NONE = 'none',
  TO = 'to'
}

export type RedisDataResponse = {
  __typename?: 'RedisDataResponse';
  count?: Maybe<Scalars['Int']>;
  list: Array<Maybe<RedisItem>>;
};

export type RedisItem = {
  __typename?: 'RedisItem';
  name?: Maybe<Scalars['String']>;
  ttl?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type RejectReservationInfo = {
  __typename?: 'RejectReservationInfo';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUserId?: Maybe<Scalars['ID']>;
  processedAt?: Maybe<Scalars['Date']>;
  processedBy?: Maybe<Scalars['String']>;
  status?: Maybe<RejectReservationStatusEnum>;
};

export type RejectReservationInput = {
  comment: Scalars['String'];
};

export enum RejectReservationStatusEnum {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PENDING = 'PENDING'
}

export type RequiredCampaignDocument = {
  __typename?: 'RequiredCampaignDocument';
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  _id: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['String']>;
  campaignState?: Maybe<Scalars['String']>;
  cancelReason?: Maybe<ReservationCancelReason>;
  concents?: Maybe<Array<Maybe<ReservationConcent>>>;
  createdAt?: Maybe<Scalars['Date']>;
  expediencyId?: Maybe<Scalars['ID']>;
  expediencyResult?: Maybe<Scalars['String']>;
  feedback?: Maybe<ReservationFeedback>;
  hidden?: Maybe<Scalars['Boolean']>;
  invoiceSent?: Maybe<Array<Maybe<Scalars['Date']>>>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<ReservationNote>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRegistrationDate?: Maybe<Scalars['Date']>;
  paymentRegistrationUser?: Maybe<User>;
  paymentState?: Maybe<Scalars['String']>;
  preorder?: Maybe<Scalars['Boolean']>;
  rejectedDueToMissingPayment?: Maybe<Scalars['Boolean']>;
  rejectionInfo?: Maybe<RejectReservationInfo>;
  shareholder_rejected?: Maybe<Scalars['Boolean']>;
  shares?: Maybe<Scalars['Int']>;
  signee?: Maybe<Signee>;
  ssn?: Maybe<Scalars['String']>;
  taggedForSinglePurposeVehicle?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  user?: Maybe<User>;
  userState?: Maybe<Scalars['String']>;
};

export type ReservationByAssociation = {
  __typename?: 'ReservationByAssociation';
  _id: Scalars['ID'];
  amount?: Maybe<Scalars['Float']>;
  campaign?: Maybe<Campaign>;
  cancelReason?: Maybe<ReservationCancelReason>;
  createdAt?: Maybe<Scalars['Date']>;
  hidden?: Maybe<Scalars['Boolean']>;
  invoiceSent?: Maybe<Array<Maybe<Scalars['Date']>>>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentRegistrationDate?: Maybe<Scalars['Date']>;
  paymentState?: Maybe<Scalars['String']>;
  rejectedDueToMissingPayment?: Maybe<Scalars['Boolean']>;
  rejectionInfo?: Maybe<RejectReservationInfo>;
  shareholder_rejected?: Maybe<Scalars['Boolean']>;
  shares?: Maybe<Scalars['Int']>;
  signee?: Maybe<Signee>;
  taggedForSinglePurposeVehicle?: Maybe<Scalars['Boolean']>;
  user?: Maybe<AssociatedReservationUser>;
  userState?: Maybe<Scalars['String']>;
};

export type ReservationCancelReason = {
  __typename?: 'ReservationCancelReason';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type ReservationCancelReasonInput = {
  comment?: InputMaybe<Scalars['String']>;
};

export type ReservationConcent = {
  __typename?: 'ReservationConcent';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
};

export type ReservationConcentInput = {
  content?: InputMaybe<Scalars['String']>;
};

export type ReservationFeedback = {
  __typename?: 'ReservationFeedback';
  amount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  comments: Array<Maybe<UserComment>>;
  score?: Maybe<Scalars['Int']>;
};

export type ReservationJson = {
  __typename?: 'ReservationJSON';
  json?: Maybe<Scalars['String']>;
  reservation?: Maybe<Reservation>;
};

export type ReservationNote = {
  __typename?: 'ReservationNote';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};

export type ReservationPage = {
  __typename?: 'ReservationPage';
  items: Array<Reservation>;
  timestamp: Scalars['Date'];
  totalCount: Scalars['Int'];
};

export type ReservationTag = {
  __typename?: 'ReservationTag';
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ReservationsListItem = {
  __typename?: 'ReservationsListItem';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  shares?: Maybe<Scalars['Int']>;
  signee?: Maybe<SigneeName>;
};

export type ReservationsSummary = {
  __typename?: 'ReservationsSummary';
  _id?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  investors?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Float']>;
};

export type ReserveSharesInput = {
  amount: Scalars['Float'];
  concents: Array<InputMaybe<Scalars['String']>>;
  expediencyId?: InputMaybe<Scalars['ID']>;
  expediencyResult?: InputMaybe<Scalars['String']>;
  shares: Scalars['Int'];
  signatureId?: InputMaybe<Scalars['String']>;
  signee: SigneeInput;
  vpsAccount?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RiskComment = {
  __typename?: 'RiskComment';
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type RiskCommentInput = {
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
};

export type RiskEvaluationData = {
  __typename?: 'RiskEvaluationData';
  _id: Scalars['ID'];
  comments: Array<Maybe<AdminComment>>;
  createdAt?: Maybe<Scalars['Date']>;
  history: Array<Maybe<RiskHistoryItem>>;
  riskMap: Array<Maybe<RiskEvaluationField>>;
  rrh: Array<Maybe<RiskEvaluationRrhItem>>;
  screenings?: Maybe<Array<Maybe<RiskEvaluationScreening>>>;
  signed: Array<Maybe<SignedEvaluation>>;
  status?: Maybe<RiskStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
  version?: Maybe<Scalars['String']>;
  versionData?: Maybe<RiskEvaluationVersion>;
};

export type RiskEvaluationField = {
  __typename?: 'RiskEvaluationField';
  checked?: Maybe<Scalars['Boolean']>;
  fieldId: Scalars['String'];
};

export type RiskEvaluationFieldInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  fieldId: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type RiskEvaluationItem = {
  __typename?: 'RiskEvaluationItem';
  comments?: Maybe<Array<Maybe<RiskComment>>>;
  handledBy?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  risk?: Maybe<Scalars['String']>;
  riskEvaluationDate?: Maybe<Scalars['Date']>;
  riskMap?: Maybe<Array<Maybe<RiskItem>>>;
  version?: Maybe<Scalars['Float']>;
};

export type RiskEvaluationItemInput = {
  comments?: InputMaybe<Array<InputMaybe<RiskCommentInput>>>;
  handledBy?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  risk?: InputMaybe<Scalars['String']>;
  riskEvaluationDate?: InputMaybe<Scalars['Date']>;
  riskMap?: InputMaybe<Array<InputMaybe<RiskItemInput>>>;
};

export type RiskEvaluationLabel = {
  __typename?: 'RiskEvaluationLabel';
  conclusion?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};

export type RiskEvaluationRrhItem = {
  __typename?: 'RiskEvaluationRRHItem';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  values: Array<Maybe<RiskEvaluationField>>;
};

export type RiskEvaluationRrhItemInput = {
  _id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<RiskEvaluationFieldInput>>>;
};

export type RiskEvaluationScreening = {
  __typename?: 'RiskEvaluationScreening';
  PEP?: Maybe<Scalars['Boolean']>;
  SANCTION?: Maybe<Scalars['Boolean']>;
  _id?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<AdminUser>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  screenings?: Maybe<Array<Maybe<AmlScreening>>>;
};

export type RiskEvaluationVersion = {
  __typename?: 'RiskEvaluationVersion';
  createdAt?: Maybe<Scalars['String']>;
  labels: Array<Maybe<RiskEvaluationLabel>>;
  version?: Maybe<Scalars['String']>;
};

export type RiskHistoryItem = {
  __typename?: 'RiskHistoryItem';
  _id: Scalars['ID'];
  createdAt?: Maybe<Scalars['Date']>;
  fieldId?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<AdminUser>;
  version?: Maybe<Scalars['String']>;
};

export type RiskIssueItem = {
  __typename?: 'RiskIssueItem';
  category?: Maybe<Scalars['String']>;
  conclusion?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
};

export type RiskItem = {
  __typename?: 'RiskItem';
  approved?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type RiskItemInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type RiskStatus = {
  __typename?: 'RiskStatus';
  issues: Array<Maybe<RiskIssueItem>>;
  risk?: Maybe<Scalars['String']>;
};

export type SpvMarkedResult = {
  __typename?: 'SPVMarkedResult';
  count?: Maybe<Scalars['Int']>;
  reservations: Array<Reservation>;
};

export type ScreeningItem = {
  __typename?: 'ScreeningItem';
  _id: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['Date']>;
  dateUpdated?: Maybe<Scalars['Date']>;
  entity?: Maybe<Scalars['String']>;
  externalSrc?: Maybe<Array<Maybe<Scalars['String']>>>;
  functionDescription?: Maybe<Scalars['String']>;
  list?: Maybe<Scalars['String']>;
  listType?: Maybe<Scalars['String']>;
  matchStrength?: Maybe<AmlMatchStrength>;
  src?: Maybe<Array<Maybe<Scalars['String']>>>;
  srcName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SelfReportItemData = {
  __typename?: 'SelfReportItemData';
  helpertext?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type SelfreportItem = {
  __typename?: 'SelfreportItem';
  answerDetails?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SelfreportItemInput = {
  answerDetails?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SignaturUserInput = {
  _id: Scalars['ID'];
  type?: InputMaybe<SignatureUserEnum>;
};

export type Signature = {
  __typename?: 'Signature';
  _id: Scalars['ID'];
  campaignId?: Maybe<Scalars['ID']>;
  category?: Maybe<SignatureCategoryEnum>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  documentId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  originalDoc?: Maybe<SignatureBlobData>;
  signedDate?: Maybe<Scalars['Date']>;
  signedDoc?: Maybe<SignatureBlobData>;
  signers?: Maybe<Array<Maybe<Signer>>>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SignatureBlobData = {
  __typename?: 'SignatureBlobData';
  blobName?: Maybe<Scalars['String']>;
  container?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
};

export enum SignatureCategoryEnum {
  COMPLETENESS_DECLARATION = 'COMPLETENESS_DECLARATION',
  CUSTOMER_AGREEMENT = 'CUSTOMER_AGREEMENT',
  SHAREHOLDER_AGREEMENT = 'SHAREHOLDER_AGREEMENT'
}

export enum SignatureUserEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export type SignedEvaluation = {
  __typename?: 'SignedEvaluation';
  campaign?: Maybe<Campaign>;
  comments?: Maybe<Array<Maybe<AdminComment>>>;
  createdAt?: Maybe<Scalars['Date']>;
  risk?: Maybe<Scalars['String']>;
  riskComment?: Maybe<Scalars['String']>;
  riskMap?: Maybe<Array<Maybe<RiskEvaluationField>>>;
  rrh?: Maybe<Array<Maybe<SignedRrhItem>>>;
  screenings?: Maybe<Array<Maybe<RiskEvaluationScreening>>>;
  signedBy?: Maybe<Scalars['String']>;
  status?: Maybe<RiskStatus>;
  version?: Maybe<Scalars['String']>;
  versionData?: Maybe<RiskEvaluationVersion>;
};

export type SignedExpediencyFieldStats = {
  __typename?: 'SignedExpediencyFieldStats';
  _id?: Maybe<Scalars['String']>;
  countFalse?: Maybe<Scalars['Int']>;
  countTrue?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type SignedRrhItem = {
  __typename?: 'SignedRRHItem';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  values: Array<Maybe<RiskEvaluationField>>;
};

export type Signee = {
  __typename?: 'Signee';
  addressFields?: Maybe<ProfileAddress>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  vpsAccount?: Maybe<Scalars['String']>;
};

export type SigneeInput = {
  addressFields: ProfileAddressInput;
  email: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
  phone: Scalars['String'];
  type: Scalars['String'];
};

export type SigneeName = {
  __typename?: 'SigneeName';
  name?: Maybe<Scalars['String']>;
};

export type Signer = {
  __typename?: 'Signer';
  name?: Maybe<Scalars['String']>;
  signatureUrl?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['Date']>;
  signedName?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userType?: Maybe<SignerEnum>;
};

export enum SignerEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export type SignerInput = {
  name: Scalars['String'];
  userId: Scalars['ID'];
  userType: SignerEnum;
};

export type SignicatDataInput = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  sessionState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type SignupInput = {
  campaignRef?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SinglePurposeVehicle = {
  __typename?: 'SinglePurposeVehicle';
  accountNumber?: Maybe<Scalars['String']>;
  cutoffAmountOfSharesInCampaign?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  numberOfShares?: Maybe<Scalars['Int']>;
  organizationNumber?: Maybe<Scalars['String']>;
  sharePrice?: Maybe<Scalars['Float']>;
};

export type SinglePurposeVehicleInput = {
  accountNumber: Scalars['String'];
  cutoffAmountOfSharesInCampaign: Scalars['Int'];
  name: Scalars['String'];
  numberOfShares: Scalars['Int'];
  organizationNumber: Scalars['String'];
  sharePrice: Scalars['Float'];
};

export type StatisticsItem = {
  __typename?: 'StatisticsItem';
  day?: Maybe<Scalars['Float']>;
  label?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  week?: Maybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  campaignUpdated?: Maybe<Campaign>;
  commentUpdated?: Maybe<Comment>;
  progressUpdated?: Maybe<ProgressItem>;
  pushmessageUpdate?: Maybe<Pushmessage>;
  reservationUpdated?: Maybe<Reservation>;
  reservationsSummaryUpdated?: Maybe<ReservationsSummary>;
  userUpdated?: Maybe<User>;
};


export type SubscriptionCampaignUpdatedArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type SubscriptionCommentUpdatedArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionProgressUpdatedArgs = {
  progressId: Scalars['ID'];
};


export type SubscriptionReservationUpdatedArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionReservationsSummaryUpdatedArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<SummaryEnum>;
};


export type SubscriptionUserUpdatedArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum SummaryEnum {
  ACTIVE = 'ACTIVE',
  NON_REJECTION = 'NON_REJECTION',
  TOTAL = 'TOTAL'
}

export type Terms = {
  __typename?: 'Terms';
  content?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type TestEmailInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  from?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  _id: Scalars['ID'];
  companyName?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  section?: Maybe<TestimonialSection>;
  text: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type TestimonialInput = {
  companyName?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<TestimonialSection>;
  text?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export enum TestimonialSection {
  ENTREPRENEUR = 'ENTREPRENEUR',
  FRONTPAGE = 'FRONTPAGE',
  LANDINGENTREPRENEUR = 'LANDINGENTREPRENEUR'
}

export type Twofactor = {
  __typename?: 'Twofactor';
  enabled?: Maybe<Scalars['Boolean']>;
  secret?: Maybe<Scalars['String']>;
};

export type UpdateCampaignCommentInput = {
  content?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCampaignDocumentInput = {
  category?: InputMaybe<CampaignDocumentCategoryEnum>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignInput = {
  accountBankName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  board?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
  campaignVideo?: InputMaybe<CampaignVideoInput>;
  caption?: InputMaybe<Scalars['String']>;
  chairmanEmail?: InputMaybe<Scalars['String']>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyCity?: InputMaybe<Scalars['String']>;
  companyEmail?: InputMaybe<Scalars['String']>;
  companyFoundedDate?: InputMaybe<Scalars['Date']>;
  companyLogo?: InputMaybe<FileInput>;
  companyLogoSmall?: InputMaybe<FileInput>;
  companyName?: InputMaybe<Scalars['String']>;
  companyNumber?: InputMaybe<Scalars['String']>;
  companyPostcode?: InputMaybe<Scalars['String']>;
  companyURL?: InputMaybe<Scalars['String']>;
  companyValue?: InputMaybe<Scalars['Float']>;
  coverImage?: InputMaybe<FileInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptionHTML?: InputMaybe<Scalars['String']>;
  featuredVideoId?: InputMaybe<Scalars['String']>;
  filesOptional?: InputMaybe<Array<InputMaybe<FileInput>>>;
  filesRequired?: InputMaybe<Array<InputMaybe<FileInput>>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  maximumInvestment?: InputMaybe<Scalars['Float']>;
  maximumShareInvestment?: InputMaybe<Scalars['Int']>;
  minimumInvestment?: InputMaybe<Scalars['Float']>;
  minimumShareInvestment?: InputMaybe<Scalars['Int']>;
  nominalShareValue?: InputMaybe<Scalars['Float']>;
  numberOfCurrentShares?: InputMaybe<Scalars['Int']>;
  owners?: InputMaybe<Array<InputMaybe<OwnerInput>>>;
  partners?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
  pricePerShare?: InputMaybe<Scalars['Float']>;
  raisingAmountMaximum?: InputMaybe<Scalars['Float']>;
  raisingAmountMinimum?: InputMaybe<Scalars['Float']>;
  raisingSharesMaximum?: InputMaybe<Scalars['Int']>;
  raisingSharesMinimum?: InputMaybe<Scalars['Int']>;
  selfreportlist?: InputMaybe<Array<InputMaybe<SelfreportItemInput>>>;
  sharesCapital?: InputMaybe<Scalars['Float']>;
  team?: InputMaybe<Array<InputMaybe<OrganizationMemberInput>>>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  acceptedLatestTerms?: Maybe<Scalars['Boolean']>;
  access?: Maybe<Scalars['String']>;
  addressFields?: Maybe<ProfileAddress>;
  bankidverified?: Maybe<Scalars['Boolean']>;
  birthdate?: Maybe<Scalars['String']>;
  campaigns?: Maybe<Array<Campaign>>;
  companies?: Maybe<Array<Company>>;
  concents?: Maybe<Array<Concent>>;
  conflictingSsnUser?: Maybe<User>;
  createdAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  expediency?: Maybe<ExpediencyResponse>;
  hasCampaigns?: Maybe<Scalars['Boolean']>;
  hasGoogleAsOnlyLoginMethod?: Maybe<Scalars['Boolean']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  hasPersonnumber?: Maybe<Scalars['Boolean']>;
  idverified?: Maybe<Scalars['String']>;
  ignoreBankIdDuplicates?: Maybe<Scalars['Boolean']>;
  isEntrepreneur?: Maybe<Scalars['Boolean']>;
  isInvestor?: Maybe<Scalars['Boolean']>;
  lastActive?: Maybe<Scalars['Date']>;
  loginBlocked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Nationality>;
  notifyInterval?: Maybe<Scalars['String']>;
  numberOfEmailsSent?: Maybe<Scalars['Int']>;
  pendingEmailChange?: Maybe<Scalars['String']>;
  pep?: Maybe<Scalars['Boolean']>;
  pepData?: Maybe<PepData>;
  pepHistory?: Maybe<Array<Maybe<PepHistoryItem>>>;
  phone?: Maybe<Scalars['String']>;
  preorderApprovedCampaigns: Array<Maybe<Campaign>>;
  previousAmlScreeningDate?: Maybe<Scalars['Date']>;
  profileCompleted?: Maybe<Scalars['Boolean']>;
  receiveNewsletter?: Maybe<Scalars['Boolean']>;
  relatedCampaigns: Array<Maybe<UserCampaignRelation>>;
  reservations?: Maybe<Array<Maybe<Reservation>>>;
  reservationsFailedExpediency?: Maybe<Scalars['Int']>;
  sanctions?: Maybe<Scalars['Boolean']>;
  signicat?: Maybe<Scalars['Boolean']>;
  spamReports: Array<EmailSpamReport>;
  ssn?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type UserActivityStats = {
  __typename?: 'UserActivityStats';
  count?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Date']>;
  subCount?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Date']>;
};

export type UserCampaignRelation = {
  __typename?: 'UserCampaignRelation';
  _id?: Maybe<Scalars['ID']>;
  isContributor?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type UserComment = {
  __typename?: 'UserComment';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserEmailData = {
  __typename?: 'UserEmailData';
  _id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  unsubscribeURL?: Maybe<Scalars['String']>;
};

export type UserJson = {
  __typename?: 'UserJSON';
  json?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserPage = {
  __typename?: 'UserPage';
  items?: Maybe<Array<Maybe<User>>>;
  timestamp?: Maybe<Scalars['Date']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UserWithServiceExistsPayload = {
  __typename?: 'UserWithServiceExistsPayload';
  existed?: Maybe<Scalars['Boolean']>;
};

export type UsersNotifyStats = {
  __typename?: 'UsersNotifyStats';
  data?: Maybe<Array<Maybe<IntervalData>>>;
  lastUpdate?: Maybe<Scalars['Date']>;
};

export type Video = {
  __typename?: 'Video';
  _id: Scalars['ID'];
  createdAt: Scalars['Date'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  highlighted?: Maybe<Scalars['Boolean']>;
  section: VideoSection;
  thumbnail?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Date']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type VideoInput = {
  description?: InputMaybe<Scalars['String']>;
  highlighted?: InputMaybe<Scalars['Boolean']>;
  section: VideoSection;
  thumbnail?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export enum VideoSection {
  STATISTICS = 'STATISTICS'
}

export type VisitorSettings = {
  __typename?: 'VisitorSettings';
  _id?: Maybe<Scalars['String']>;
  acceptsPreorderOffers?: Maybe<Scalars['Boolean']>;
  approvedForPreorder?: Maybe<Scalars['Boolean']>;
  hasEmailReminder?: Maybe<Scalars['Boolean']>;
  isContributor?: Maybe<Scalars['Boolean']>;
  isLoggedIn?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  showWelcomeDialog?: Maybe<Scalars['Boolean']>;
};

export type WillAcceptPreorderItem = {
  __typename?: 'WillAcceptPreorderItem';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type NotifyAboutErrorMutationVariables = Exact<{
  error?: InputMaybe<ErrorInput>;
}>;


export type NotifyAboutErrorMutation = { __typename?: 'Mutation', notifyAboutError?: string | null };

export type GetCampaignCardDataQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignCardDataQuery = { __typename?: 'Query', reducedCampaignDataForCampaignCard?: { __typename?: 'Campaign', _id?: string | null, slug?: string | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, status?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', total?: number | null, shares?: number | null, investors?: number | null } | null } | null, visitorSettings?: { __typename?: 'VisitorSettings', _id?: string | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, hasEmailReminder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null } | null };

export type EditEmailPreferencesMutationVariables = Exact<{
  input: EmailPreferencesInput;
}>;


export type EditEmailPreferencesMutation = { __typename?: 'Mutation', editEmailPreferences?: boolean | null };

export type SignExpediencyMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
  approved?: InputMaybe<Scalars['Boolean']>;
}>;


export type SignExpediencyMutation = { __typename?: 'Mutation', signExpediency?: { __typename?: 'User', _id: string, expediency?: { __typename?: 'ExpediencyResponse', signedDate?: any | null, signed?: boolean | null, result?: boolean | null, testId?: string | null, outdatedApproval?: boolean | null, totalAttempts?: number | null } | null } | null };

export type SubmitExpediencyMutationVariables = Exact<{
  input?: InputMaybe<ExpediencyInput>;
}>;


export type SubmitExpediencyMutation = { __typename?: 'Mutation', submitExpediency?: { __typename?: 'Expediency', _id?: string | null, fields?: Array<{ __typename?: 'ExpediencyField', id?: string | null, answer?: boolean | null } | null> | null } | null };

export type FetchDataForFollowDialogQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type FetchDataForFollowDialogQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, slug?: string | null, title?: string | null, caption?: string | null, emailReminderCount?: number | null, pricePerShare?: number | null, coverImage?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null, campaignCardBySlugOrId?: { __typename?: 'CampaignCard', id: string, followerCount?: number | null } | null, visitorSettings?: { __typename?: 'VisitorSettings', _id?: string | null, isLoggedIn?: boolean | null, hasEmailReminder?: boolean | null, approvedForPreorder?: boolean | null, acceptsPreorderOffers?: boolean | null } | null, me?: { __typename?: 'User', _id: string, email: string } | null, fetchComingSoonItem?: { __typename?: 'ComingSoonItem', _id?: string | null, title?: string | null, caption?: string | null, coverImage?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null };

export type FetchCampaignFollowerCountQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type FetchCampaignFollowerCountQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, emailReminderCount?: number | null } | null };

export type RegisterEmailReminderCampaignMutationVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  acceptPreorderOffer?: InputMaybe<Scalars['Boolean']>;
}>;


export type RegisterEmailReminderCampaignMutation = { __typename?: 'Mutation', registerEmailReminderCampaign?: boolean | null };

export type UnregisterEmailReminderCampaignMutationVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type UnregisterEmailReminderCampaignMutation = { __typename?: 'Mutation', unregisterEmailReminderCampaign?: boolean | null };

export type PushmessageFragmentFragment = { __typename?: 'Pushmessage', _id?: string | null, content?: string | null, status?: string | null, type?: string | null, createdAt?: any | null, closeDate?: any | null, startDate?: any | null };

export type GetPushMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPushMessagesQuery = { __typename?: 'Query', getPushmessages: Array<{ __typename?: 'Pushmessage', _id?: string | null, content?: string | null, status?: string | null, type?: string | null, createdAt?: any | null, closeDate?: any | null, startDate?: any | null } | null> };

export type PushmessageUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PushmessageUpdateSubscription = { __typename?: 'Subscription', pushmessageUpdate?: { __typename?: 'Pushmessage', _id?: string | null, content?: string | null, status?: string | null, type?: string | null, createdAt?: any | null, closeDate?: any | null, startDate?: any | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: { __typename?: 'SuccessResponse', success?: boolean | null, message?: string | null, code?: string | null } | null };

export type UserWithServiceExistsQueryVariables = Exact<{
  serviceName: Scalars['String'];
  token: Scalars['String'];
}>;


export type UserWithServiceExistsQuery = { __typename?: 'Query', userWithServiceExists?: { __typename?: 'UserWithServiceExistsPayload', existed?: boolean | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', passwordReset: { __typename?: 'ResetPasswordPayload', success?: boolean | null, message?: string | null } };

export type RequestEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestEmailVerificationMutation = { __typename?: 'Mutation', requestEmailVerification?: boolean | null };

export type ToggleCommentLikeMutationVariables = Exact<{
  commentId?: InputMaybe<Scalars['ID']>;
}>;


export type ToggleCommentLikeMutation = { __typename?: 'Mutation', toggleCommentLike?: { __typename?: 'Comment', _id: string, likes?: Array<string> | null } | null };

export type UpdateCommentSubscriptionMutationVariables = Exact<{
  commentID?: InputMaybe<Scalars['ID']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCommentSubscriptionMutation = { __typename?: 'Mutation', updateCommentSubscription?: { __typename?: 'Comment', _id: string, isSubscribed?: boolean | null } | null };

export type FetchCampaignDataForCommentsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type FetchCampaignDataForCommentsQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, closeDate?: any | null, filesRequired?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, user?: { __typename?: 'User', _id: string } | null, companyLogo?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null };

export type FetchCommentsQueryVariables = Exact<{
  _id: Scalars['ID'];
}>;


export type FetchCommentsQuery = { __typename?: 'Query', allCommentsByCampaignId: Array<{ __typename?: 'Comment', _id: string, content?: string | null, userStatus?: string | null, title?: string | null, createdAt?: any | null, parent?: string | null, deleted?: boolean | null, subscriptions?: Array<string | null> | null, likes?: Array<string> | null, isSubscribed?: boolean | null, user?: { __typename?: 'User', _id: string, name?: string | null } | null } | null> };

export type CommentUpdatedSubscriptionVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type CommentUpdatedSubscription = { __typename?: 'Subscription', commentUpdated?: { __typename?: 'Comment', _id: string, content?: string | null, userStatus?: string | null, title?: string | null, createdAt?: any | null, parent?: string | null, deleted?: boolean | null, subscriptions?: Array<string | null> | null, likes?: Array<string> | null, isSubscribed?: boolean | null, user?: { __typename?: 'User', _id: string, name?: string | null } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', addComment?: { __typename?: 'Comment', _id: string, content?: string | null, title?: string | null, parent?: string | null, createdAt?: any | null, subscriptions?: Array<string | null> | null, user?: { __typename?: 'User', name?: string | null, _id: string } | null } | null };

export type GetPublicCampaignDocumentDataQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetPublicCampaignDocumentDataQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, filesRequiredData?: Array<{ __typename?: 'PublicCampaignDocument', hidden?: boolean | null, title?: string | null, file?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, filesOptionalData?: Array<{ __typename?: 'PublicCampaignDocument', hidden?: boolean | null, title?: string | null, file?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null };

export type PublicCampaignDocumentFragmentForDocumentsFragment = { __typename?: 'PublicCampaignDocument', hidden?: boolean | null, title?: string | null, file?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null };

export type AddInvestmentsPageVisitorMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type AddInvestmentsPageVisitorMutation = { __typename?: 'Mutation', addInvestmentsPageVisitor?: boolean | null };

export type PreorderPermissionQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type PreorderPermissionQuery = { __typename?: 'Query', visitorSettings?: { __typename?: 'VisitorSettings', _id?: string | null, approvedForPreorder?: boolean | null, hasEmailReminder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null } | null };

export type FetchSigneeMaxSharesQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  organizationNumber?: InputMaybe<Scalars['String']>;
}>;


export type FetchSigneeMaxSharesQuery = { __typename?: 'Query', fetchSigneeDataForCampaign?: { __typename?: 'CampaignSigneeData', signeeCurrentShares?: number | null, totalSharesLeft?: number | null, campaignMax?: number | null, minPerSignee?: number | null, maxPerSignee?: number | null, maxSharesLeft?: number | null } | null };

export type ReserveSharesMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  input: ReserveSharesInput;
}>;


export type ReserveSharesMutation = { __typename?: 'Mutation', reserveShares?: { __typename?: 'Reservation', _id: string, shares?: number | null, campaign?: { __typename?: 'Campaign', _id?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null } | null };

export type SelfreportItemsInCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type SelfreportItemsInCampaignQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, selfreportlist?: Array<{ __typename?: 'SelfreportItem', id?: string | null, name?: string | null, description?: string | null, comment?: string | null, type?: string | null, values?: Array<string | null> | null, answerDetails?: string | null } | null> | null } | null };

export type CheckForNewerCampaignsQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type CheckForNewerCampaignsQuery = { __typename?: 'Query', getSlugForNewestCampaign?: string | null };

export type CampaignCardDataFragment = { __typename?: 'CampaignCard', id: string, title?: string | null, imageUrl?: string | null, caption?: string | null, website?: string | null, state: CampaignCardState, followerCount?: number | null, recentReservationsCount: number, reservationsCount?: number | null, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, slug?: string | null, dates?: { __typename?: 'CampaignDates', publish?: any | null, open?: any | null, close?: any | null } | null, finishedCampaignData?: { __typename?: 'FinishedCampaignCardCampaignData', _id: string, slug?: string | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, status?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, total?: number | null, shares?: number | null, investors?: number | null } | null } | null };

export type OrganizationMemberFragmentFragment = { __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null };

export type CampaignVideoDataFragment = { __typename?: 'CampaignVideo', id: string, url?: string | null, blobName?: string | null, name?: string | null, thumbnailUrl?: string | null, title?: string | null, description?: string | null, html?: string | null };

export type ReservationsSummaryFragmentFragment = { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null };

export type CampaignViewFragment = { __typename?: 'Campaign', _id?: string | null, title?: string | null, caption?: string | null, startDate?: any | null, closeDate?: any | null, publishDate?: any | null, closeDateRequested?: any | null, description?: string | null, descriptionHTML?: string | null, status?: string | null, slug?: string | null, chairmanEmail?: string | null, emailReminderCount?: number | null, companyNumber?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyFoundedDate?: any | null, companyURL?: string | null, companyEmail?: string | null, companyValue?: number | null, accountNumber?: string | null, invoiceSent?: Array<any | null> | null, pricePerShare?: number | null, numberOfCurrentShares?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, minimumInvestment?: number | null, maximumInvestment?: number | null, minimumShareInvestment?: number | null, maximumShareInvestment?: number | null, isHidden?: boolean | null, isOutdated?: boolean | null, shareholdersApproved?: boolean | null, commentCount?: number | null, pageViews?: number | null, fundedStatus?: string | null, hasVPS?: boolean | null, campaignOptions?: Array<{ __typename?: 'CampaignOption', name?: string | null, text?: string | null, checked?: boolean | null, labelText?: string | null } | null> | null, concentsRequired?: Array<{ __typename?: 'CampaignConcent', name?: string | null, label?: string | null, content?: string | null } | null> | null, coverImage?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogoSmall?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogo?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, owners?: Array<{ __typename?: 'Owner', name: string, shares: number }> | null, reservationsList?: Array<{ __typename?: 'ReservationsListItem', _id: string, createdAt?: any | null, shares?: number | null, signee?: { __typename?: 'SigneeName', name?: string | null } | null }> | null, featuredVideo?: { __typename?: 'CampaignVideo', id: string, url?: string | null, blobName?: string | null, name?: string | null, thumbnailUrl?: string | null, title?: string | null, description?: string | null, html?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null, filesRequired?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, filesOptional?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, team?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, board?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, partners?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null };

export type CommentViewFragment = { __typename?: 'Comment', _id: string, content?: string | null, userStatus?: string | null, title?: string | null, createdAt?: any | null, parent?: string | null, deleted?: boolean | null, subscriptions?: Array<string | null> | null, likes?: Array<string> | null, isSubscribed?: boolean | null, user?: { __typename?: 'User', _id: string, name?: string | null } | null };

export type InvestmentCompanyDataFragment = { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> };

export type FileFragmentFragment = { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null };

export type GetBlobUploadSasQueryVariables = Exact<{
  containerName: BlobContainer;
  blobName: Scalars['String'];
}>;


export type GetBlobUploadSasQuery = { __typename?: 'Query', getBlobUploadSas?: string | null };

export type AddCompanyCertificateMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  file: FileInput;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type AddCompanyCertificateMutation = { __typename?: 'Mutation', addCompanyCertificate?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type DeleteCompanyCertificateMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  certificateID: Scalars['ID'];
}>;


export type DeleteCompanyCertificateMutation = { __typename?: 'Mutation', deleteCompanyCertificate?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type PepDataFragment = { __typename?: 'PepData', createdAt?: any | null, handledAt?: any | null, approved?: boolean | null };

export type AddressFieldsFragmentFragment = { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null };

export type Me_AllFragment = { __typename?: 'User', _id: string, acceptedLatestTerms?: boolean | null, access?: string | null, bankidverified?: boolean | null, birthdate?: string | null, hasCampaigns?: boolean | null, loginBlocked?: boolean | null, createdAt?: any | null, email: string, emailVerified?: boolean | null, hasPassword?: boolean | null, hasPersonnumber?: boolean | null, idverified?: string | null, isEntrepreneur?: boolean | null, isInvestor?: boolean | null, hasGoogleAsOnlyLoginMethod?: boolean | null, name?: string | null, notifyInterval?: string | null, pendingEmailChange?: string | null, pep?: boolean | null, phone?: string | null, profileCompleted?: boolean | null, receiveNewsletter?: boolean | null, signicat?: boolean | null, updatedAt?: any | null, ignoreBankIdDuplicates?: boolean | null, nationality?: Nationality | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null, companies?: Array<{ __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> }> | null, concents?: Array<{ __typename?: 'Concent', name?: string | null, version?: string | null, createdAt?: any | null, updatedAt?: any | null, status?: string | null }> | null, expediency?: { __typename?: 'ExpediencyResponse', signedDate?: any | null, signed?: boolean | null, result?: boolean | null, testId?: string | null, outdatedApproval?: boolean | null, totalAttempts?: number | null } | null, pepData?: { __typename?: 'PepData', createdAt?: any | null, handledAt?: any | null, approved?: boolean | null } | null, conflictingSsnUser?: { __typename?: 'User', _id: string, createdAt?: any | null, email: string, phone?: string | null, loginBlocked?: boolean | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null };

export type ReservationFragmentFragment = { __typename?: 'Reservation', _id: string, shares?: number | null, amount?: number | null, createdAt?: any | null, userState?: string | null, paymentState?: string | null, shareholder_rejected?: boolean | null, paymentRegistrationDate?: any | null, rejectedDueToMissingPayment?: boolean | null, isOverdue?: boolean | null, campaignId?: string | null, user?: { __typename?: 'User', _id: string, name?: string | null } | null, signee?: { __typename?: 'Signee', name?: string | null, type?: string | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', refcode?: string | null, duedate?: any | null } | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, createdByUserId?: string | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null, processedBy?: string | null } | null };

export type MyReservationsViewFragment = { __typename?: 'Reservation', _id: string, amount?: number | null, shares?: number | null, hidden?: boolean | null, createdAt?: any | null, userState?: string | null, paymentState?: string | null, isLocked?: boolean | null, campaignState?: string | null, shareholder_rejected?: boolean | null, rejectedDueToMissingPayment?: boolean | null, taggedForSinglePurposeVehicle?: boolean | null, invoiceSent?: Array<any | null> | null, tags?: Array<string | null> | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null } | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, closeDate?: any | null, startDate?: any | null, status?: string | null, invoiceSent?: Array<any | null> | null, fundedStatus?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyNumber?: string | null, pricePerShare?: number | null, raisingAmountMinimum?: number | null, hasVPS?: boolean | null, accountNumber?: string | null, onboarding?: { __typename?: 'Onboarding', ceoName?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, duedate?: any | null, accountNumber?: string | null, pricePerShare?: number | null, companyName?: string | null, organizationNumber?: string | null, refcode?: string | null, vpsAndAccountToggled?: boolean | null } | null, signee?: { __typename?: 'Signee', name?: string | null, number?: string | null, vpsAccount?: string | null, type?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, concents?: Array<{ __typename?: 'ReservationConcent', content?: string | null, createdAt?: any | null } | null> | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null };

export type ReservationsTableFragment = { __typename?: 'Reservation', _id: string, amount?: number | null, shares?: number | null, createdAt?: any | null, userState?: string | null, isLocked?: boolean | null, shareholder_rejected?: boolean | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, raisingAmountMaximum?: number | null, raisingAmountMinimum?: number | null, fundedStatus?: string | null, hasVPS?: boolean | null, accountNumber?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, refcode?: string | null, duedate?: any | null } | null, concents?: Array<{ __typename?: 'ReservationConcent', content?: string | null, createdAt?: any | null } | null> | null, signee?: { __typename?: 'Signee', name?: string | null, email?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, user?: { __typename?: 'User', _id: string, name?: string | null, email: string } | null };

export type ReservationViewFragment = { __typename?: 'Reservation', _id: string, amount?: number | null, isLocked?: boolean | null, campaignState?: string | null, createdAt?: any | null, paymentRegistrationDate?: any | null, paymentState?: string | null, shareholder_rejected?: boolean | null, shares?: number | null, preorder?: boolean | null, userState?: string | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, raisingAmountMaximum?: number | null, raisingAmountMinimum?: number | null, fundedStatus?: string | null, hasVPS?: boolean | null, accountNumber?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, refcode?: string | null, duedate?: any | null } | null, signee?: { __typename?: 'Signee', name?: string | null, email?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, user?: { __typename?: 'User', _id: string, name?: string | null, email: string } | null };

export type SubscribeToReservationsSummarySubscriptionVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<SummaryEnum>;
}>;


export type SubscribeToReservationsSummarySubscription = { __typename?: 'Subscription', reservationsSummaryUpdated?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null };

export type GetReservationsSummaryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  includePreorders?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReservationsSummaryQuery = { __typename?: 'Query', getReservationsSummaryForCampaign?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null };

export type GetAllAboutUsMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAboutUsMembersQuery = { __typename?: 'Query', getAboutUsMembers: { __typename?: 'AllAboutUsMembers', members: Array<{ __typename?: 'AboutUsMember', _id: string, imageUrl?: string | null, name?: string | null, location?: string | null, title?: string | null, section?: AboutUsMemberSection | null }> } };

export type MyCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCampaignsQuery = { __typename?: 'Query', myCampaigns: Array<{ __typename?: 'Campaign', _id?: string | null, onboardingCompleted?: boolean | null, title?: string | null, slug?: string | null, licensePaid?: string | null, createdAt?: any | null, status?: string | null } | null> };

export type MyCampaignCardByIdQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type MyCampaignCardByIdQuery = { __typename?: 'Query', myCampaignCardById?: { __typename?: 'CampaignCard', id: string, title?: string | null, imageUrl?: string | null, caption?: string | null, website?: string | null, state: CampaignCardState, followerCount?: number | null, recentReservationsCount: number, reservationsCount?: number | null, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, slug?: string | null, dates?: { __typename?: 'CampaignDates', publish?: any | null, open?: any | null, close?: any | null } | null, finishedCampaignData?: { __typename?: 'FinishedCampaignCardCampaignData', _id: string, slug?: string | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, status?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, total?: number | null, shares?: number | null, investors?: number | null } | null } | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type SearchForInvestmentCompanyQueryVariables = Exact<{
  input?: InputMaybe<InvestmentCompanySearchInput>;
  paginationUrl?: InputMaybe<Scalars['String']>;
}>;


export type SearchForInvestmentCompanyQuery = { __typename?: 'Query', searchForInvestmentCompanies: { __typename?: 'CompanySearchResult', hitCount: number, pageIndex: number, totalPages: number, next?: string | null, previous?: string | null, countryCode: CompanyCountryCodeEnum, hits: Array<{ __typename?: 'CompanySearchResultItem', companyId?: string | null, companyName?: string | null, legalGroupCode?: string | null, town?: string | null, legalGroupText?: string | null } | null> } };

export type AddInvestmentCompanyToProfileMutationVariables = Exact<{
  companyId: Scalars['String'];
  countryCode: CompanyCountryCodeEnum;
}>;


export type AddInvestmentCompanyToProfileMutation = { __typename?: 'Mutation', addInvestmentCompanyToProfile?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type RemoveCompanyMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
}>;


export type RemoveCompanyMutation = { __typename?: 'Mutation', removeCompany?: { __typename?: 'User', _id: string } | null };

export type AddCompanyUserMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  email: Scalars['String'];
}>;


export type AddCompanyUserMutation = { __typename?: 'Mutation', addCompanyUser?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type RemoveCompanyUserMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  email: Scalars['String'];
}>;


export type RemoveCompanyUserMutation = { __typename?: 'Mutation', removeCompanyUser?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type GetCompanyOwnersQueryVariables = Exact<{
  organizationNumber: Scalars['String'];
}>;


export type GetCompanyOwnersQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type AddCompanyOwnerMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  name: Scalars['String'];
}>;


export type AddCompanyOwnerMutation = { __typename?: 'Mutation', addCompanyOwner?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type RemoveCompanyOwnerMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  _id: Scalars['ID'];
}>;


export type RemoveCompanyOwnerMutation = { __typename?: 'Mutation', removeCompanyOwner?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type ToggleNoCompanyOwnersMutationVariables = Exact<{
  organizationNumber: Scalars['String'];
  hasNoOwners: Scalars['Boolean'];
}>;


export type ToggleNoCompanyOwnersMutation = { __typename?: 'Mutation', toggleNoCompanyOwners?: { __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> } | null };

export type MyServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyServicesQuery = { __typename?: 'Query', myServices?: Array<string | null> | null };

export type AddServiceMutationVariables = Exact<{
  serviceName: Scalars['String'];
  token: Scalars['String'];
}>;


export type AddServiceMutation = { __typename?: 'Mutation', addService?: boolean | null };

export type RemoveServiceMutationVariables = Exact<{
  serviceName: Scalars['String'];
}>;


export type RemoveServiceMutation = { __typename?: 'Mutation', removeService?: boolean | null };

export type GetTermsCurrentVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsCurrentVersionQuery = { __typename?: 'Query', getTermsCurrentVersion?: string | null };

export type RevokeTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeTermsMutation = { __typename?: 'Mutation', revokeTerms?: boolean | null };

export type ResetBankIdMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetBankIdMutation = { __typename?: 'Mutation', resetBankId?: boolean | null };

export type CancelReservationMutationVariables = Exact<{
  reservationId: Scalars['ID'];
  reason: ReservationCancelReasonInput;
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', cancelReservation?: { __typename?: 'Reservation', _id: string, userState?: string | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null } | null };

export type HideReservationMutationVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type HideReservationMutation = { __typename?: 'Mutation', hideReservation?: { __typename?: 'Reservation', _id: string, hidden?: boolean | null } | null };

export type MyReservationSubSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MyReservationSubSubscription = { __typename?: 'Subscription', reservationUpdated?: { __typename?: 'Reservation', _id: string, amount?: number | null, shares?: number | null, hidden?: boolean | null, createdAt?: any | null, userState?: string | null, paymentState?: string | null, isLocked?: boolean | null, campaignState?: string | null, shareholder_rejected?: boolean | null, rejectedDueToMissingPayment?: boolean | null, taggedForSinglePurposeVehicle?: boolean | null, invoiceSent?: Array<any | null> | null, tags?: Array<string | null> | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null } | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, closeDate?: any | null, startDate?: any | null, status?: string | null, invoiceSent?: Array<any | null> | null, fundedStatus?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyNumber?: string | null, pricePerShare?: number | null, raisingAmountMinimum?: number | null, hasVPS?: boolean | null, accountNumber?: string | null, onboarding?: { __typename?: 'Onboarding', ceoName?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, duedate?: any | null, accountNumber?: string | null, pricePerShare?: number | null, companyName?: string | null, organizationNumber?: string | null, refcode?: string | null, vpsAndAccountToggled?: boolean | null } | null, signee?: { __typename?: 'Signee', name?: string | null, number?: string | null, vpsAccount?: string | null, type?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, concents?: Array<{ __typename?: 'ReservationConcent', content?: string | null, createdAt?: any | null } | null> | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null } | null };

export type MyReservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReservationsQuery = { __typename?: 'Query', myReservations: Array<{ __typename?: 'Reservation', _id: string, amount?: number | null, shares?: number | null, hidden?: boolean | null, createdAt?: any | null, userState?: string | null, paymentState?: string | null, isLocked?: boolean | null, campaignState?: string | null, shareholder_rejected?: boolean | null, rejectedDueToMissingPayment?: boolean | null, taggedForSinglePurposeVehicle?: boolean | null, invoiceSent?: Array<any | null> | null, tags?: Array<string | null> | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null } | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, closeDate?: any | null, startDate?: any | null, status?: string | null, invoiceSent?: Array<any | null> | null, fundedStatus?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyNumber?: string | null, pricePerShare?: number | null, raisingAmountMinimum?: number | null, hasVPS?: boolean | null, accountNumber?: string | null, onboarding?: { __typename?: 'Onboarding', ceoName?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, duedate?: any | null, accountNumber?: string | null, pricePerShare?: number | null, companyName?: string | null, organizationNumber?: string | null, refcode?: string | null, vpsAndAccountToggled?: boolean | null } | null, signee?: { __typename?: 'Signee', name?: string | null, number?: string | null, vpsAccount?: string | null, type?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, concents?: Array<{ __typename?: 'ReservationConcent', content?: string | null, createdAt?: any | null } | null> | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null } | null>, myAssociatedReservations: Array<{ __typename?: 'ReservationByAssociation', _id: string, amount?: number | null, shares?: number | null, createdAt?: any | null, userState?: string | null, hidden?: boolean | null, paymentState?: string | null, shareholder_rejected?: boolean | null, rejectedDueToMissingPayment?: boolean | null, taggedForSinglePurposeVehicle?: boolean | null, invoiceSent?: Array<any | null> | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null } | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, closeDate?: any | null, startDate?: any | null, status?: string | null, invoiceSent?: Array<any | null> | null, fundedStatus?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyNumber?: string | null, pricePerShare?: number | null, raisingAmountMinimum?: number | null, hasVPS?: boolean | null, accountNumber?: string | null, onboarding?: { __typename?: 'Onboarding', ceoName?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, duedate?: any | null, accountNumber?: string | null, pricePerShare?: number | null, companyName?: string | null, organizationNumber?: string | null, refcode?: string | null, vpsAndAccountToggled?: boolean | null } | null, signee?: { __typename?: 'Signee', name?: string | null, number?: string | null, vpsAccount?: string | null, type?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null, user?: { __typename?: 'AssociatedReservationUser', _id: string, name: string, email: string } | null }> };

export type ReservationByAssociationDataFragment = { __typename?: 'ReservationByAssociation', _id: string, amount?: number | null, shares?: number | null, createdAt?: any | null, userState?: string | null, hidden?: boolean | null, paymentState?: string | null, shareholder_rejected?: boolean | null, rejectedDueToMissingPayment?: boolean | null, taggedForSinglePurposeVehicle?: boolean | null, invoiceSent?: Array<any | null> | null, rejectionInfo?: { __typename?: 'RejectReservationInfo', createdAt?: any | null, status?: RejectReservationStatusEnum | null, comment?: string | null, processedAt?: any | null } | null, campaign?: { __typename?: 'Campaign', title?: string | null, _id?: string | null, slug?: string | null, closeDate?: any | null, startDate?: any | null, status?: string | null, invoiceSent?: Array<any | null> | null, fundedStatus?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyNumber?: string | null, pricePerShare?: number | null, raisingAmountMinimum?: number | null, hasVPS?: boolean | null, accountNumber?: string | null, onboarding?: { __typename?: 'Onboarding', ceoName?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', amount?: number | null, duedate?: any | null, accountNumber?: string | null, pricePerShare?: number | null, companyName?: string | null, organizationNumber?: string | null, refcode?: string | null, vpsAndAccountToggled?: boolean | null } | null, signee?: { __typename?: 'Signee', name?: string | null, number?: string | null, vpsAccount?: string | null, type?: string | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null, cancelReason?: { __typename?: 'ReservationCancelReason', comment?: string | null, createdAt?: any | null } | null, user?: { __typename?: 'AssociatedReservationUser', _id: string, name: string, email: string } | null };

export type ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type ReservationsSummaryUpdatedForCampaignPageSubscription = { __typename?: 'Subscription', reservationsSummaryUpdated?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null };

export type CampaignUpdatedSubscriptionVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type CampaignUpdatedSubscription = { __typename?: 'Subscription', campaignUpdated?: { __typename?: 'Campaign', _id?: string | null, title?: string | null, caption?: string | null, startDate?: any | null, closeDate?: any | null, publishDate?: any | null, closeDateRequested?: any | null, description?: string | null, descriptionHTML?: string | null, status?: string | null, slug?: string | null, chairmanEmail?: string | null, emailReminderCount?: number | null, companyNumber?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyFoundedDate?: any | null, companyURL?: string | null, companyEmail?: string | null, companyValue?: number | null, accountNumber?: string | null, invoiceSent?: Array<any | null> | null, pricePerShare?: number | null, numberOfCurrentShares?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, minimumInvestment?: number | null, maximumInvestment?: number | null, minimumShareInvestment?: number | null, maximumShareInvestment?: number | null, isHidden?: boolean | null, isOutdated?: boolean | null, shareholdersApproved?: boolean | null, commentCount?: number | null, pageViews?: number | null, fundedStatus?: string | null, hasVPS?: boolean | null, campaignOptions?: Array<{ __typename?: 'CampaignOption', name?: string | null, text?: string | null, checked?: boolean | null, labelText?: string | null } | null> | null, concentsRequired?: Array<{ __typename?: 'CampaignConcent', name?: string | null, label?: string | null, content?: string | null } | null> | null, coverImage?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogoSmall?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogo?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, owners?: Array<{ __typename?: 'Owner', name: string, shares: number }> | null, reservationsList?: Array<{ __typename?: 'ReservationsListItem', _id: string, createdAt?: any | null, shares?: number | null, signee?: { __typename?: 'SigneeName', name?: string | null } | null }> | null, featuredVideo?: { __typename?: 'CampaignVideo', id: string, url?: string | null, blobName?: string | null, name?: string | null, thumbnailUrl?: string | null, title?: string | null, description?: string | null, html?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null, filesRequired?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, filesOptional?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, team?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, board?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, partners?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null };

export type IncrementCampaignViewsMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type IncrementCampaignViewsMutation = { __typename?: 'Mutation', incrementCampaignViews?: number | null };

export type SetReservationFeedbackCommentMutationVariables = Exact<{
  reservationID: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SetReservationFeedbackCommentMutation = { __typename?: 'Mutation', setReservationFeedbackComment?: boolean | null };

export type SetReservationFeedbackScoreMutationVariables = Exact<{
  reservationID: Scalars['ID'];
  score?: InputMaybe<Scalars['Int']>;
}>;


export type SetReservationFeedbackScoreMutation = { __typename?: 'Mutation', setReservationFeedbackScore?: boolean | null };

export type CampaignCardBySlugOrIdQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type CampaignCardBySlugOrIdQuery = { __typename?: 'Query', campaignCardBySlugOrId?: { __typename?: 'CampaignCard', id: string, title?: string | null, imageUrl?: string | null, caption?: string | null, website?: string | null, state: CampaignCardState, followerCount?: number | null, recentReservationsCount: number, reservationsCount?: number | null, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, slug?: string | null, dates?: { __typename?: 'CampaignDates', publish?: any | null, open?: any | null, close?: any | null } | null, finishedCampaignData?: { __typename?: 'FinishedCampaignCardCampaignData', _id: string, slug?: string | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, status?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, total?: number | null, shares?: number | null, investors?: number | null } | null } | null } | null };

export type IsSpecialFrontPageEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IsSpecialFrontPageEnabledQuery = { __typename?: 'Query', isSpecialFrontPageEnabled: boolean };

export type HasOpenCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type HasOpenCampaignsQuery = { __typename?: 'Query', hasOpenCampaigns?: boolean | null };

export type GetFrontPageTestimonialQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFrontPageTestimonialQuery = { __typename?: 'Query', getFrontPageTestimonial?: { __typename?: 'Testimonial', companyName?: string | null, imageUrl: string, name: string, text: string } | null };

export type GetEntrepreneurTestimonialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEntrepreneurTestimonialsQuery = { __typename?: 'Query', getEntrepreneurTestimonials?: Array<{ __typename?: 'Testimonial', _id: string, companyName?: string | null, imageUrl: string, jobTitle?: string | null, name: string, text: string } | null> | null };

export type GetLandingPageEntrepreneurTestimonialQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLandingPageEntrepreneurTestimonialQuery = { __typename?: 'Query', getLandingPageEntrepreneurTestimonial?: { __typename?: 'Testimonial', _id: string, companyName?: string | null, imageUrl: string, jobTitle?: string | null, name: string, text: string } | null };

export type GetActiveInvestorRelationsHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveInvestorRelationsHeaderQuery = { __typename?: 'Query', getActiveInvestorRelationsHeader?: { __typename?: 'InvestorRelationsHeader', _id?: string | null, title?: string | null, description?: string | null, videoUrl?: string | null } | null };

export type GetVisibleInvestorRelationsEventsQueryVariables = Exact<{
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetVisibleInvestorRelationsEventsQuery = { __typename?: 'Query', getVisibleInvestorRelationsEvents?: { __typename?: 'InvestorRelationsEventPage', pageIndex?: number | null, pageSize?: number | null, totalCount?: number | null, events?: Array<{ __typename?: 'InvestorRelationsEvent', _id?: string | null, title?: string | null, description?: string | null, dateOfEvent?: any | null, endDateOfEvent?: any | null } | null> | null } | null };

export type GetAllInvestorRelationHighlightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInvestorRelationHighlightsQuery = { __typename?: 'Query', getAllInvestorRelationsHighlights?: Array<{ __typename?: 'InvestorRelationsHighlight', _id?: string | null, title?: string | null, description?: string | null, linkUrl?: string | null, dateOfHighlight?: any | null } | null> | null };

export type InterestedCompanyNotificationMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  country: InterestedCompanyCountryEnum;
  companyName: Scalars['String'];
}>;


export type InterestedCompanyNotificationMutation = { __typename?: 'Mutation', interestedCompanyNotification?: boolean | null };

export type ReservationsSummaryForLivePageDataFragment = { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, shares?: number | null, total?: number | null, investors?: number | null };

export type LivePageReservationsSummarySubscriptionSubscriptionVariables = Exact<{
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type LivePageReservationsSummarySubscriptionSubscription = { __typename?: 'Subscription', reservationsSummaryUpdated?: { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, shares?: number | null, total?: number | null, investors?: number | null } | null };

export type LivePageCampaignSubscriptionVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type LivePageCampaignSubscription = { __typename?: 'Subscription', campaignUpdated?: { __typename?: 'Campaign', _id?: string | null, startDate?: any | null, closeDate?: any | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, title?: string | null } | null };

export type InitialLivePageDataQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type InitialLivePageDataQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, startDate?: any | null, closeDate?: any | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, title?: string | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, count?: number | null, shares?: number | null, total?: number | null, investors?: number | null } | null } | null };

export type CampaignPreorderWithVisitorQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CampaignPreorderWithVisitorQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, title?: string | null, slug?: string | null } | null, visitorSettings?: { __typename?: 'VisitorSettings', _id?: string | null, approvedForPreorder?: boolean | null } | null };

export type GetAllPressReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPressReleasesQuery = { __typename?: 'Query', getAllPressReleases: Array<{ __typename?: 'PressRelease', _id: string, title?: string | null, description?: string | null, imageUrl?: string | null, timestamp?: any | null, documentUrl?: string | null } | null> };

export type GetAllMediaMentionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMediaMentionsQuery = { __typename?: 'Query', getAllMediaMentions: Array<{ __typename?: 'MediaMention', _id: string, title?: string | null, description?: string | null, imageUrl?: string | null, timestamp?: any | null, documentUrl?: string | null } | null> };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: boolean };

export type PublicDocumentFragmentFragment = { __typename?: 'PublicDocument', _id: string, fileName?: string | null, fileUrl?: string | null, publishDate?: any | null, section?: PublicDocumentSection | null, title?: string | null, year?: number | null };

export type GetPublicDocumentsBySectionQueryVariables = Exact<{
  section: PublicDocumentSection;
}>;


export type GetPublicDocumentsBySectionQuery = { __typename?: 'Query', getPublicDocumentsBySection?: Array<{ __typename?: 'PublicDocument', _id: string, fileName?: string | null, fileUrl?: string | null, publishDate?: any | null, section?: PublicDocumentSection | null, title?: string | null, year?: number | null } | null> | null };

export type GetStatisticsVideosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticsVideosQuery = { __typename?: 'Query', getVideosBySection?: Array<{ __typename?: 'Video', _id: string, description?: string | null, highlighted?: boolean | null, thumbnail?: string | null, timestamp?: any | null, title?: string | null, url?: string | null } | null> | null };

export type MeEmailSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeEmailSettingsQuery = { __typename?: 'Query', me?: { __typename?: 'User', _id: string, email: string, notifyInterval?: string | null, receiveNewsletter?: boolean | null, emailVerified?: boolean | null } | null };

export type FetchEmailPreferencesQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type FetchEmailPreferencesQuery = { __typename?: 'Query', fetchEmailPreferences?: { __typename?: 'EmailPreferences', email?: string | null, notifyInterval?: string | null, receiveNewsletter?: boolean | null } | null };

export type UpdateProfileMutationMutationVariables = Exact<{
  input: ProfileUpdateInput;
}>;


export type UpdateProfileMutationMutation = { __typename?: 'Mutation', updateProfile?: boolean | null };

export type AcceptTermsMutationMutationVariables = Exact<{
  termsVersion?: InputMaybe<Scalars['String']>;
  pep?: InputMaybe<Scalars['Boolean']>;
}>;


export type AcceptTermsMutationMutation = { __typename?: 'Mutation', acceptTerms?: boolean | null };

export type RequestEmailReVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestEmailReVerificationMutation = { __typename?: 'Mutation', requestEmailReVerification?: boolean | null };

export type ApproveUserForPreorderMutationVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type ApproveUserForPreorderMutation = { __typename?: 'Mutation', approveUserForPreorder?: boolean | null };

export type VisitorSettingsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['ID']>;
}>;


export type VisitorSettingsQuery = { __typename?: 'Query', visitorSettings?: { __typename?: 'VisitorSettings', _id?: string | null, isLoggedIn?: boolean | null, showWelcomeDialog?: boolean | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, hasEmailReminder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null } | null };

export type GetTermsQueryVariables = Exact<{
  version?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTermsQuery = { __typename?: 'Query', getTerms?: { __typename?: 'Terms', content?: string | null, version?: string | null } | null };

export type FetchCampaignQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type FetchCampaignQuery = { __typename?: 'Query', Campaign?: { __typename?: 'Campaign', _id?: string | null, title?: string | null, caption?: string | null, startDate?: any | null, closeDate?: any | null, publishDate?: any | null, closeDateRequested?: any | null, description?: string | null, descriptionHTML?: string | null, status?: string | null, slug?: string | null, chairmanEmail?: string | null, emailReminderCount?: number | null, companyNumber?: string | null, companyName?: string | null, companyAddress?: string | null, companyPostcode?: string | null, companyCity?: string | null, companyFoundedDate?: any | null, companyURL?: string | null, companyEmail?: string | null, companyValue?: number | null, accountNumber?: string | null, invoiceSent?: Array<any | null> | null, pricePerShare?: number | null, numberOfCurrentShares?: number | null, raisingAmountMinimum?: number | null, raisingAmountMaximum?: number | null, raisingSharesMinimum?: number | null, raisingSharesMaximum?: number | null, minimumInvestment?: number | null, maximumInvestment?: number | null, minimumShareInvestment?: number | null, maximumShareInvestment?: number | null, isHidden?: boolean | null, isOutdated?: boolean | null, shareholdersApproved?: boolean | null, commentCount?: number | null, pageViews?: number | null, fundedStatus?: string | null, hasVPS?: boolean | null, campaignOptions?: Array<{ __typename?: 'CampaignOption', name?: string | null, text?: string | null, checked?: boolean | null, labelText?: string | null } | null> | null, concentsRequired?: Array<{ __typename?: 'CampaignConcent', name?: string | null, label?: string | null, content?: string | null } | null> | null, coverImage?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogoSmall?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, companyLogo?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null, owners?: Array<{ __typename?: 'Owner', name: string, shares: number }> | null, reservationsList?: Array<{ __typename?: 'ReservationsListItem', _id: string, createdAt?: any | null, shares?: number | null, signee?: { __typename?: 'SigneeName', name?: string | null } | null }> | null, featuredVideo?: { __typename?: 'CampaignVideo', id: string, url?: string | null, blobName?: string | null, name?: string | null, thumbnailUrl?: string | null, title?: string | null, description?: string | null, html?: string | null } | null, reservationsSummary?: { __typename?: 'ReservationsSummary', _id?: string | null, total?: number | null, count?: number | null, shares?: number | null, investors?: number | null } | null, filesRequired?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, filesOptional?: Array<{ __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null> | null, team?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, board?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null, partners?: Array<{ __typename?: 'OrganizationMember', id?: string | null, bio?: string | null, facebook?: string | null, linkedin?: string | null, name?: string | null, role?: string | null, roles?: Array<string | null> | null, title?: string | null, twitter?: string | null, picture?: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null };

export type EmailAddressInUseQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type EmailAddressInUseQuery = { __typename?: 'Query', emailAddressInUse?: boolean | null };

export type MeAllQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAllQuery = { __typename?: 'Query', me?: { __typename?: 'User', _id: string, acceptedLatestTerms?: boolean | null, access?: string | null, bankidverified?: boolean | null, birthdate?: string | null, hasCampaigns?: boolean | null, loginBlocked?: boolean | null, createdAt?: any | null, email: string, emailVerified?: boolean | null, hasPassword?: boolean | null, hasPersonnumber?: boolean | null, idverified?: string | null, isEntrepreneur?: boolean | null, isInvestor?: boolean | null, hasGoogleAsOnlyLoginMethod?: boolean | null, name?: string | null, notifyInterval?: string | null, pendingEmailChange?: string | null, pep?: boolean | null, phone?: string | null, profileCompleted?: boolean | null, receiveNewsletter?: boolean | null, signicat?: boolean | null, updatedAt?: any | null, ignoreBankIdDuplicates?: boolean | null, nationality?: Nationality | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null, companies?: Array<{ __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> }> | null, concents?: Array<{ __typename?: 'Concent', name?: string | null, version?: string | null, createdAt?: any | null, updatedAt?: any | null, status?: string | null }> | null, expediency?: { __typename?: 'ExpediencyResponse', signedDate?: any | null, signed?: boolean | null, result?: boolean | null, testId?: string | null, outdatedApproval?: boolean | null, totalAttempts?: number | null } | null, pepData?: { __typename?: 'PepData', createdAt?: any | null, handledAt?: any | null, approved?: boolean | null } | null, conflictingSsnUser?: { __typename?: 'User', _id: string, createdAt?: any | null, email: string, phone?: string | null, loginBlocked?: boolean | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null } | null };

export type ContextUserUpdatedSubscriptionVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;


export type ContextUserUpdatedSubscription = { __typename?: 'Subscription', userUpdated?: { __typename?: 'User', _id: string, acceptedLatestTerms?: boolean | null, access?: string | null, bankidverified?: boolean | null, birthdate?: string | null, hasCampaigns?: boolean | null, loginBlocked?: boolean | null, createdAt?: any | null, email: string, emailVerified?: boolean | null, hasPassword?: boolean | null, hasPersonnumber?: boolean | null, idverified?: string | null, isEntrepreneur?: boolean | null, isInvestor?: boolean | null, hasGoogleAsOnlyLoginMethod?: boolean | null, name?: string | null, notifyInterval?: string | null, pendingEmailChange?: string | null, pep?: boolean | null, phone?: string | null, profileCompleted?: boolean | null, receiveNewsletter?: boolean | null, signicat?: boolean | null, updatedAt?: any | null, ignoreBankIdDuplicates?: boolean | null, nationality?: Nationality | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null, companies?: Array<{ __typename?: 'Company', _id?: string | null, name?: string | null, organizationNumber: string, organizationType: string, address?: string | null, postcode?: string | null, city?: string | null, foundedDate?: any | null, userStatus?: string | null, verified?: any | null, hasNoOwners: boolean, users: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, owners?: Array<{ __typename?: 'CompanyOwner', _id?: string | null, name?: string | null } | null> | null, removedUsers: Array<{ __typename?: 'CompanyUser', email?: string | null, addedBy?: string | null, owner?: boolean | null, removedBy?: string | null, createdAt?: any | null } | null>, certificates: Array<{ __typename?: 'CompanyCertificate', _id?: string | null, date?: any | null, comment?: string | null, submitDate?: any | null, submitUserId?: string | null, processed?: boolean | null, approved?: boolean | null, archived?: boolean | null, processedBy?: string | null, file: { __typename?: 'File', id?: string | null, mimeType?: string | null, name?: string | null, originalName?: string | null, title?: string | null, url?: string | null } } | null> }> | null, concents?: Array<{ __typename?: 'Concent', name?: string | null, version?: string | null, createdAt?: any | null, updatedAt?: any | null, status?: string | null }> | null, expediency?: { __typename?: 'ExpediencyResponse', signedDate?: any | null, signed?: boolean | null, result?: boolean | null, testId?: string | null, outdatedApproval?: boolean | null, totalAttempts?: number | null } | null, pepData?: { __typename?: 'PepData', createdAt?: any | null, handledAt?: any | null, approved?: boolean | null } | null, conflictingSsnUser?: { __typename?: 'User', _id: string, createdAt?: any | null, email: string, phone?: string | null, loginBlocked?: boolean | null, addressFields?: { __typename?: 'ProfileAddress', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } | null } | null } | null };

export type GetServerTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServerTimeQuery = { __typename?: 'Query', getServerTime: any };

export const PushmessageFragmentFragmentDoc = gql`
    fragment pushmessageFragment on Pushmessage {
  _id
  content
  status
  type
  createdAt
  closeDate
  startDate
}
    `;
export const FileFragmentFragmentDoc = gql`
    fragment fileFragment on File {
  id
  mimeType
  name
  originalName
  title
  url
}
    `;
export const PublicCampaignDocumentFragmentForDocumentsFragmentDoc = gql`
    fragment publicCampaignDocumentFragmentForDocuments on PublicCampaignDocument {
  hidden
  title
  file {
    ...fileFragment
  }
}
    ${FileFragmentFragmentDoc}`;
export const CampaignCardDataFragmentDoc = gql`
    fragment CampaignCardData on CampaignCard {
  id
  title
  imageUrl
  caption
  website
  dates {
    publish
    open
    close
  }
  state
  followerCount
  recentReservationsCount
  reservationsCount
  recentPageViewsCount
  finishedSuccessfully
  slug
  finishedCampaignData {
    _id
    reservationsSummary {
      _id
      count
      total
      shares
      investors
    }
    slug
    raisingSharesMinimum
    raisingSharesMaximum
    raisingAmountMinimum
    raisingAmountMaximum
    status
  }
}
    `;
export const CampaignVideoDataFragmentDoc = gql`
    fragment CampaignVideoData on CampaignVideo {
  id
  url
  blobName
  name
  thumbnailUrl
  title
  description
  html
}
    `;
export const ReservationsSummaryFragmentFragmentDoc = gql`
    fragment reservationsSummaryFragment on ReservationsSummary {
  _id
  total
  count
  shares
  investors
}
    `;
export const OrganizationMemberFragmentFragmentDoc = gql`
    fragment organizationMemberFragment on OrganizationMember {
  id
  bio
  facebook
  linkedin
  name
  picture {
    ...fileFragment
  }
  role
  roles
  title
  twitter
}
    ${FileFragmentFragmentDoc}`;
export const CampaignViewFragmentDoc = gql`
    fragment campaignView on Campaign {
  _id
  title
  caption
  startDate
  closeDate
  publishDate
  closeDateRequested
  description
  descriptionHTML
  status
  slug
  chairmanEmail
  campaignOptions {
    name
    text
    checked
    labelText
  }
  concentsRequired {
    name
    label
    content
  }
  coverImage {
    ...fileFragment
  }
  companyLogoSmall {
    ...fileFragment
  }
  companyLogo {
    ...fileFragment
  }
  owners {
    name
    shares
  }
  reservationsList {
    _id
    createdAt
    shares
    signee {
      name
    }
  }
  emailReminderCount
  companyNumber
  companyName
  companyAddress
  companyPostcode
  companyCity
  companyFoundedDate
  companyURL
  companyEmail
  companyValue
  featuredVideo {
    ...CampaignVideoData
  }
  companyLogo {
    ...fileFragment
  }
  companyLogoSmall {
    ...fileFragment
  }
  reservationsSummary {
    ...reservationsSummaryFragment
  }
  accountNumber
  invoiceSent
  pricePerShare
  numberOfCurrentShares
  raisingAmountMinimum
  raisingAmountMaximum
  raisingSharesMinimum
  raisingSharesMaximum
  minimumInvestment
  maximumInvestment
  minimumShareInvestment
  maximumShareInvestment
  isHidden
  isOutdated
  shareholdersApproved
  commentCount
  filesRequired {
    ...fileFragment
  }
  filesOptional {
    ...fileFragment
  }
  team {
    ...organizationMemberFragment
  }
  board {
    ...organizationMemberFragment
  }
  partners {
    ...organizationMemberFragment
  }
  pageViews
  fundedStatus
  hasVPS
}
    ${FileFragmentFragmentDoc}
${CampaignVideoDataFragmentDoc}
${ReservationsSummaryFragmentFragmentDoc}
${OrganizationMemberFragmentFragmentDoc}`;
export const CommentViewFragmentDoc = gql`
    fragment commentView on Comment {
  _id
  content
  user {
    _id
    name
  }
  userStatus
  title
  createdAt
  parent
  deleted
  subscriptions
  likes
  isSubscribed
}
    `;
export const AddressFieldsFragmentFragmentDoc = gql`
    fragment addressFieldsFragment on ProfileAddress {
  street
  postalTown
  countryCode
  postalCode
}
    `;
export const InvestmentCompanyDataFragmentDoc = gql`
    fragment InvestmentCompanyData on Company {
  _id
  name
  organizationNumber
  organizationType
  address
  postcode
  city
  foundedDate
  userStatus
  verified
  hasNoOwners
  users {
    email
    addedBy
    owner
    removedBy
    createdAt
  }
  owners {
    _id
    name
  }
  removedUsers {
    email
    addedBy
    owner
    removedBy
    createdAt
  }
  certificates {
    _id
    date
    comment
    submitDate
    submitUserId
    processed
    approved
    archived
    processedBy
    file {
      ...fileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;
export const PepDataFragmentDoc = gql`
    fragment pepData on PepData {
  createdAt
  handledAt
  approved
}
    `;
export const Me_AllFragmentDoc = gql`
    fragment me_all on User {
  _id
  acceptedLatestTerms
  access
  bankidverified
  birthdate
  hasCampaigns
  loginBlocked
  addressFields {
    ...addressFieldsFragment
  }
  companies {
    ...InvestmentCompanyData
  }
  concents {
    name
    version
    createdAt
    updatedAt
    status
  }
  createdAt
  email
  emailVerified
  expediency {
    signedDate
    signed
    result
    testId
    outdatedApproval
    totalAttempts
  }
  hasPassword
  hasPersonnumber
  idverified
  isEntrepreneur
  isInvestor
  hasGoogleAsOnlyLoginMethod
  name
  notifyInterval
  pendingEmailChange
  pep
  pepData {
    ...pepData
  }
  phone
  profileCompleted
  receiveNewsletter
  signicat
  updatedAt
  ignoreBankIdDuplicates
  nationality
  conflictingSsnUser {
    _id
    createdAt
    email
    addressFields {
      ...addressFieldsFragment
    }
    phone
    loginBlocked
  }
}
    ${AddressFieldsFragmentFragmentDoc}
${InvestmentCompanyDataFragmentDoc}
${PepDataFragmentDoc}`;
export const ReservationFragmentFragmentDoc = gql`
    fragment reservationFragment on Reservation {
  _id
  user {
    _id
    name
  }
  signee {
    name
    type
  }
  shares
  amount
  paymentInfo {
    refcode
    duedate
  }
  createdAt
  userState
  paymentState
  shareholder_rejected
  paymentRegistrationDate
  rejectedDueToMissingPayment
  isOverdue
  rejectionInfo {
    createdAt
    createdByUserId
    status
    comment
    processedAt
    processedBy
  }
  campaignId
}
    `;
export const MyReservationsViewFragmentDoc = gql`
    fragment myReservationsView on Reservation {
  _id
  amount
  shares
  hidden
  createdAt
  userState
  paymentState
  isLocked
  campaignState
  shareholder_rejected
  rejectedDueToMissingPayment
  rejectionInfo {
    createdAt
    status
    comment
    processedAt
  }
  campaign {
    title
    _id
    slug
    closeDate
    startDate
    status
    invoiceSent
    fundedStatus
    companyName
    companyAddress
    companyPostcode
    companyCity
    companyNumber
    pricePerShare
    raisingAmountMinimum
    onboarding {
      ceoName
    }
    hasVPS
    accountNumber
    reservationsSummary {
      ...reservationsSummaryFragment
    }
  }
  taggedForSinglePurposeVehicle
  paymentInfo {
    amount
    duedate
    accountNumber
    pricePerShare
    companyName
    organizationNumber
    refcode
    vpsAndAccountToggled
  }
  paymentState
  invoiceSent
  signee {
    name
    number
    vpsAccount
    type
    addressFields {
      ...addressFieldsFragment
    }
  }
  concents {
    content
    createdAt
  }
  tags
  cancelReason {
    comment
    createdAt
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}
${AddressFieldsFragmentFragmentDoc}`;
export const ReservationsTableFragmentDoc = gql`
    fragment reservationsTable on Reservation {
  _id
  amount
  shares
  createdAt
  userState
  isLocked
  campaign {
    title
    _id
    slug
    raisingAmountMaximum
    raisingAmountMinimum
    fundedStatus
    hasVPS
    accountNumber
    reservationsSummary {
      ...reservationsSummaryFragment
    }
  }
  shareholder_rejected
  paymentInfo {
    amount
    refcode
    duedate
  }
  concents {
    content
    createdAt
  }
  signee {
    name
    email
    addressFields {
      ...addressFieldsFragment
    }
  }
  user {
    _id
    name
    email
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}
${AddressFieldsFragmentFragmentDoc}`;
export const ReservationViewFragmentDoc = gql`
    fragment reservationView on Reservation {
  _id
  amount
  isLocked
  campaign {
    title
    _id
    slug
    raisingAmountMaximum
    raisingAmountMinimum
    fundedStatus
    hasVPS
    accountNumber
    reservationsSummary {
      ...reservationsSummaryFragment
    }
  }
  campaignState
  createdAt
  paymentInfo {
    amount
    refcode
    duedate
  }
  paymentRegistrationDate
  paymentState
  shareholder_rejected
  shares
  preorder
  signee {
    name
    email
    addressFields {
      ...addressFieldsFragment
    }
  }
  user {
    _id
    name
    email
  }
  userState
}
    ${ReservationsSummaryFragmentFragmentDoc}
${AddressFieldsFragmentFragmentDoc}`;
export const ReservationByAssociationDataFragmentDoc = gql`
    fragment ReservationByAssociationData on ReservationByAssociation {
  _id
  amount
  shares
  createdAt
  userState
  hidden
  paymentState
  shareholder_rejected
  rejectedDueToMissingPayment
  rejectionInfo {
    createdAt
    status
    comment
    processedAt
  }
  campaign {
    title
    _id
    slug
    closeDate
    startDate
    status
    invoiceSent
    fundedStatus
    companyName
    companyAddress
    companyPostcode
    companyCity
    companyNumber
    pricePerShare
    raisingAmountMinimum
    onboarding {
      ceoName
    }
    hasVPS
    accountNumber
    reservationsSummary {
      ...reservationsSummaryFragment
    }
  }
  taggedForSinglePurposeVehicle
  paymentInfo {
    amount
    duedate
    accountNumber
    pricePerShare
    companyName
    organizationNumber
    refcode
    vpsAndAccountToggled
  }
  paymentState
  invoiceSent
  signee {
    name
    number
    vpsAccount
    type
    addressFields {
      ...addressFieldsFragment
    }
  }
  cancelReason {
    comment
    createdAt
  }
  user {
    _id
    name
    email
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}
${AddressFieldsFragmentFragmentDoc}`;
export const ReservationsSummaryForLivePageDataFragmentDoc = gql`
    fragment ReservationsSummaryForLivePageData on ReservationsSummary {
  _id
  count
  shares
  total
  investors
}
    `;
export const PublicDocumentFragmentFragmentDoc = gql`
    fragment publicDocumentFragment on PublicDocument {
  _id
  fileName
  fileUrl
  publishDate
  section
  title
  year
}
    `;
export const NotifyAboutErrorDocument = gql`
    mutation notifyAboutError($error: ErrorInput) {
  notifyAboutError(error: $error)
}
    `;
export type NotifyAboutErrorMutationFn = Apollo.MutationFunction<NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables>;
export type NotifyAboutErrorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables>
    } & TChildProps;
export function withNotifyAboutError<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NotifyAboutErrorMutation,
  NotifyAboutErrorMutationVariables,
  NotifyAboutErrorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables, NotifyAboutErrorProps<TChildProps, TDataName>>(NotifyAboutErrorDocument, {
      alias: 'notifyAboutError',
      ...operationOptions
    });
};

/**
 * __useNotifyAboutErrorMutation__
 *
 * To run a mutation, you first call `useNotifyAboutErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAboutErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAboutErrorMutation, { data, loading, error }] = useNotifyAboutErrorMutation({
 *   variables: {
 *      error: // value for 'error'
 *   },
 * });
 */
export function useNotifyAboutErrorMutation(baseOptions?: Apollo.MutationHookOptions<NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables>(NotifyAboutErrorDocument, options);
      }
export type NotifyAboutErrorMutationHookResult = ReturnType<typeof useNotifyAboutErrorMutation>;
export type NotifyAboutErrorMutationResult = Apollo.MutationResult<NotifyAboutErrorMutation>;
export type NotifyAboutErrorMutationOptions = Apollo.BaseMutationOptions<NotifyAboutErrorMutation, NotifyAboutErrorMutationVariables>;
export const GetCampaignCardDataDocument = gql`
    query GetCampaignCardData($campaignId: ID!) {
  reducedCampaignDataForCampaignCard(campaignId: $campaignId) {
    _id
    reservationsSummary {
      total
      shares
      investors
    }
    slug
    raisingSharesMinimum
    raisingSharesMaximum
    raisingAmountMinimum
    raisingAmountMaximum
    status
  }
  visitorSettings(campaignId: $campaignId) {
    _id
    acceptsPreorderOffers
    approvedForPreorder
    hasEmailReminder
    isOwner
    isContributor
  }
}
    `;
export type GetCampaignCardDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>
    } & TChildProps;
export function withGetCampaignCardData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCampaignCardDataQuery,
  GetCampaignCardDataQueryVariables,
  GetCampaignCardDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables, GetCampaignCardDataProps<TChildProps, TDataName>>(GetCampaignCardDataDocument, {
      alias: 'getCampaignCardData',
      ...operationOptions
    });
};

/**
 * __useGetCampaignCardDataQuery__
 *
 * To run a query within a React component, call `useGetCampaignCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignCardDataQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignCardDataQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>(GetCampaignCardDataDocument, options);
      }
export function useGetCampaignCardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>(GetCampaignCardDataDocument, options);
        }
export type GetCampaignCardDataQueryHookResult = ReturnType<typeof useGetCampaignCardDataQuery>;
export type GetCampaignCardDataLazyQueryHookResult = ReturnType<typeof useGetCampaignCardDataLazyQuery>;
export type GetCampaignCardDataQueryResult = Apollo.QueryResult<GetCampaignCardDataQuery, GetCampaignCardDataQueryVariables>;
export const EditEmailPreferencesDocument = gql`
    mutation EditEmailPreferences($input: EmailPreferencesInput!) {
  editEmailPreferences(input: $input)
}
    `;
export type EditEmailPreferencesMutationFn = Apollo.MutationFunction<EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables>;
export type EditEmailPreferencesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables>
    } & TChildProps;
export function withEditEmailPreferences<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditEmailPreferencesMutation,
  EditEmailPreferencesMutationVariables,
  EditEmailPreferencesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables, EditEmailPreferencesProps<TChildProps, TDataName>>(EditEmailPreferencesDocument, {
      alias: 'editEmailPreferences',
      ...operationOptions
    });
};

/**
 * __useEditEmailPreferencesMutation__
 *
 * To run a mutation, you first call `useEditEmailPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEmailPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEmailPreferencesMutation, { data, loading, error }] = useEditEmailPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEmailPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables>(EditEmailPreferencesDocument, options);
      }
export type EditEmailPreferencesMutationHookResult = ReturnType<typeof useEditEmailPreferencesMutation>;
export type EditEmailPreferencesMutationResult = Apollo.MutationResult<EditEmailPreferencesMutation>;
export type EditEmailPreferencesMutationOptions = Apollo.BaseMutationOptions<EditEmailPreferencesMutation, EditEmailPreferencesMutationVariables>;
export const SignExpediencyDocument = gql`
    mutation SignExpediency($_id: ID, $approved: Boolean) {
  signExpediency(_id: $_id, approved: $approved) {
    _id
    expediency {
      signedDate
      signed
      result
      testId
      outdatedApproval
      totalAttempts
    }
  }
}
    `;
export type SignExpediencyMutationFn = Apollo.MutationFunction<SignExpediencyMutation, SignExpediencyMutationVariables>;
export type SignExpediencyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SignExpediencyMutation, SignExpediencyMutationVariables>
    } & TChildProps;
export function withSignExpediency<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SignExpediencyMutation,
  SignExpediencyMutationVariables,
  SignExpediencyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SignExpediencyMutation, SignExpediencyMutationVariables, SignExpediencyProps<TChildProps, TDataName>>(SignExpediencyDocument, {
      alias: 'signExpediency',
      ...operationOptions
    });
};

/**
 * __useSignExpediencyMutation__
 *
 * To run a mutation, you first call `useSignExpediencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignExpediencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signExpediencyMutation, { data, loading, error }] = useSignExpediencyMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useSignExpediencyMutation(baseOptions?: Apollo.MutationHookOptions<SignExpediencyMutation, SignExpediencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignExpediencyMutation, SignExpediencyMutationVariables>(SignExpediencyDocument, options);
      }
export type SignExpediencyMutationHookResult = ReturnType<typeof useSignExpediencyMutation>;
export type SignExpediencyMutationResult = Apollo.MutationResult<SignExpediencyMutation>;
export type SignExpediencyMutationOptions = Apollo.BaseMutationOptions<SignExpediencyMutation, SignExpediencyMutationVariables>;
export const SubmitExpediencyDocument = gql`
    mutation SubmitExpediency($input: ExpediencyInput) {
  submitExpediency(input: $input) {
    _id
    fields {
      id
      answer
    }
  }
}
    `;
export type SubmitExpediencyMutationFn = Apollo.MutationFunction<SubmitExpediencyMutation, SubmitExpediencyMutationVariables>;
export type SubmitExpediencyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SubmitExpediencyMutation, SubmitExpediencyMutationVariables>
    } & TChildProps;
export function withSubmitExpediency<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubmitExpediencyMutation,
  SubmitExpediencyMutationVariables,
  SubmitExpediencyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SubmitExpediencyMutation, SubmitExpediencyMutationVariables, SubmitExpediencyProps<TChildProps, TDataName>>(SubmitExpediencyDocument, {
      alias: 'submitExpediency',
      ...operationOptions
    });
};

/**
 * __useSubmitExpediencyMutation__
 *
 * To run a mutation, you first call `useSubmitExpediencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitExpediencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitExpediencyMutation, { data, loading, error }] = useSubmitExpediencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitExpediencyMutation(baseOptions?: Apollo.MutationHookOptions<SubmitExpediencyMutation, SubmitExpediencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitExpediencyMutation, SubmitExpediencyMutationVariables>(SubmitExpediencyDocument, options);
      }
export type SubmitExpediencyMutationHookResult = ReturnType<typeof useSubmitExpediencyMutation>;
export type SubmitExpediencyMutationResult = Apollo.MutationResult<SubmitExpediencyMutation>;
export type SubmitExpediencyMutationOptions = Apollo.BaseMutationOptions<SubmitExpediencyMutation, SubmitExpediencyMutationVariables>;
export const FetchDataForFollowDialogDocument = gql`
    query FetchDataForFollowDialog($campaignId: ID!) {
  Campaign(_id: $campaignId) {
    _id
    slug
    title
    caption
    emailReminderCount
    pricePerShare
    coverImage {
      ...fileFragment
    }
  }
  campaignCardBySlugOrId(campaignId: $campaignId) {
    id
    followerCount
  }
  visitorSettings(campaignId: $campaignId) {
    _id
    isLoggedIn
    hasEmailReminder
    approvedForPreorder
    acceptsPreorderOffers
  }
  me {
    _id
    email
  }
  fetchComingSoonItem(campaignId: $campaignId) {
    _id
    title
    caption
    coverImage {
      ...fileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;
export type FetchDataForFollowDialogProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>
    } & TChildProps;
export function withFetchDataForFollowDialog<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchDataForFollowDialogQuery,
  FetchDataForFollowDialogQueryVariables,
  FetchDataForFollowDialogProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables, FetchDataForFollowDialogProps<TChildProps, TDataName>>(FetchDataForFollowDialogDocument, {
      alias: 'fetchDataForFollowDialog',
      ...operationOptions
    });
};

/**
 * __useFetchDataForFollowDialogQuery__
 *
 * To run a query within a React component, call `useFetchDataForFollowDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDataForFollowDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDataForFollowDialogQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useFetchDataForFollowDialogQuery(baseOptions: Apollo.QueryHookOptions<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>(FetchDataForFollowDialogDocument, options);
      }
export function useFetchDataForFollowDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>(FetchDataForFollowDialogDocument, options);
        }
export type FetchDataForFollowDialogQueryHookResult = ReturnType<typeof useFetchDataForFollowDialogQuery>;
export type FetchDataForFollowDialogLazyQueryHookResult = ReturnType<typeof useFetchDataForFollowDialogLazyQuery>;
export type FetchDataForFollowDialogQueryResult = Apollo.QueryResult<FetchDataForFollowDialogQuery, FetchDataForFollowDialogQueryVariables>;
export const FetchCampaignFollowerCountDocument = gql`
    query FetchCampaignFollowerCount($_id: ID!) {
  Campaign(_id: $_id) {
    _id
    emailReminderCount
  }
}
    `;
export type FetchCampaignFollowerCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>
    } & TChildProps;
export function withFetchCampaignFollowerCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchCampaignFollowerCountQuery,
  FetchCampaignFollowerCountQueryVariables,
  FetchCampaignFollowerCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables, FetchCampaignFollowerCountProps<TChildProps, TDataName>>(FetchCampaignFollowerCountDocument, {
      alias: 'fetchCampaignFollowerCount',
      ...operationOptions
    });
};

/**
 * __useFetchCampaignFollowerCountQuery__
 *
 * To run a query within a React component, call `useFetchCampaignFollowerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignFollowerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignFollowerCountQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFetchCampaignFollowerCountQuery(baseOptions: Apollo.QueryHookOptions<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>(FetchCampaignFollowerCountDocument, options);
      }
export function useFetchCampaignFollowerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>(FetchCampaignFollowerCountDocument, options);
        }
export type FetchCampaignFollowerCountQueryHookResult = ReturnType<typeof useFetchCampaignFollowerCountQuery>;
export type FetchCampaignFollowerCountLazyQueryHookResult = ReturnType<typeof useFetchCampaignFollowerCountLazyQuery>;
export type FetchCampaignFollowerCountQueryResult = Apollo.QueryResult<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>;
export const RegisterEmailReminderCampaignDocument = gql`
    mutation RegisterEmailReminderCampaign($campaignId: ID, $email: String, $acceptPreorderOffer: Boolean) {
  registerEmailReminderCampaign(
    campaignId: $campaignId
    email: $email
    acceptPreorderOffer: $acceptPreorderOffer
  )
}
    `;
export type RegisterEmailReminderCampaignMutationFn = Apollo.MutationFunction<RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables>;
export type RegisterEmailReminderCampaignProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables>
    } & TChildProps;
export function withRegisterEmailReminderCampaign<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegisterEmailReminderCampaignMutation,
  RegisterEmailReminderCampaignMutationVariables,
  RegisterEmailReminderCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables, RegisterEmailReminderCampaignProps<TChildProps, TDataName>>(RegisterEmailReminderCampaignDocument, {
      alias: 'registerEmailReminderCampaign',
      ...operationOptions
    });
};

/**
 * __useRegisterEmailReminderCampaignMutation__
 *
 * To run a mutation, you first call `useRegisterEmailReminderCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterEmailReminderCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerEmailReminderCampaignMutation, { data, loading, error }] = useRegisterEmailReminderCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      email: // value for 'email'
 *      acceptPreorderOffer: // value for 'acceptPreorderOffer'
 *   },
 * });
 */
export function useRegisterEmailReminderCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables>(RegisterEmailReminderCampaignDocument, options);
      }
export type RegisterEmailReminderCampaignMutationHookResult = ReturnType<typeof useRegisterEmailReminderCampaignMutation>;
export type RegisterEmailReminderCampaignMutationResult = Apollo.MutationResult<RegisterEmailReminderCampaignMutation>;
export type RegisterEmailReminderCampaignMutationOptions = Apollo.BaseMutationOptions<RegisterEmailReminderCampaignMutation, RegisterEmailReminderCampaignMutationVariables>;
export const UnregisterEmailReminderCampaignDocument = gql`
    mutation UnregisterEmailReminderCampaign($campaignId: ID) {
  unregisterEmailReminderCampaign(campaignId: $campaignId)
}
    `;
export type UnregisterEmailReminderCampaignMutationFn = Apollo.MutationFunction<UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables>;
export type UnregisterEmailReminderCampaignProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables>
    } & TChildProps;
export function withUnregisterEmailReminderCampaign<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnregisterEmailReminderCampaignMutation,
  UnregisterEmailReminderCampaignMutationVariables,
  UnregisterEmailReminderCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables, UnregisterEmailReminderCampaignProps<TChildProps, TDataName>>(UnregisterEmailReminderCampaignDocument, {
      alias: 'unregisterEmailReminderCampaign',
      ...operationOptions
    });
};

/**
 * __useUnregisterEmailReminderCampaignMutation__
 *
 * To run a mutation, you first call `useUnregisterEmailReminderCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterEmailReminderCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterEmailReminderCampaignMutation, { data, loading, error }] = useUnregisterEmailReminderCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUnregisterEmailReminderCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables>(UnregisterEmailReminderCampaignDocument, options);
      }
export type UnregisterEmailReminderCampaignMutationHookResult = ReturnType<typeof useUnregisterEmailReminderCampaignMutation>;
export type UnregisterEmailReminderCampaignMutationResult = Apollo.MutationResult<UnregisterEmailReminderCampaignMutation>;
export type UnregisterEmailReminderCampaignMutationOptions = Apollo.BaseMutationOptions<UnregisterEmailReminderCampaignMutation, UnregisterEmailReminderCampaignMutationVariables>;
export const GetPushMessagesDocument = gql`
    query GetPushMessages {
  getPushmessages {
    ...pushmessageFragment
  }
}
    ${PushmessageFragmentFragmentDoc}`;
export type GetPushMessagesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPushMessagesQuery, GetPushMessagesQueryVariables>
    } & TChildProps;
export function withGetPushMessages<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPushMessagesQuery,
  GetPushMessagesQueryVariables,
  GetPushMessagesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPushMessagesQuery, GetPushMessagesQueryVariables, GetPushMessagesProps<TChildProps, TDataName>>(GetPushMessagesDocument, {
      alias: 'getPushMessages',
      ...operationOptions
    });
};

/**
 * __useGetPushMessagesQuery__
 *
 * To run a query within a React component, call `useGetPushMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPushMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPushMessagesQuery, GetPushMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPushMessagesQuery, GetPushMessagesQueryVariables>(GetPushMessagesDocument, options);
      }
export function useGetPushMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPushMessagesQuery, GetPushMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPushMessagesQuery, GetPushMessagesQueryVariables>(GetPushMessagesDocument, options);
        }
export type GetPushMessagesQueryHookResult = ReturnType<typeof useGetPushMessagesQuery>;
export type GetPushMessagesLazyQueryHookResult = ReturnType<typeof useGetPushMessagesLazyQuery>;
export type GetPushMessagesQueryResult = Apollo.QueryResult<GetPushMessagesQuery, GetPushMessagesQueryVariables>;
export const PushmessageUpdateDocument = gql`
    subscription PushmessageUpdate {
  pushmessageUpdate {
    ...pushmessageFragment
  }
}
    ${PushmessageFragmentFragmentDoc}`;
export type PushmessageUpdateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PushmessageUpdateSubscription, PushmessageUpdateSubscriptionVariables>
    } & TChildProps;
export function withPushmessageUpdate<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PushmessageUpdateSubscription,
  PushmessageUpdateSubscriptionVariables,
  PushmessageUpdateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, PushmessageUpdateSubscription, PushmessageUpdateSubscriptionVariables, PushmessageUpdateProps<TChildProps, TDataName>>(PushmessageUpdateDocument, {
      alias: 'pushmessageUpdate',
      ...operationOptions
    });
};

/**
 * __usePushmessageUpdateSubscription__
 *
 * To run a query within a React component, call `usePushmessageUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushmessageUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushmessageUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePushmessageUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PushmessageUpdateSubscription, PushmessageUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PushmessageUpdateSubscription, PushmessageUpdateSubscriptionVariables>(PushmessageUpdateDocument, options);
      }
export type PushmessageUpdateSubscriptionHookResult = ReturnType<typeof usePushmessageUpdateSubscription>;
export type PushmessageUpdateSubscriptionResult = Apollo.SubscriptionResult<PushmessageUpdateSubscription>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($token: String) {
  verifyEmail(token: $token) {
    success
    message
    code
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;
export type VerifyEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>
    } & TChildProps;
export function withVerifyEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  VerifyEmailMutation,
  VerifyEmailMutationVariables,
  VerifyEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, VerifyEmailMutation, VerifyEmailMutationVariables, VerifyEmailProps<TChildProps, TDataName>>(VerifyEmailDocument, {
      alias: 'verifyEmail',
      ...operationOptions
    });
};

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const UserWithServiceExistsDocument = gql`
    query UserWithServiceExists($serviceName: String!, $token: String!) {
  userWithServiceExists(serviceName: $serviceName, token: $token) {
    existed
  }
}
    `;
export type UserWithServiceExistsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>
    } & TChildProps;
export function withUserWithServiceExists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserWithServiceExistsQuery,
  UserWithServiceExistsQueryVariables,
  UserWithServiceExistsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables, UserWithServiceExistsProps<TChildProps, TDataName>>(UserWithServiceExistsDocument, {
      alias: 'userWithServiceExists',
      ...operationOptions
    });
};

/**
 * __useUserWithServiceExistsQuery__
 *
 * To run a query within a React component, call `useUserWithServiceExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithServiceExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithServiceExistsQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserWithServiceExistsQuery(baseOptions: Apollo.QueryHookOptions<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>(UserWithServiceExistsDocument, options);
      }
export function useUserWithServiceExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>(UserWithServiceExistsDocument, options);
        }
export type UserWithServiceExistsQueryHookResult = ReturnType<typeof useUserWithServiceExistsQuery>;
export type UserWithServiceExistsLazyQueryHookResult = ReturnType<typeof useUserWithServiceExistsLazyQuery>;
export type UserWithServiceExistsQueryResult = Apollo.QueryResult<UserWithServiceExistsQuery, UserWithServiceExistsQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  passwordReset(email: $email) {
    success
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export type ResetPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>
    } & TChildProps;
export function withResetPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  ResetPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResetPasswordMutation, ResetPasswordMutationVariables, ResetPasswordProps<TChildProps, TDataName>>(ResetPasswordDocument, {
      alias: 'resetPassword',
      ...operationOptions
    });
};

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RequestEmailVerificationDocument = gql`
    mutation RequestEmailVerification {
  requestEmailVerification
}
    `;
export type RequestEmailVerificationMutationFn = Apollo.MutationFunction<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>;
export type RequestEmailVerificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>
    } & TChildProps;
export function withRequestEmailVerification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestEmailVerificationMutation,
  RequestEmailVerificationMutationVariables,
  RequestEmailVerificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables, RequestEmailVerificationProps<TChildProps, TDataName>>(RequestEmailVerificationDocument, {
      alias: 'requestEmailVerification',
      ...operationOptions
    });
};

/**
 * __useRequestEmailVerificationMutation__
 *
 * To run a mutation, you first call `useRequestEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailVerificationMutation, { data, loading, error }] = useRequestEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>(RequestEmailVerificationDocument, options);
      }
export type RequestEmailVerificationMutationHookResult = ReturnType<typeof useRequestEmailVerificationMutation>;
export type RequestEmailVerificationMutationResult = Apollo.MutationResult<RequestEmailVerificationMutation>;
export type RequestEmailVerificationMutationOptions = Apollo.BaseMutationOptions<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>;
export const ToggleCommentLikeDocument = gql`
    mutation ToggleCommentLike($commentId: ID) {
  toggleCommentLike(commentId: $commentId) {
    _id
    likes
  }
}
    `;
export type ToggleCommentLikeMutationFn = Apollo.MutationFunction<ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables>;
export type ToggleCommentLikeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables>
    } & TChildProps;
export function withToggleCommentLike<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToggleCommentLikeMutation,
  ToggleCommentLikeMutationVariables,
  ToggleCommentLikeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables, ToggleCommentLikeProps<TChildProps, TDataName>>(ToggleCommentLikeDocument, {
      alias: 'toggleCommentLike',
      ...operationOptions
    });
};

/**
 * __useToggleCommentLikeMutation__
 *
 * To run a mutation, you first call `useToggleCommentLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCommentLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCommentLikeMutation, { data, loading, error }] = useToggleCommentLikeMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useToggleCommentLikeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables>(ToggleCommentLikeDocument, options);
      }
export type ToggleCommentLikeMutationHookResult = ReturnType<typeof useToggleCommentLikeMutation>;
export type ToggleCommentLikeMutationResult = Apollo.MutationResult<ToggleCommentLikeMutation>;
export type ToggleCommentLikeMutationOptions = Apollo.BaseMutationOptions<ToggleCommentLikeMutation, ToggleCommentLikeMutationVariables>;
export const UpdateCommentSubscriptionDocument = gql`
    mutation UpdateCommentSubscription($commentID: ID, $subscribed: Boolean) {
  updateCommentSubscription(commentID: $commentID, subscribed: $subscribed) {
    _id
    isSubscribed
  }
}
    `;
export type UpdateCommentSubscriptionMutationFn = Apollo.MutationFunction<UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables>;
export type UpdateCommentSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables>
    } & TChildProps;
export function withUpdateCommentSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCommentSubscriptionMutation,
  UpdateCommentSubscriptionMutationVariables,
  UpdateCommentSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables, UpdateCommentSubscriptionProps<TChildProps, TDataName>>(UpdateCommentSubscriptionDocument, {
      alias: 'updateCommentSubscription',
      ...operationOptions
    });
};

/**
 * __useUpdateCommentSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCommentSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentSubscriptionMutation, { data, loading, error }] = useUpdateCommentSubscriptionMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useUpdateCommentSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables>(UpdateCommentSubscriptionDocument, options);
      }
export type UpdateCommentSubscriptionMutationHookResult = ReturnType<typeof useUpdateCommentSubscriptionMutation>;
export type UpdateCommentSubscriptionMutationResult = Apollo.MutationResult<UpdateCommentSubscriptionMutation>;
export type UpdateCommentSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateCommentSubscriptionMutation, UpdateCommentSubscriptionMutationVariables>;
export const FetchCampaignDataForCommentsDocument = gql`
    query FetchCampaignDataForComments($_id: ID!) {
  Campaign(_id: $_id) {
    _id
    filesRequired {
      ...fileFragment
    }
    closeDate
    user {
      _id
    }
    companyLogo {
      ...fileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;
export type FetchCampaignDataForCommentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>
    } & TChildProps;
export function withFetchCampaignDataForComments<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchCampaignDataForCommentsQuery,
  FetchCampaignDataForCommentsQueryVariables,
  FetchCampaignDataForCommentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables, FetchCampaignDataForCommentsProps<TChildProps, TDataName>>(FetchCampaignDataForCommentsDocument, {
      alias: 'fetchCampaignDataForComments',
      ...operationOptions
    });
};

/**
 * __useFetchCampaignDataForCommentsQuery__
 *
 * To run a query within a React component, call `useFetchCampaignDataForCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignDataForCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignDataForCommentsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFetchCampaignDataForCommentsQuery(baseOptions: Apollo.QueryHookOptions<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>(FetchCampaignDataForCommentsDocument, options);
      }
export function useFetchCampaignDataForCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>(FetchCampaignDataForCommentsDocument, options);
        }
export type FetchCampaignDataForCommentsQueryHookResult = ReturnType<typeof useFetchCampaignDataForCommentsQuery>;
export type FetchCampaignDataForCommentsLazyQueryHookResult = ReturnType<typeof useFetchCampaignDataForCommentsLazyQuery>;
export type FetchCampaignDataForCommentsQueryResult = Apollo.QueryResult<FetchCampaignDataForCommentsQuery, FetchCampaignDataForCommentsQueryVariables>;
export const FetchCommentsDocument = gql`
    query FetchComments($_id: ID!) {
  allCommentsByCampaignId(_id: $_id) {
    ...commentView
  }
}
    ${CommentViewFragmentDoc}`;
export type FetchCommentsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchCommentsQuery, FetchCommentsQueryVariables>
    } & TChildProps;
export function withFetchComments<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchCommentsQuery,
  FetchCommentsQueryVariables,
  FetchCommentsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchCommentsQuery, FetchCommentsQueryVariables, FetchCommentsProps<TChildProps, TDataName>>(FetchCommentsDocument, {
      alias: 'fetchComments',
      ...operationOptions
    });
};

/**
 * __useFetchCommentsQuery__
 *
 * To run a query within a React component, call `useFetchCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCommentsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useFetchCommentsQuery(baseOptions: Apollo.QueryHookOptions<FetchCommentsQuery, FetchCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCommentsQuery, FetchCommentsQueryVariables>(FetchCommentsDocument, options);
      }
export function useFetchCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCommentsQuery, FetchCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCommentsQuery, FetchCommentsQueryVariables>(FetchCommentsDocument, options);
        }
export type FetchCommentsQueryHookResult = ReturnType<typeof useFetchCommentsQuery>;
export type FetchCommentsLazyQueryHookResult = ReturnType<typeof useFetchCommentsLazyQuery>;
export type FetchCommentsQueryResult = Apollo.QueryResult<FetchCommentsQuery, FetchCommentsQueryVariables>;
export const CommentUpdatedDocument = gql`
    subscription CommentUpdated($campaignId: ID) {
  commentUpdated(campaignId: $campaignId) {
    ...commentView
  }
}
    ${CommentViewFragmentDoc}`;
export type CommentUpdatedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables>
    } & TChildProps;
export function withCommentUpdated<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CommentUpdatedSubscription,
  CommentUpdatedSubscriptionVariables,
  CommentUpdatedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables, CommentUpdatedProps<TChildProps, TDataName>>(CommentUpdatedDocument, {
      alias: 'commentUpdated',
      ...operationOptions
    });
};

/**
 * __useCommentUpdatedSubscription__
 *
 * To run a query within a React component, call `useCommentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentUpdatedSubscription({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCommentUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentUpdatedSubscription, CommentUpdatedSubscriptionVariables>(CommentUpdatedDocument, options);
      }
export type CommentUpdatedSubscriptionHookResult = ReturnType<typeof useCommentUpdatedSubscription>;
export type CommentUpdatedSubscriptionResult = Apollo.SubscriptionResult<CommentUpdatedSubscription>;
export const CreateCommentDocument = gql`
    mutation CreateComment($campaignId: ID!, $input: CreateCommentInput!) {
  addComment(campaignId: $campaignId, input: $input) {
    _id
    content
    user {
      name
      _id
    }
    title
    parent
    createdAt
    subscriptions
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;
export type CreateCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>
    } & TChildProps;
export function withCreateComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCommentMutation,
  CreateCommentMutationVariables,
  CreateCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCommentMutation, CreateCommentMutationVariables, CreateCommentProps<TChildProps, TDataName>>(CreateCommentDocument, {
      alias: 'createComment',
      ...operationOptions
    });
};

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const GetPublicCampaignDocumentDataDocument = gql`
    query GetPublicCampaignDocumentData($campaignId: ID!) {
  Campaign(_id: $campaignId) {
    _id
    filesRequiredData {
      ...publicCampaignDocumentFragmentForDocuments
    }
    filesOptionalData {
      ...publicCampaignDocumentFragmentForDocuments
    }
  }
}
    ${PublicCampaignDocumentFragmentForDocumentsFragmentDoc}`;
export type GetPublicCampaignDocumentDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>
    } & TChildProps;
export function withGetPublicCampaignDocumentData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPublicCampaignDocumentDataQuery,
  GetPublicCampaignDocumentDataQueryVariables,
  GetPublicCampaignDocumentDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables, GetPublicCampaignDocumentDataProps<TChildProps, TDataName>>(GetPublicCampaignDocumentDataDocument, {
      alias: 'getPublicCampaignDocumentData',
      ...operationOptions
    });
};

/**
 * __useGetPublicCampaignDocumentDataQuery__
 *
 * To run a query within a React component, call `useGetPublicCampaignDocumentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCampaignDocumentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCampaignDocumentDataQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetPublicCampaignDocumentDataQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>(GetPublicCampaignDocumentDataDocument, options);
      }
export function useGetPublicCampaignDocumentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>(GetPublicCampaignDocumentDataDocument, options);
        }
export type GetPublicCampaignDocumentDataQueryHookResult = ReturnType<typeof useGetPublicCampaignDocumentDataQuery>;
export type GetPublicCampaignDocumentDataLazyQueryHookResult = ReturnType<typeof useGetPublicCampaignDocumentDataLazyQuery>;
export type GetPublicCampaignDocumentDataQueryResult = Apollo.QueryResult<GetPublicCampaignDocumentDataQuery, GetPublicCampaignDocumentDataQueryVariables>;
export const AddInvestmentsPageVisitorDocument = gql`
    mutation AddInvestmentsPageVisitor($campaignId: String!) {
  addInvestmentsPageVisitor(campaignId: $campaignId)
}
    `;
export type AddInvestmentsPageVisitorMutationFn = Apollo.MutationFunction<AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables>;
export type AddInvestmentsPageVisitorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables>
    } & TChildProps;
export function withAddInvestmentsPageVisitor<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddInvestmentsPageVisitorMutation,
  AddInvestmentsPageVisitorMutationVariables,
  AddInvestmentsPageVisitorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables, AddInvestmentsPageVisitorProps<TChildProps, TDataName>>(AddInvestmentsPageVisitorDocument, {
      alias: 'addInvestmentsPageVisitor',
      ...operationOptions
    });
};

/**
 * __useAddInvestmentsPageVisitorMutation__
 *
 * To run a mutation, you first call `useAddInvestmentsPageVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvestmentsPageVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvestmentsPageVisitorMutation, { data, loading, error }] = useAddInvestmentsPageVisitorMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useAddInvestmentsPageVisitorMutation(baseOptions?: Apollo.MutationHookOptions<AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables>(AddInvestmentsPageVisitorDocument, options);
      }
export type AddInvestmentsPageVisitorMutationHookResult = ReturnType<typeof useAddInvestmentsPageVisitorMutation>;
export type AddInvestmentsPageVisitorMutationResult = Apollo.MutationResult<AddInvestmentsPageVisitorMutation>;
export type AddInvestmentsPageVisitorMutationOptions = Apollo.BaseMutationOptions<AddInvestmentsPageVisitorMutation, AddInvestmentsPageVisitorMutationVariables>;
export const PreorderPermissionDocument = gql`
    query PreorderPermission($campaignId: ID) {
  visitorSettings(campaignId: $campaignId) {
    _id
    approvedForPreorder
    hasEmailReminder
    isOwner
    isContributor
  }
}
    `;
export type PreorderPermissionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PreorderPermissionQuery, PreorderPermissionQueryVariables>
    } & TChildProps;
export function withPreorderPermission<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PreorderPermissionQuery,
  PreorderPermissionQueryVariables,
  PreorderPermissionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PreorderPermissionQuery, PreorderPermissionQueryVariables, PreorderPermissionProps<TChildProps, TDataName>>(PreorderPermissionDocument, {
      alias: 'preorderPermission',
      ...operationOptions
    });
};

/**
 * __usePreorderPermissionQuery__
 *
 * To run a query within a React component, call `usePreorderPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreorderPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreorderPermissionQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePreorderPermissionQuery(baseOptions?: Apollo.QueryHookOptions<PreorderPermissionQuery, PreorderPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreorderPermissionQuery, PreorderPermissionQueryVariables>(PreorderPermissionDocument, options);
      }
export function usePreorderPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreorderPermissionQuery, PreorderPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreorderPermissionQuery, PreorderPermissionQueryVariables>(PreorderPermissionDocument, options);
        }
export type PreorderPermissionQueryHookResult = ReturnType<typeof usePreorderPermissionQuery>;
export type PreorderPermissionLazyQueryHookResult = ReturnType<typeof usePreorderPermissionLazyQuery>;
export type PreorderPermissionQueryResult = Apollo.QueryResult<PreorderPermissionQuery, PreorderPermissionQueryVariables>;
export const FetchSigneeMaxSharesDocument = gql`
    query FetchSigneeMaxShares($campaignId: ID!, $organizationNumber: String) {
  fetchSigneeDataForCampaign(
    campaignId: $campaignId
    organizationNumber: $organizationNumber
  ) {
    signeeCurrentShares
    totalSharesLeft
    campaignMax
    minPerSignee
    maxPerSignee
    maxSharesLeft
  }
}
    `;
export type FetchSigneeMaxSharesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>
    } & TChildProps;
export function withFetchSigneeMaxShares<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchSigneeMaxSharesQuery,
  FetchSigneeMaxSharesQueryVariables,
  FetchSigneeMaxSharesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables, FetchSigneeMaxSharesProps<TChildProps, TDataName>>(FetchSigneeMaxSharesDocument, {
      alias: 'fetchSigneeMaxShares',
      ...operationOptions
    });
};

/**
 * __useFetchSigneeMaxSharesQuery__
 *
 * To run a query within a React component, call `useFetchSigneeMaxSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSigneeMaxSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSigneeMaxSharesQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      organizationNumber: // value for 'organizationNumber'
 *   },
 * });
 */
export function useFetchSigneeMaxSharesQuery(baseOptions: Apollo.QueryHookOptions<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>(FetchSigneeMaxSharesDocument, options);
      }
export function useFetchSigneeMaxSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>(FetchSigneeMaxSharesDocument, options);
        }
export type FetchSigneeMaxSharesQueryHookResult = ReturnType<typeof useFetchSigneeMaxSharesQuery>;
export type FetchSigneeMaxSharesLazyQueryHookResult = ReturnType<typeof useFetchSigneeMaxSharesLazyQuery>;
export type FetchSigneeMaxSharesQueryResult = Apollo.QueryResult<FetchSigneeMaxSharesQuery, FetchSigneeMaxSharesQueryVariables>;
export const ReserveSharesDocument = gql`
    mutation ReserveShares($campaignId: ID!, $input: ReserveSharesInput!) {
  reserveShares(campaignId: $campaignId, input: $input) {
    _id
    shares
    campaign {
      _id
      reservationsSummary {
        ...reservationsSummaryFragment
      }
    }
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}`;
export type ReserveSharesMutationFn = Apollo.MutationFunction<ReserveSharesMutation, ReserveSharesMutationVariables>;
export type ReserveSharesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ReserveSharesMutation, ReserveSharesMutationVariables>
    } & TChildProps;
export function withReserveShares<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReserveSharesMutation,
  ReserveSharesMutationVariables,
  ReserveSharesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReserveSharesMutation, ReserveSharesMutationVariables, ReserveSharesProps<TChildProps, TDataName>>(ReserveSharesDocument, {
      alias: 'reserveShares',
      ...operationOptions
    });
};

/**
 * __useReserveSharesMutation__
 *
 * To run a mutation, you first call `useReserveSharesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveSharesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveSharesMutation, { data, loading, error }] = useReserveSharesMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReserveSharesMutation(baseOptions?: Apollo.MutationHookOptions<ReserveSharesMutation, ReserveSharesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveSharesMutation, ReserveSharesMutationVariables>(ReserveSharesDocument, options);
      }
export type ReserveSharesMutationHookResult = ReturnType<typeof useReserveSharesMutation>;
export type ReserveSharesMutationResult = Apollo.MutationResult<ReserveSharesMutation>;
export type ReserveSharesMutationOptions = Apollo.BaseMutationOptions<ReserveSharesMutation, ReserveSharesMutationVariables>;
export const SelfreportItemsInCampaignDocument = gql`
    query SelfreportItemsInCampaign($campaignId: ID!) {
  Campaign(_id: $campaignId) {
    _id
    selfreportlist {
      id
      name
      description
      comment
      type
      values
      answerDetails
    }
  }
}
    `;
export type SelfreportItemsInCampaignProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>
    } & TChildProps;
export function withSelfreportItemsInCampaign<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SelfreportItemsInCampaignQuery,
  SelfreportItemsInCampaignQueryVariables,
  SelfreportItemsInCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables, SelfreportItemsInCampaignProps<TChildProps, TDataName>>(SelfreportItemsInCampaignDocument, {
      alias: 'selfreportItemsInCampaign',
      ...operationOptions
    });
};

/**
 * __useSelfreportItemsInCampaignQuery__
 *
 * To run a query within a React component, call `useSelfreportItemsInCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfreportItemsInCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfreportItemsInCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSelfreportItemsInCampaignQuery(baseOptions: Apollo.QueryHookOptions<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>(SelfreportItemsInCampaignDocument, options);
      }
export function useSelfreportItemsInCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>(SelfreportItemsInCampaignDocument, options);
        }
export type SelfreportItemsInCampaignQueryHookResult = ReturnType<typeof useSelfreportItemsInCampaignQuery>;
export type SelfreportItemsInCampaignLazyQueryHookResult = ReturnType<typeof useSelfreportItemsInCampaignLazyQuery>;
export type SelfreportItemsInCampaignQueryResult = Apollo.QueryResult<SelfreportItemsInCampaignQuery, SelfreportItemsInCampaignQueryVariables>;
export const CheckForNewerCampaignsDocument = gql`
    query CheckForNewerCampaigns($campaignId: ID) {
  getSlugForNewestCampaign(campaignId: $campaignId)
}
    `;
export type CheckForNewerCampaignsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>
    } & TChildProps;
export function withCheckForNewerCampaigns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CheckForNewerCampaignsQuery,
  CheckForNewerCampaignsQueryVariables,
  CheckForNewerCampaignsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables, CheckForNewerCampaignsProps<TChildProps, TDataName>>(CheckForNewerCampaignsDocument, {
      alias: 'checkForNewerCampaigns',
      ...operationOptions
    });
};

/**
 * __useCheckForNewerCampaignsQuery__
 *
 * To run a query within a React component, call `useCheckForNewerCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForNewerCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForNewerCampaignsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCheckForNewerCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>(CheckForNewerCampaignsDocument, options);
      }
export function useCheckForNewerCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>(CheckForNewerCampaignsDocument, options);
        }
export type CheckForNewerCampaignsQueryHookResult = ReturnType<typeof useCheckForNewerCampaignsQuery>;
export type CheckForNewerCampaignsLazyQueryHookResult = ReturnType<typeof useCheckForNewerCampaignsLazyQuery>;
export type CheckForNewerCampaignsQueryResult = Apollo.QueryResult<CheckForNewerCampaignsQuery, CheckForNewerCampaignsQueryVariables>;
export const GetBlobUploadSasDocument = gql`
    query GetBlobUploadSas($containerName: BlobContainer!, $blobName: String!) {
  getBlobUploadSas(containerName: $containerName, blobName: $blobName)
}
    `;
export type GetBlobUploadSasProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>
    } & TChildProps;
export function withGetBlobUploadSas<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBlobUploadSasQuery,
  GetBlobUploadSasQueryVariables,
  GetBlobUploadSasProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables, GetBlobUploadSasProps<TChildProps, TDataName>>(GetBlobUploadSasDocument, {
      alias: 'getBlobUploadSas',
      ...operationOptions
    });
};

/**
 * __useGetBlobUploadSasQuery__
 *
 * To run a query within a React component, call `useGetBlobUploadSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlobUploadSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlobUploadSasQuery({
 *   variables: {
 *      containerName: // value for 'containerName'
 *      blobName: // value for 'blobName'
 *   },
 * });
 */
export function useGetBlobUploadSasQuery(baseOptions: Apollo.QueryHookOptions<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>(GetBlobUploadSasDocument, options);
      }
export function useGetBlobUploadSasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>(GetBlobUploadSasDocument, options);
        }
export type GetBlobUploadSasQueryHookResult = ReturnType<typeof useGetBlobUploadSasQuery>;
export type GetBlobUploadSasLazyQueryHookResult = ReturnType<typeof useGetBlobUploadSasLazyQuery>;
export type GetBlobUploadSasQueryResult = Apollo.QueryResult<GetBlobUploadSasQuery, GetBlobUploadSasQueryVariables>;
export const AddCompanyCertificateDocument = gql`
    mutation addCompanyCertificate($organizationNumber: String!, $file: FileInput!, $date: Date) {
  addCompanyCertificate(
    organizationNumber: $organizationNumber
    file: $file
    date: $date
  ) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type AddCompanyCertificateMutationFn = Apollo.MutationFunction<AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables>;
export type AddCompanyCertificateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables>
    } & TChildProps;
export function withAddCompanyCertificate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCompanyCertificateMutation,
  AddCompanyCertificateMutationVariables,
  AddCompanyCertificateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables, AddCompanyCertificateProps<TChildProps, TDataName>>(AddCompanyCertificateDocument, {
      alias: 'addCompanyCertificate',
      ...operationOptions
    });
};

/**
 * __useAddCompanyCertificateMutation__
 *
 * To run a mutation, you first call `useAddCompanyCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCertificateMutation, { data, loading, error }] = useAddCompanyCertificateMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      file: // value for 'file'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAddCompanyCertificateMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables>(AddCompanyCertificateDocument, options);
      }
export type AddCompanyCertificateMutationHookResult = ReturnType<typeof useAddCompanyCertificateMutation>;
export type AddCompanyCertificateMutationResult = Apollo.MutationResult<AddCompanyCertificateMutation>;
export type AddCompanyCertificateMutationOptions = Apollo.BaseMutationOptions<AddCompanyCertificateMutation, AddCompanyCertificateMutationVariables>;
export const DeleteCompanyCertificateDocument = gql`
    mutation deleteCompanyCertificate($organizationNumber: String!, $certificateID: ID!) {
  deleteCompanyCertificate(
    organizationNumber: $organizationNumber
    certificateID: $certificateID
  ) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type DeleteCompanyCertificateMutationFn = Apollo.MutationFunction<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables>;
export type DeleteCompanyCertificateProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables>
    } & TChildProps;
export function withDeleteCompanyCertificate<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCompanyCertificateMutation,
  DeleteCompanyCertificateMutationVariables,
  DeleteCompanyCertificateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables, DeleteCompanyCertificateProps<TChildProps, TDataName>>(DeleteCompanyCertificateDocument, {
      alias: 'deleteCompanyCertificate',
      ...operationOptions
    });
};

/**
 * __useDeleteCompanyCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyCertificateMutation, { data, loading, error }] = useDeleteCompanyCertificateMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      certificateID: // value for 'certificateID'
 *   },
 * });
 */
export function useDeleteCompanyCertificateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables>(DeleteCompanyCertificateDocument, options);
      }
export type DeleteCompanyCertificateMutationHookResult = ReturnType<typeof useDeleteCompanyCertificateMutation>;
export type DeleteCompanyCertificateMutationResult = Apollo.MutationResult<DeleteCompanyCertificateMutation>;
export type DeleteCompanyCertificateMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyCertificateMutation, DeleteCompanyCertificateMutationVariables>;
export const SubscribeToReservationsSummaryDocument = gql`
    subscription SubscribeToReservationsSummary($campaignId: ID, $type: SummaryEnum) {
  reservationsSummaryUpdated(campaignId: $campaignId, type: $type) {
    ...reservationsSummaryFragment
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}`;
export type SubscribeToReservationsSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscribeToReservationsSummarySubscription, SubscribeToReservationsSummarySubscriptionVariables>
    } & TChildProps;
export function withSubscribeToReservationsSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscribeToReservationsSummarySubscription,
  SubscribeToReservationsSummarySubscriptionVariables,
  SubscribeToReservationsSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, SubscribeToReservationsSummarySubscription, SubscribeToReservationsSummarySubscriptionVariables, SubscribeToReservationsSummaryProps<TChildProps, TDataName>>(SubscribeToReservationsSummaryDocument, {
      alias: 'subscribeToReservationsSummary',
      ...operationOptions
    });
};

/**
 * __useSubscribeToReservationsSummarySubscription__
 *
 * To run a query within a React component, call `useSubscribeToReservationsSummarySubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToReservationsSummarySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToReservationsSummarySubscription({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSubscribeToReservationsSummarySubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToReservationsSummarySubscription, SubscribeToReservationsSummarySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToReservationsSummarySubscription, SubscribeToReservationsSummarySubscriptionVariables>(SubscribeToReservationsSummaryDocument, options);
      }
export type SubscribeToReservationsSummarySubscriptionHookResult = ReturnType<typeof useSubscribeToReservationsSummarySubscription>;
export type SubscribeToReservationsSummarySubscriptionResult = Apollo.SubscriptionResult<SubscribeToReservationsSummarySubscription>;
export const GetReservationsSummaryDocument = gql`
    query GetReservationsSummary($campaignId: ID!, $includePreorders: Boolean) {
  getReservationsSummaryForCampaign(
    campaignId: $campaignId
    includePreorders: $includePreorders
  ) {
    ...reservationsSummaryFragment
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}`;
export type GetReservationsSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>
    } & TChildProps;
export function withGetReservationsSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReservationsSummaryQuery,
  GetReservationsSummaryQueryVariables,
  GetReservationsSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables, GetReservationsSummaryProps<TChildProps, TDataName>>(GetReservationsSummaryDocument, {
      alias: 'getReservationsSummary',
      ...operationOptions
    });
};

/**
 * __useGetReservationsSummaryQuery__
 *
 * To run a query within a React component, call `useGetReservationsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationsSummaryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      includePreorders: // value for 'includePreorders'
 *   },
 * });
 */
export function useGetReservationsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>(GetReservationsSummaryDocument, options);
      }
export function useGetReservationsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>(GetReservationsSummaryDocument, options);
        }
export type GetReservationsSummaryQueryHookResult = ReturnType<typeof useGetReservationsSummaryQuery>;
export type GetReservationsSummaryLazyQueryHookResult = ReturnType<typeof useGetReservationsSummaryLazyQuery>;
export type GetReservationsSummaryQueryResult = Apollo.QueryResult<GetReservationsSummaryQuery, GetReservationsSummaryQueryVariables>;
export const GetAllAboutUsMembersDocument = gql`
    query GetAllAboutUsMembers {
  getAboutUsMembers {
    members {
      _id
      imageUrl
      name
      location
      title
      section
    }
  }
}
    `;
export type GetAllAboutUsMembersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>
    } & TChildProps;
export function withGetAllAboutUsMembers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllAboutUsMembersQuery,
  GetAllAboutUsMembersQueryVariables,
  GetAllAboutUsMembersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables, GetAllAboutUsMembersProps<TChildProps, TDataName>>(GetAllAboutUsMembersDocument, {
      alias: 'getAllAboutUsMembers',
      ...operationOptions
    });
};

/**
 * __useGetAllAboutUsMembersQuery__
 *
 * To run a query within a React component, call `useGetAllAboutUsMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAboutUsMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAboutUsMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAboutUsMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>(GetAllAboutUsMembersDocument, options);
      }
export function useGetAllAboutUsMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>(GetAllAboutUsMembersDocument, options);
        }
export type GetAllAboutUsMembersQueryHookResult = ReturnType<typeof useGetAllAboutUsMembersQuery>;
export type GetAllAboutUsMembersLazyQueryHookResult = ReturnType<typeof useGetAllAboutUsMembersLazyQuery>;
export type GetAllAboutUsMembersQueryResult = Apollo.QueryResult<GetAllAboutUsMembersQuery, GetAllAboutUsMembersQueryVariables>;
export const MyCampaignsDocument = gql`
    query MyCampaigns {
  myCampaigns {
    _id
    onboardingCompleted
    title
    slug
    licensePaid
    createdAt
    status
  }
}
    `;
export type MyCampaignsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyCampaignsQuery, MyCampaignsQueryVariables>
    } & TChildProps;
export function withMyCampaigns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyCampaignsQuery,
  MyCampaignsQueryVariables,
  MyCampaignsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MyCampaignsQuery, MyCampaignsQueryVariables, MyCampaignsProps<TChildProps, TDataName>>(MyCampaignsDocument, {
      alias: 'myCampaigns',
      ...operationOptions
    });
};

/**
 * __useMyCampaignsQuery__
 *
 * To run a query within a React component, call `useMyCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampaignsQuery, MyCampaignsQueryVariables>(MyCampaignsDocument, options);
      }
export function useMyCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampaignsQuery, MyCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampaignsQuery, MyCampaignsQueryVariables>(MyCampaignsDocument, options);
        }
export type MyCampaignsQueryHookResult = ReturnType<typeof useMyCampaignsQuery>;
export type MyCampaignsLazyQueryHookResult = ReturnType<typeof useMyCampaignsLazyQuery>;
export type MyCampaignsQueryResult = Apollo.QueryResult<MyCampaignsQuery, MyCampaignsQueryVariables>;
export const MyCampaignCardByIdDocument = gql`
    query MyCampaignCardById($campaignId: ID!) {
  myCampaignCardById(campaignId: $campaignId) {
    ...CampaignCardData
  }
}
    ${CampaignCardDataFragmentDoc}`;
export type MyCampaignCardByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>
    } & TChildProps;
export function withMyCampaignCardById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyCampaignCardByIdQuery,
  MyCampaignCardByIdQueryVariables,
  MyCampaignCardByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables, MyCampaignCardByIdProps<TChildProps, TDataName>>(MyCampaignCardByIdDocument, {
      alias: 'myCampaignCardById',
      ...operationOptions
    });
};

/**
 * __useMyCampaignCardByIdQuery__
 *
 * To run a query within a React component, call `useMyCampaignCardByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampaignCardByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampaignCardByIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useMyCampaignCardByIdQuery(baseOptions: Apollo.QueryHookOptions<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>(MyCampaignCardByIdDocument, options);
      }
export function useMyCampaignCardByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>(MyCampaignCardByIdDocument, options);
        }
export type MyCampaignCardByIdQueryHookResult = ReturnType<typeof useMyCampaignCardByIdQuery>;
export type MyCampaignCardByIdLazyQueryHookResult = ReturnType<typeof useMyCampaignCardByIdLazyQuery>;
export type MyCampaignCardByIdQueryResult = Apollo.QueryResult<MyCampaignCardByIdQuery, MyCampaignCardByIdQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;
export type ChangePasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>
    } & TChildProps;
export function withChangePassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  ChangePasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangePasswordMutation, ChangePasswordMutationVariables, ChangePasswordProps<TChildProps, TDataName>>(ChangePasswordDocument, {
      alias: 'changePassword',
      ...operationOptions
    });
};

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const SearchForInvestmentCompanyDocument = gql`
    query SearchForInvestmentCompany($input: InvestmentCompanySearchInput, $paginationUrl: String) {
  searchForInvestmentCompanies(input: $input, paginationUrl: $paginationUrl) {
    hits {
      companyId
      companyName
      legalGroupCode
      town
      legalGroupText
    }
    hitCount
    pageIndex
    totalPages
    next
    previous
    countryCode
  }
}
    `;
export type SearchForInvestmentCompanyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>
    } & TChildProps;
export function withSearchForInvestmentCompany<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchForInvestmentCompanyQuery,
  SearchForInvestmentCompanyQueryVariables,
  SearchForInvestmentCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables, SearchForInvestmentCompanyProps<TChildProps, TDataName>>(SearchForInvestmentCompanyDocument, {
      alias: 'searchForInvestmentCompany',
      ...operationOptions
    });
};

/**
 * __useSearchForInvestmentCompanyQuery__
 *
 * To run a query within a React component, call `useSearchForInvestmentCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForInvestmentCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForInvestmentCompanyQuery({
 *   variables: {
 *      input: // value for 'input'
 *      paginationUrl: // value for 'paginationUrl'
 *   },
 * });
 */
export function useSearchForInvestmentCompanyQuery(baseOptions?: Apollo.QueryHookOptions<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>(SearchForInvestmentCompanyDocument, options);
      }
export function useSearchForInvestmentCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>(SearchForInvestmentCompanyDocument, options);
        }
export type SearchForInvestmentCompanyQueryHookResult = ReturnType<typeof useSearchForInvestmentCompanyQuery>;
export type SearchForInvestmentCompanyLazyQueryHookResult = ReturnType<typeof useSearchForInvestmentCompanyLazyQuery>;
export type SearchForInvestmentCompanyQueryResult = Apollo.QueryResult<SearchForInvestmentCompanyQuery, SearchForInvestmentCompanyQueryVariables>;
export const AddInvestmentCompanyToProfileDocument = gql`
    mutation AddInvestmentCompanyToProfile($companyId: String!, $countryCode: CompanyCountryCodeEnum!) {
  addInvestmentCompanyToProfile(companyId: $companyId, countryCode: $countryCode) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type AddInvestmentCompanyToProfileMutationFn = Apollo.MutationFunction<AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables>;
export type AddInvestmentCompanyToProfileProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables>
    } & TChildProps;
export function withAddInvestmentCompanyToProfile<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddInvestmentCompanyToProfileMutation,
  AddInvestmentCompanyToProfileMutationVariables,
  AddInvestmentCompanyToProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables, AddInvestmentCompanyToProfileProps<TChildProps, TDataName>>(AddInvestmentCompanyToProfileDocument, {
      alias: 'addInvestmentCompanyToProfile',
      ...operationOptions
    });
};

/**
 * __useAddInvestmentCompanyToProfileMutation__
 *
 * To run a mutation, you first call `useAddInvestmentCompanyToProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvestmentCompanyToProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvestmentCompanyToProfileMutation, { data, loading, error }] = useAddInvestmentCompanyToProfileMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useAddInvestmentCompanyToProfileMutation(baseOptions?: Apollo.MutationHookOptions<AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables>(AddInvestmentCompanyToProfileDocument, options);
      }
export type AddInvestmentCompanyToProfileMutationHookResult = ReturnType<typeof useAddInvestmentCompanyToProfileMutation>;
export type AddInvestmentCompanyToProfileMutationResult = Apollo.MutationResult<AddInvestmentCompanyToProfileMutation>;
export type AddInvestmentCompanyToProfileMutationOptions = Apollo.BaseMutationOptions<AddInvestmentCompanyToProfileMutation, AddInvestmentCompanyToProfileMutationVariables>;
export const RemoveCompanyDocument = gql`
    mutation RemoveCompany($organizationNumber: String!) {
  removeCompany(organizationNumber: $organizationNumber) {
    _id
  }
}
    `;
export type RemoveCompanyMutationFn = Apollo.MutationFunction<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export type RemoveCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RemoveCompanyMutation, RemoveCompanyMutationVariables>
    } & TChildProps;
export function withRemoveCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCompanyMutation,
  RemoveCompanyMutationVariables,
  RemoveCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCompanyMutation, RemoveCompanyMutationVariables, RemoveCompanyProps<TChildProps, TDataName>>(RemoveCompanyDocument, {
      alias: 'removeCompany',
      ...operationOptions
    });
};

/**
 * __useRemoveCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMutation, { data, loading, error }] = useRemoveCompanyMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *   },
 * });
 */
export function useRemoveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMutation, RemoveCompanyMutationVariables>(RemoveCompanyDocument, options);
      }
export type RemoveCompanyMutationHookResult = ReturnType<typeof useRemoveCompanyMutation>;
export type RemoveCompanyMutationResult = Apollo.MutationResult<RemoveCompanyMutation>;
export type RemoveCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMutation, RemoveCompanyMutationVariables>;
export const AddCompanyUserDocument = gql`
    mutation AddCompanyUser($organizationNumber: String!, $email: String!) {
  addCompanyUser(organizationNumber: $organizationNumber, email: $email) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type AddCompanyUserMutationFn = Apollo.MutationFunction<AddCompanyUserMutation, AddCompanyUserMutationVariables>;
export type AddCompanyUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddCompanyUserMutation, AddCompanyUserMutationVariables>
    } & TChildProps;
export function withAddCompanyUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCompanyUserMutation,
  AddCompanyUserMutationVariables,
  AddCompanyUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCompanyUserMutation, AddCompanyUserMutationVariables, AddCompanyUserProps<TChildProps, TDataName>>(AddCompanyUserDocument, {
      alias: 'addCompanyUser',
      ...operationOptions
    });
};

/**
 * __useAddCompanyUserMutation__
 *
 * To run a mutation, you first call `useAddCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyUserMutation, { data, loading, error }] = useAddCompanyUserMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyUserMutation, AddCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyUserMutation, AddCompanyUserMutationVariables>(AddCompanyUserDocument, options);
      }
export type AddCompanyUserMutationHookResult = ReturnType<typeof useAddCompanyUserMutation>;
export type AddCompanyUserMutationResult = Apollo.MutationResult<AddCompanyUserMutation>;
export type AddCompanyUserMutationOptions = Apollo.BaseMutationOptions<AddCompanyUserMutation, AddCompanyUserMutationVariables>;
export const RemoveCompanyUserDocument = gql`
    mutation RemoveCompanyUser($organizationNumber: String!, $email: String!) {
  removeCompanyUser(organizationNumber: $organizationNumber, email: $email) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type RemoveCompanyUserMutationFn = Apollo.MutationFunction<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>;
export type RemoveCompanyUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>
    } & TChildProps;
export function withRemoveCompanyUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCompanyUserMutation,
  RemoveCompanyUserMutationVariables,
  RemoveCompanyUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables, RemoveCompanyUserProps<TChildProps, TDataName>>(RemoveCompanyUserDocument, {
      alias: 'removeCompanyUser',
      ...operationOptions
    });
};

/**
 * __useRemoveCompanyUserMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyUserMutation, { data, loading, error }] = useRemoveCompanyUserMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>(RemoveCompanyUserDocument, options);
      }
export type RemoveCompanyUserMutationHookResult = ReturnType<typeof useRemoveCompanyUserMutation>;
export type RemoveCompanyUserMutationResult = Apollo.MutationResult<RemoveCompanyUserMutation>;
export type RemoveCompanyUserMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>;
export const GetCompanyOwnersDocument = gql`
    query GetCompanyOwners($organizationNumber: String!) {
  getCompany(organizationNumber: $organizationNumber) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type GetCompanyOwnersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>
    } & TChildProps;
export function withGetCompanyOwners<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCompanyOwnersQuery,
  GetCompanyOwnersQueryVariables,
  GetCompanyOwnersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables, GetCompanyOwnersProps<TChildProps, TDataName>>(GetCompanyOwnersDocument, {
      alias: 'getCompanyOwners',
      ...operationOptions
    });
};

/**
 * __useGetCompanyOwnersQuery__
 *
 * To run a query within a React component, call `useGetCompanyOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOwnersQuery({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *   },
 * });
 */
export function useGetCompanyOwnersQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>(GetCompanyOwnersDocument, options);
      }
export function useGetCompanyOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>(GetCompanyOwnersDocument, options);
        }
export type GetCompanyOwnersQueryHookResult = ReturnType<typeof useGetCompanyOwnersQuery>;
export type GetCompanyOwnersLazyQueryHookResult = ReturnType<typeof useGetCompanyOwnersLazyQuery>;
export type GetCompanyOwnersQueryResult = Apollo.QueryResult<GetCompanyOwnersQuery, GetCompanyOwnersQueryVariables>;
export const AddCompanyOwnerDocument = gql`
    mutation AddCompanyOwner($organizationNumber: String!, $name: String!) {
  addCompanyOwner(organizationNumber: $organizationNumber, name: $name) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type AddCompanyOwnerMutationFn = Apollo.MutationFunction<AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables>;
export type AddCompanyOwnerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables>
    } & TChildProps;
export function withAddCompanyOwner<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddCompanyOwnerMutation,
  AddCompanyOwnerMutationVariables,
  AddCompanyOwnerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables, AddCompanyOwnerProps<TChildProps, TDataName>>(AddCompanyOwnerDocument, {
      alias: 'addCompanyOwner',
      ...operationOptions
    });
};

/**
 * __useAddCompanyOwnerMutation__
 *
 * To run a mutation, you first call `useAddCompanyOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyOwnerMutation, { data, loading, error }] = useAddCompanyOwnerMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddCompanyOwnerMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables>(AddCompanyOwnerDocument, options);
      }
export type AddCompanyOwnerMutationHookResult = ReturnType<typeof useAddCompanyOwnerMutation>;
export type AddCompanyOwnerMutationResult = Apollo.MutationResult<AddCompanyOwnerMutation>;
export type AddCompanyOwnerMutationOptions = Apollo.BaseMutationOptions<AddCompanyOwnerMutation, AddCompanyOwnerMutationVariables>;
export const RemoveCompanyOwnerDocument = gql`
    mutation RemoveCompanyOwner($organizationNumber: String!, $_id: ID!) {
  removeCompanyOwner(organizationNumber: $organizationNumber, _id: $_id) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type RemoveCompanyOwnerMutationFn = Apollo.MutationFunction<RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables>;
export type RemoveCompanyOwnerProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables>
    } & TChildProps;
export function withRemoveCompanyOwner<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveCompanyOwnerMutation,
  RemoveCompanyOwnerMutationVariables,
  RemoveCompanyOwnerProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables, RemoveCompanyOwnerProps<TChildProps, TDataName>>(RemoveCompanyOwnerDocument, {
      alias: 'removeCompanyOwner',
      ...operationOptions
    });
};

/**
 * __useRemoveCompanyOwnerMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyOwnerMutation, { data, loading, error }] = useRemoveCompanyOwnerMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemoveCompanyOwnerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables>(RemoveCompanyOwnerDocument, options);
      }
export type RemoveCompanyOwnerMutationHookResult = ReturnType<typeof useRemoveCompanyOwnerMutation>;
export type RemoveCompanyOwnerMutationResult = Apollo.MutationResult<RemoveCompanyOwnerMutation>;
export type RemoveCompanyOwnerMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyOwnerMutation, RemoveCompanyOwnerMutationVariables>;
export const ToggleNoCompanyOwnersDocument = gql`
    mutation ToggleNoCompanyOwners($organizationNumber: String!, $hasNoOwners: Boolean!) {
  toggleNoCompanyOwners(
    organizationNumber: $organizationNumber
    hasNoOwners: $hasNoOwners
  ) {
    ...InvestmentCompanyData
  }
}
    ${InvestmentCompanyDataFragmentDoc}`;
export type ToggleNoCompanyOwnersMutationFn = Apollo.MutationFunction<ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables>;
export type ToggleNoCompanyOwnersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables>
    } & TChildProps;
export function withToggleNoCompanyOwners<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ToggleNoCompanyOwnersMutation,
  ToggleNoCompanyOwnersMutationVariables,
  ToggleNoCompanyOwnersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables, ToggleNoCompanyOwnersProps<TChildProps, TDataName>>(ToggleNoCompanyOwnersDocument, {
      alias: 'toggleNoCompanyOwners',
      ...operationOptions
    });
};

/**
 * __useToggleNoCompanyOwnersMutation__
 *
 * To run a mutation, you first call `useToggleNoCompanyOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNoCompanyOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNoCompanyOwnersMutation, { data, loading, error }] = useToggleNoCompanyOwnersMutation({
 *   variables: {
 *      organizationNumber: // value for 'organizationNumber'
 *      hasNoOwners: // value for 'hasNoOwners'
 *   },
 * });
 */
export function useToggleNoCompanyOwnersMutation(baseOptions?: Apollo.MutationHookOptions<ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables>(ToggleNoCompanyOwnersDocument, options);
      }
export type ToggleNoCompanyOwnersMutationHookResult = ReturnType<typeof useToggleNoCompanyOwnersMutation>;
export type ToggleNoCompanyOwnersMutationResult = Apollo.MutationResult<ToggleNoCompanyOwnersMutation>;
export type ToggleNoCompanyOwnersMutationOptions = Apollo.BaseMutationOptions<ToggleNoCompanyOwnersMutation, ToggleNoCompanyOwnersMutationVariables>;
export const MyServicesDocument = gql`
    query MyServices {
  myServices
}
    `;
export type MyServicesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyServicesQuery, MyServicesQueryVariables>
    } & TChildProps;
export function withMyServices<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyServicesQuery,
  MyServicesQueryVariables,
  MyServicesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MyServicesQuery, MyServicesQueryVariables, MyServicesProps<TChildProps, TDataName>>(MyServicesDocument, {
      alias: 'myServices',
      ...operationOptions
    });
};

/**
 * __useMyServicesQuery__
 *
 * To run a query within a React component, call `useMyServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyServicesQuery(baseOptions?: Apollo.QueryHookOptions<MyServicesQuery, MyServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyServicesQuery, MyServicesQueryVariables>(MyServicesDocument, options);
      }
export function useMyServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyServicesQuery, MyServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyServicesQuery, MyServicesQueryVariables>(MyServicesDocument, options);
        }
export type MyServicesQueryHookResult = ReturnType<typeof useMyServicesQuery>;
export type MyServicesLazyQueryHookResult = ReturnType<typeof useMyServicesLazyQuery>;
export type MyServicesQueryResult = Apollo.QueryResult<MyServicesQuery, MyServicesQueryVariables>;
export const AddServiceDocument = gql`
    mutation AddService($serviceName: String!, $token: String!) {
  addService(serviceName: $serviceName, token: $token)
}
    `;
export type AddServiceMutationFn = Apollo.MutationFunction<AddServiceMutation, AddServiceMutationVariables>;
export type AddServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddServiceMutation, AddServiceMutationVariables>
    } & TChildProps;
export function withAddService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddServiceMutation,
  AddServiceMutationVariables,
  AddServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddServiceMutation, AddServiceMutationVariables, AddServiceProps<TChildProps, TDataName>>(AddServiceDocument, {
      alias: 'addService',
      ...operationOptions
    });
};

/**
 * __useAddServiceMutation__
 *
 * To run a mutation, you first call `useAddServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceMutation, { data, loading, error }] = useAddServiceMutation({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAddServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceMutation, AddServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceMutation, AddServiceMutationVariables>(AddServiceDocument, options);
      }
export type AddServiceMutationHookResult = ReturnType<typeof useAddServiceMutation>;
export type AddServiceMutationResult = Apollo.MutationResult<AddServiceMutation>;
export type AddServiceMutationOptions = Apollo.BaseMutationOptions<AddServiceMutation, AddServiceMutationVariables>;
export const RemoveServiceDocument = gql`
    mutation RemoveService($serviceName: String!) {
  removeService(serviceName: $serviceName)
}
    `;
export type RemoveServiceMutationFn = Apollo.MutationFunction<RemoveServiceMutation, RemoveServiceMutationVariables>;
export type RemoveServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RemoveServiceMutation, RemoveServiceMutationVariables>
    } & TChildProps;
export function withRemoveService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveServiceMutation,
  RemoveServiceMutationVariables,
  RemoveServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveServiceMutation, RemoveServiceMutationVariables, RemoveServiceProps<TChildProps, TDataName>>(RemoveServiceDocument, {
      alias: 'removeService',
      ...operationOptions
    });
};

/**
 * __useRemoveServiceMutation__
 *
 * To run a mutation, you first call `useRemoveServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeServiceMutation, { data, loading, error }] = useRemoveServiceMutation({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useRemoveServiceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveServiceMutation, RemoveServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveServiceMutation, RemoveServiceMutationVariables>(RemoveServiceDocument, options);
      }
export type RemoveServiceMutationHookResult = ReturnType<typeof useRemoveServiceMutation>;
export type RemoveServiceMutationResult = Apollo.MutationResult<RemoveServiceMutation>;
export type RemoveServiceMutationOptions = Apollo.BaseMutationOptions<RemoveServiceMutation, RemoveServiceMutationVariables>;
export const GetTermsCurrentVersionDocument = gql`
    query GetTermsCurrentVersion {
  getTermsCurrentVersion
}
    `;
export type GetTermsCurrentVersionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>
    } & TChildProps;
export function withGetTermsCurrentVersion<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTermsCurrentVersionQuery,
  GetTermsCurrentVersionQueryVariables,
  GetTermsCurrentVersionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables, GetTermsCurrentVersionProps<TChildProps, TDataName>>(GetTermsCurrentVersionDocument, {
      alias: 'getTermsCurrentVersion',
      ...operationOptions
    });
};

/**
 * __useGetTermsCurrentVersionQuery__
 *
 * To run a query within a React component, call `useGetTermsCurrentVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsCurrentVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsCurrentVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsCurrentVersionQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>(GetTermsCurrentVersionDocument, options);
      }
export function useGetTermsCurrentVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>(GetTermsCurrentVersionDocument, options);
        }
export type GetTermsCurrentVersionQueryHookResult = ReturnType<typeof useGetTermsCurrentVersionQuery>;
export type GetTermsCurrentVersionLazyQueryHookResult = ReturnType<typeof useGetTermsCurrentVersionLazyQuery>;
export type GetTermsCurrentVersionQueryResult = Apollo.QueryResult<GetTermsCurrentVersionQuery, GetTermsCurrentVersionQueryVariables>;
export const RevokeTermsDocument = gql`
    mutation RevokeTerms {
  revokeTerms
}
    `;
export type RevokeTermsMutationFn = Apollo.MutationFunction<RevokeTermsMutation, RevokeTermsMutationVariables>;
export type RevokeTermsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RevokeTermsMutation, RevokeTermsMutationVariables>
    } & TChildProps;
export function withRevokeTerms<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RevokeTermsMutation,
  RevokeTermsMutationVariables,
  RevokeTermsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RevokeTermsMutation, RevokeTermsMutationVariables, RevokeTermsProps<TChildProps, TDataName>>(RevokeTermsDocument, {
      alias: 'revokeTerms',
      ...operationOptions
    });
};

/**
 * __useRevokeTermsMutation__
 *
 * To run a mutation, you first call `useRevokeTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeTermsMutation, { data, loading, error }] = useRevokeTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeTermsMutation(baseOptions?: Apollo.MutationHookOptions<RevokeTermsMutation, RevokeTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeTermsMutation, RevokeTermsMutationVariables>(RevokeTermsDocument, options);
      }
export type RevokeTermsMutationHookResult = ReturnType<typeof useRevokeTermsMutation>;
export type RevokeTermsMutationResult = Apollo.MutationResult<RevokeTermsMutation>;
export type RevokeTermsMutationOptions = Apollo.BaseMutationOptions<RevokeTermsMutation, RevokeTermsMutationVariables>;
export const ResetBankIdDocument = gql`
    mutation ResetBankId {
  resetBankId
}
    `;
export type ResetBankIdMutationFn = Apollo.MutationFunction<ResetBankIdMutation, ResetBankIdMutationVariables>;
export type ResetBankIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ResetBankIdMutation, ResetBankIdMutationVariables>
    } & TChildProps;
export function withResetBankId<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ResetBankIdMutation,
  ResetBankIdMutationVariables,
  ResetBankIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ResetBankIdMutation, ResetBankIdMutationVariables, ResetBankIdProps<TChildProps, TDataName>>(ResetBankIdDocument, {
      alias: 'resetBankId',
      ...operationOptions
    });
};

/**
 * __useResetBankIdMutation__
 *
 * To run a mutation, you first call `useResetBankIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetBankIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetBankIdMutation, { data, loading, error }] = useResetBankIdMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetBankIdMutation(baseOptions?: Apollo.MutationHookOptions<ResetBankIdMutation, ResetBankIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetBankIdMutation, ResetBankIdMutationVariables>(ResetBankIdDocument, options);
      }
export type ResetBankIdMutationHookResult = ReturnType<typeof useResetBankIdMutation>;
export type ResetBankIdMutationResult = Apollo.MutationResult<ResetBankIdMutation>;
export type ResetBankIdMutationOptions = Apollo.BaseMutationOptions<ResetBankIdMutation, ResetBankIdMutationVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($reservationId: ID!, $reason: ReservationCancelReasonInput!) {
  cancelReservation(reservationId: $reservationId, reason: $reason) {
    _id
    userState
    cancelReason {
      comment
      createdAt
    }
  }
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;
export type CancelReservationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>
    } & TChildProps;
export function withCancelReservation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelReservationMutation,
  CancelReservationMutationVariables,
  CancelReservationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelReservationMutation, CancelReservationMutationVariables, CancelReservationProps<TChildProps, TDataName>>(CancelReservationDocument, {
      alias: 'cancelReservation',
      ...operationOptions
    });
};

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const HideReservationDocument = gql`
    mutation HideReservation($reservationId: ID!) {
  hideReservation(reservationId: $reservationId) {
    _id
    hidden
  }
}
    `;
export type HideReservationMutationFn = Apollo.MutationFunction<HideReservationMutation, HideReservationMutationVariables>;
export type HideReservationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<HideReservationMutation, HideReservationMutationVariables>
    } & TChildProps;
export function withHideReservation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HideReservationMutation,
  HideReservationMutationVariables,
  HideReservationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, HideReservationMutation, HideReservationMutationVariables, HideReservationProps<TChildProps, TDataName>>(HideReservationDocument, {
      alias: 'hideReservation',
      ...operationOptions
    });
};

/**
 * __useHideReservationMutation__
 *
 * To run a mutation, you first call `useHideReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideReservationMutation, { data, loading, error }] = useHideReservationMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useHideReservationMutation(baseOptions?: Apollo.MutationHookOptions<HideReservationMutation, HideReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideReservationMutation, HideReservationMutationVariables>(HideReservationDocument, options);
      }
export type HideReservationMutationHookResult = ReturnType<typeof useHideReservationMutation>;
export type HideReservationMutationResult = Apollo.MutationResult<HideReservationMutation>;
export type HideReservationMutationOptions = Apollo.BaseMutationOptions<HideReservationMutation, HideReservationMutationVariables>;
export const MyReservationSubDocument = gql`
    subscription MyReservationSub {
  reservationUpdated {
    ...myReservationsView
  }
}
    ${MyReservationsViewFragmentDoc}`;
export type MyReservationSubProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyReservationSubSubscription, MyReservationSubSubscriptionVariables>
    } & TChildProps;
export function withMyReservationSub<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyReservationSubSubscription,
  MyReservationSubSubscriptionVariables,
  MyReservationSubProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, MyReservationSubSubscription, MyReservationSubSubscriptionVariables, MyReservationSubProps<TChildProps, TDataName>>(MyReservationSubDocument, {
      alias: 'myReservationSub',
      ...operationOptions
    });
};

/**
 * __useMyReservationSubSubscription__
 *
 * To run a query within a React component, call `useMyReservationSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMyReservationSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReservationSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMyReservationSubSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MyReservationSubSubscription, MyReservationSubSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyReservationSubSubscription, MyReservationSubSubscriptionVariables>(MyReservationSubDocument, options);
      }
export type MyReservationSubSubscriptionHookResult = ReturnType<typeof useMyReservationSubSubscription>;
export type MyReservationSubSubscriptionResult = Apollo.SubscriptionResult<MyReservationSubSubscription>;
export const MyReservationsDocument = gql`
    query MyReservations {
  myReservations {
    ...myReservationsView
  }
  myAssociatedReservations {
    ...ReservationByAssociationData
  }
}
    ${MyReservationsViewFragmentDoc}
${ReservationByAssociationDataFragmentDoc}`;
export type MyReservationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyReservationsQuery, MyReservationsQueryVariables>
    } & TChildProps;
export function withMyReservations<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyReservationsQuery,
  MyReservationsQueryVariables,
  MyReservationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MyReservationsQuery, MyReservationsQueryVariables, MyReservationsProps<TChildProps, TDataName>>(MyReservationsDocument, {
      alias: 'myReservations',
      ...operationOptions
    });
};

/**
 * __useMyReservationsQuery__
 *
 * To run a query within a React component, call `useMyReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReservationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyReservationsQuery(baseOptions?: Apollo.QueryHookOptions<MyReservationsQuery, MyReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReservationsQuery, MyReservationsQueryVariables>(MyReservationsDocument, options);
      }
export function useMyReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReservationsQuery, MyReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReservationsQuery, MyReservationsQueryVariables>(MyReservationsDocument, options);
        }
export type MyReservationsQueryHookResult = ReturnType<typeof useMyReservationsQuery>;
export type MyReservationsLazyQueryHookResult = ReturnType<typeof useMyReservationsLazyQuery>;
export type MyReservationsQueryResult = Apollo.QueryResult<MyReservationsQuery, MyReservationsQueryVariables>;
export const ReservationsSummaryUpdatedForCampaignPageDocument = gql`
    subscription ReservationsSummaryUpdatedForCampaignPage($campaignId: ID!) {
  reservationsSummaryUpdated(campaignId: $campaignId) {
    ...reservationsSummaryFragment
  }
}
    ${ReservationsSummaryFragmentFragmentDoc}`;
export type ReservationsSummaryUpdatedForCampaignPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ReservationsSummaryUpdatedForCampaignPageSubscription, ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables>
    } & TChildProps;
export function withReservationsSummaryUpdatedForCampaignPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReservationsSummaryUpdatedForCampaignPageSubscription,
  ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables,
  ReservationsSummaryUpdatedForCampaignPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, ReservationsSummaryUpdatedForCampaignPageSubscription, ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables, ReservationsSummaryUpdatedForCampaignPageProps<TChildProps, TDataName>>(ReservationsSummaryUpdatedForCampaignPageDocument, {
      alias: 'reservationsSummaryUpdatedForCampaignPage',
      ...operationOptions
    });
};

/**
 * __useReservationsSummaryUpdatedForCampaignPageSubscription__
 *
 * To run a query within a React component, call `useReservationsSummaryUpdatedForCampaignPageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReservationsSummaryUpdatedForCampaignPageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationsSummaryUpdatedForCampaignPageSubscription({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useReservationsSummaryUpdatedForCampaignPageSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReservationsSummaryUpdatedForCampaignPageSubscription, ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReservationsSummaryUpdatedForCampaignPageSubscription, ReservationsSummaryUpdatedForCampaignPageSubscriptionVariables>(ReservationsSummaryUpdatedForCampaignPageDocument, options);
      }
export type ReservationsSummaryUpdatedForCampaignPageSubscriptionHookResult = ReturnType<typeof useReservationsSummaryUpdatedForCampaignPageSubscription>;
export type ReservationsSummaryUpdatedForCampaignPageSubscriptionResult = Apollo.SubscriptionResult<ReservationsSummaryUpdatedForCampaignPageSubscription>;
export const CampaignUpdatedDocument = gql`
    subscription CampaignUpdated($campaignId: ID!) {
  campaignUpdated(campaignId: $campaignId) {
    ...campaignView
  }
}
    ${CampaignViewFragmentDoc}`;
export type CampaignUpdatedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignUpdatedSubscription, CampaignUpdatedSubscriptionVariables>
    } & TChildProps;
export function withCampaignUpdated<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignUpdatedSubscription,
  CampaignUpdatedSubscriptionVariables,
  CampaignUpdatedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, CampaignUpdatedSubscription, CampaignUpdatedSubscriptionVariables, CampaignUpdatedProps<TChildProps, TDataName>>(CampaignUpdatedDocument, {
      alias: 'campaignUpdated',
      ...operationOptions
    });
};

/**
 * __useCampaignUpdatedSubscription__
 *
 * To run a query within a React component, call `useCampaignUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCampaignUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignUpdatedSubscription({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CampaignUpdatedSubscription, CampaignUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CampaignUpdatedSubscription, CampaignUpdatedSubscriptionVariables>(CampaignUpdatedDocument, options);
      }
export type CampaignUpdatedSubscriptionHookResult = ReturnType<typeof useCampaignUpdatedSubscription>;
export type CampaignUpdatedSubscriptionResult = Apollo.SubscriptionResult<CampaignUpdatedSubscription>;
export const IncrementCampaignViewsDocument = gql`
    mutation IncrementCampaignViews($slug: String) {
  incrementCampaignViews(slug: $slug)
}
    `;
export type IncrementCampaignViewsMutationFn = Apollo.MutationFunction<IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables>;
export type IncrementCampaignViewsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables>
    } & TChildProps;
export function withIncrementCampaignViews<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IncrementCampaignViewsMutation,
  IncrementCampaignViewsMutationVariables,
  IncrementCampaignViewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables, IncrementCampaignViewsProps<TChildProps, TDataName>>(IncrementCampaignViewsDocument, {
      alias: 'incrementCampaignViews',
      ...operationOptions
    });
};

/**
 * __useIncrementCampaignViewsMutation__
 *
 * To run a mutation, you first call `useIncrementCampaignViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementCampaignViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementCampaignViewsMutation, { data, loading, error }] = useIncrementCampaignViewsMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIncrementCampaignViewsMutation(baseOptions?: Apollo.MutationHookOptions<IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables>(IncrementCampaignViewsDocument, options);
      }
export type IncrementCampaignViewsMutationHookResult = ReturnType<typeof useIncrementCampaignViewsMutation>;
export type IncrementCampaignViewsMutationResult = Apollo.MutationResult<IncrementCampaignViewsMutation>;
export type IncrementCampaignViewsMutationOptions = Apollo.BaseMutationOptions<IncrementCampaignViewsMutation, IncrementCampaignViewsMutationVariables>;
export const SetReservationFeedbackCommentDocument = gql`
    mutation setReservationFeedbackComment($reservationID: ID!, $comment: String) {
  setReservationFeedbackComment(reservationID: $reservationID, comment: $comment)
}
    `;
export type SetReservationFeedbackCommentMutationFn = Apollo.MutationFunction<SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables>;
export type SetReservationFeedbackCommentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables>
    } & TChildProps;
export function withSetReservationFeedbackComment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetReservationFeedbackCommentMutation,
  SetReservationFeedbackCommentMutationVariables,
  SetReservationFeedbackCommentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables, SetReservationFeedbackCommentProps<TChildProps, TDataName>>(SetReservationFeedbackCommentDocument, {
      alias: 'setReservationFeedbackComment',
      ...operationOptions
    });
};

/**
 * __useSetReservationFeedbackCommentMutation__
 *
 * To run a mutation, you first call `useSetReservationFeedbackCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReservationFeedbackCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReservationFeedbackCommentMutation, { data, loading, error }] = useSetReservationFeedbackCommentMutation({
 *   variables: {
 *      reservationID: // value for 'reservationID'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetReservationFeedbackCommentMutation(baseOptions?: Apollo.MutationHookOptions<SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables>(SetReservationFeedbackCommentDocument, options);
      }
export type SetReservationFeedbackCommentMutationHookResult = ReturnType<typeof useSetReservationFeedbackCommentMutation>;
export type SetReservationFeedbackCommentMutationResult = Apollo.MutationResult<SetReservationFeedbackCommentMutation>;
export type SetReservationFeedbackCommentMutationOptions = Apollo.BaseMutationOptions<SetReservationFeedbackCommentMutation, SetReservationFeedbackCommentMutationVariables>;
export const SetReservationFeedbackScoreDocument = gql`
    mutation setReservationFeedbackScore($reservationID: ID!, $score: Int) {
  setReservationFeedbackScore(reservationID: $reservationID, score: $score)
}
    `;
export type SetReservationFeedbackScoreMutationFn = Apollo.MutationFunction<SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables>;
export type SetReservationFeedbackScoreProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables>
    } & TChildProps;
export function withSetReservationFeedbackScore<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetReservationFeedbackScoreMutation,
  SetReservationFeedbackScoreMutationVariables,
  SetReservationFeedbackScoreProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables, SetReservationFeedbackScoreProps<TChildProps, TDataName>>(SetReservationFeedbackScoreDocument, {
      alias: 'setReservationFeedbackScore',
      ...operationOptions
    });
};

/**
 * __useSetReservationFeedbackScoreMutation__
 *
 * To run a mutation, you first call `useSetReservationFeedbackScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReservationFeedbackScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReservationFeedbackScoreMutation, { data, loading, error }] = useSetReservationFeedbackScoreMutation({
 *   variables: {
 *      reservationID: // value for 'reservationID'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useSetReservationFeedbackScoreMutation(baseOptions?: Apollo.MutationHookOptions<SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables>(SetReservationFeedbackScoreDocument, options);
      }
export type SetReservationFeedbackScoreMutationHookResult = ReturnType<typeof useSetReservationFeedbackScoreMutation>;
export type SetReservationFeedbackScoreMutationResult = Apollo.MutationResult<SetReservationFeedbackScoreMutation>;
export type SetReservationFeedbackScoreMutationOptions = Apollo.BaseMutationOptions<SetReservationFeedbackScoreMutation, SetReservationFeedbackScoreMutationVariables>;
export const CampaignCardBySlugOrIdDocument = gql`
    query CampaignCardBySlugOrId($slug: String, $campaignId: ID) {
  campaignCardBySlugOrId(slug: $slug, campaignId: $campaignId) {
    ...CampaignCardData
  }
}
    ${CampaignCardDataFragmentDoc}`;
export type CampaignCardBySlugOrIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>
    } & TChildProps;
export function withCampaignCardBySlugOrId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignCardBySlugOrIdQuery,
  CampaignCardBySlugOrIdQueryVariables,
  CampaignCardBySlugOrIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables, CampaignCardBySlugOrIdProps<TChildProps, TDataName>>(CampaignCardBySlugOrIdDocument, {
      alias: 'campaignCardBySlugOrId',
      ...operationOptions
    });
};

/**
 * __useCampaignCardBySlugOrIdQuery__
 *
 * To run a query within a React component, call `useCampaignCardBySlugOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignCardBySlugOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignCardBySlugOrIdQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignCardBySlugOrIdQuery(baseOptions?: Apollo.QueryHookOptions<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>(CampaignCardBySlugOrIdDocument, options);
      }
export function useCampaignCardBySlugOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>(CampaignCardBySlugOrIdDocument, options);
        }
export type CampaignCardBySlugOrIdQueryHookResult = ReturnType<typeof useCampaignCardBySlugOrIdQuery>;
export type CampaignCardBySlugOrIdLazyQueryHookResult = ReturnType<typeof useCampaignCardBySlugOrIdLazyQuery>;
export type CampaignCardBySlugOrIdQueryResult = Apollo.QueryResult<CampaignCardBySlugOrIdQuery, CampaignCardBySlugOrIdQueryVariables>;
export const IsSpecialFrontPageEnabledDocument = gql`
    query IsSpecialFrontPageEnabled {
  isSpecialFrontPageEnabled
}
    `;
export type IsSpecialFrontPageEnabledProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>
    } & TChildProps;
export function withIsSpecialFrontPageEnabled<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IsSpecialFrontPageEnabledQuery,
  IsSpecialFrontPageEnabledQueryVariables,
  IsSpecialFrontPageEnabledProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables, IsSpecialFrontPageEnabledProps<TChildProps, TDataName>>(IsSpecialFrontPageEnabledDocument, {
      alias: 'isSpecialFrontPageEnabled',
      ...operationOptions
    });
};

/**
 * __useIsSpecialFrontPageEnabledQuery__
 *
 * To run a query within a React component, call `useIsSpecialFrontPageEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSpecialFrontPageEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSpecialFrontPageEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsSpecialFrontPageEnabledQuery(baseOptions?: Apollo.QueryHookOptions<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>(IsSpecialFrontPageEnabledDocument, options);
      }
export function useIsSpecialFrontPageEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>(IsSpecialFrontPageEnabledDocument, options);
        }
export type IsSpecialFrontPageEnabledQueryHookResult = ReturnType<typeof useIsSpecialFrontPageEnabledQuery>;
export type IsSpecialFrontPageEnabledLazyQueryHookResult = ReturnType<typeof useIsSpecialFrontPageEnabledLazyQuery>;
export type IsSpecialFrontPageEnabledQueryResult = Apollo.QueryResult<IsSpecialFrontPageEnabledQuery, IsSpecialFrontPageEnabledQueryVariables>;
export const HasOpenCampaignsDocument = gql`
    query HasOpenCampaigns {
  hasOpenCampaigns
}
    `;
export type HasOpenCampaignsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>
    } & TChildProps;
export function withHasOpenCampaigns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HasOpenCampaignsQuery,
  HasOpenCampaignsQueryVariables,
  HasOpenCampaignsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables, HasOpenCampaignsProps<TChildProps, TDataName>>(HasOpenCampaignsDocument, {
      alias: 'hasOpenCampaigns',
      ...operationOptions
    });
};

/**
 * __useHasOpenCampaignsQuery__
 *
 * To run a query within a React component, call `useHasOpenCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasOpenCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasOpenCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasOpenCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>(HasOpenCampaignsDocument, options);
      }
export function useHasOpenCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>(HasOpenCampaignsDocument, options);
        }
export type HasOpenCampaignsQueryHookResult = ReturnType<typeof useHasOpenCampaignsQuery>;
export type HasOpenCampaignsLazyQueryHookResult = ReturnType<typeof useHasOpenCampaignsLazyQuery>;
export type HasOpenCampaignsQueryResult = Apollo.QueryResult<HasOpenCampaignsQuery, HasOpenCampaignsQueryVariables>;
export const GetFrontPageTestimonialDocument = gql`
    query GetFrontPageTestimonial {
  getFrontPageTestimonial {
    companyName
    imageUrl
    name
    text
  }
}
    `;
export type GetFrontPageTestimonialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>
    } & TChildProps;
export function withGetFrontPageTestimonial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFrontPageTestimonialQuery,
  GetFrontPageTestimonialQueryVariables,
  GetFrontPageTestimonialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables, GetFrontPageTestimonialProps<TChildProps, TDataName>>(GetFrontPageTestimonialDocument, {
      alias: 'getFrontPageTestimonial',
      ...operationOptions
    });
};

/**
 * __useGetFrontPageTestimonialQuery__
 *
 * To run a query within a React component, call `useGetFrontPageTestimonialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrontPageTestimonialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrontPageTestimonialQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFrontPageTestimonialQuery(baseOptions?: Apollo.QueryHookOptions<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>(GetFrontPageTestimonialDocument, options);
      }
export function useGetFrontPageTestimonialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>(GetFrontPageTestimonialDocument, options);
        }
export type GetFrontPageTestimonialQueryHookResult = ReturnType<typeof useGetFrontPageTestimonialQuery>;
export type GetFrontPageTestimonialLazyQueryHookResult = ReturnType<typeof useGetFrontPageTestimonialLazyQuery>;
export type GetFrontPageTestimonialQueryResult = Apollo.QueryResult<GetFrontPageTestimonialQuery, GetFrontPageTestimonialQueryVariables>;
export const GetEntrepreneurTestimonialsDocument = gql`
    query GetEntrepreneurTestimonials {
  getEntrepreneurTestimonials {
    _id
    companyName
    imageUrl
    jobTitle
    name
    text
  }
}
    `;
export type GetEntrepreneurTestimonialsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>
    } & TChildProps;
export function withGetEntrepreneurTestimonials<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEntrepreneurTestimonialsQuery,
  GetEntrepreneurTestimonialsQueryVariables,
  GetEntrepreneurTestimonialsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables, GetEntrepreneurTestimonialsProps<TChildProps, TDataName>>(GetEntrepreneurTestimonialsDocument, {
      alias: 'getEntrepreneurTestimonials',
      ...operationOptions
    });
};

/**
 * __useGetEntrepreneurTestimonialsQuery__
 *
 * To run a query within a React component, call `useGetEntrepreneurTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntrepreneurTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntrepreneurTestimonialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEntrepreneurTestimonialsQuery(baseOptions?: Apollo.QueryHookOptions<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>(GetEntrepreneurTestimonialsDocument, options);
      }
export function useGetEntrepreneurTestimonialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>(GetEntrepreneurTestimonialsDocument, options);
        }
export type GetEntrepreneurTestimonialsQueryHookResult = ReturnType<typeof useGetEntrepreneurTestimonialsQuery>;
export type GetEntrepreneurTestimonialsLazyQueryHookResult = ReturnType<typeof useGetEntrepreneurTestimonialsLazyQuery>;
export type GetEntrepreneurTestimonialsQueryResult = Apollo.QueryResult<GetEntrepreneurTestimonialsQuery, GetEntrepreneurTestimonialsQueryVariables>;
export const GetLandingPageEntrepreneurTestimonialDocument = gql`
    query GetLandingPageEntrepreneurTestimonial {
  getLandingPageEntrepreneurTestimonial {
    _id
    companyName
    imageUrl
    jobTitle
    name
    text
  }
}
    `;
export type GetLandingPageEntrepreneurTestimonialProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>
    } & TChildProps;
export function withGetLandingPageEntrepreneurTestimonial<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLandingPageEntrepreneurTestimonialQuery,
  GetLandingPageEntrepreneurTestimonialQueryVariables,
  GetLandingPageEntrepreneurTestimonialProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables, GetLandingPageEntrepreneurTestimonialProps<TChildProps, TDataName>>(GetLandingPageEntrepreneurTestimonialDocument, {
      alias: 'getLandingPageEntrepreneurTestimonial',
      ...operationOptions
    });
};

/**
 * __useGetLandingPageEntrepreneurTestimonialQuery__
 *
 * To run a query within a React component, call `useGetLandingPageEntrepreneurTestimonialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingPageEntrepreneurTestimonialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingPageEntrepreneurTestimonialQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLandingPageEntrepreneurTestimonialQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>(GetLandingPageEntrepreneurTestimonialDocument, options);
      }
export function useGetLandingPageEntrepreneurTestimonialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>(GetLandingPageEntrepreneurTestimonialDocument, options);
        }
export type GetLandingPageEntrepreneurTestimonialQueryHookResult = ReturnType<typeof useGetLandingPageEntrepreneurTestimonialQuery>;
export type GetLandingPageEntrepreneurTestimonialLazyQueryHookResult = ReturnType<typeof useGetLandingPageEntrepreneurTestimonialLazyQuery>;
export type GetLandingPageEntrepreneurTestimonialQueryResult = Apollo.QueryResult<GetLandingPageEntrepreneurTestimonialQuery, GetLandingPageEntrepreneurTestimonialQueryVariables>;
export const GetActiveInvestorRelationsHeaderDocument = gql`
    query GetActiveInvestorRelationsHeader {
  getActiveInvestorRelationsHeader {
    _id
    title
    description
    videoUrl
  }
}
    `;
export type GetActiveInvestorRelationsHeaderProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>
    } & TChildProps;
export function withGetActiveInvestorRelationsHeader<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetActiveInvestorRelationsHeaderQuery,
  GetActiveInvestorRelationsHeaderQueryVariables,
  GetActiveInvestorRelationsHeaderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables, GetActiveInvestorRelationsHeaderProps<TChildProps, TDataName>>(GetActiveInvestorRelationsHeaderDocument, {
      alias: 'getActiveInvestorRelationsHeader',
      ...operationOptions
    });
};

/**
 * __useGetActiveInvestorRelationsHeaderQuery__
 *
 * To run a query within a React component, call `useGetActiveInvestorRelationsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveInvestorRelationsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveInvestorRelationsHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveInvestorRelationsHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>(GetActiveInvestorRelationsHeaderDocument, options);
      }
export function useGetActiveInvestorRelationsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>(GetActiveInvestorRelationsHeaderDocument, options);
        }
export type GetActiveInvestorRelationsHeaderQueryHookResult = ReturnType<typeof useGetActiveInvestorRelationsHeaderQuery>;
export type GetActiveInvestorRelationsHeaderLazyQueryHookResult = ReturnType<typeof useGetActiveInvestorRelationsHeaderLazyQuery>;
export type GetActiveInvestorRelationsHeaderQueryResult = Apollo.QueryResult<GetActiveInvestorRelationsHeaderQuery, GetActiveInvestorRelationsHeaderQueryVariables>;
export const GetVisibleInvestorRelationsEventsDocument = gql`
    query GetVisibleInvestorRelationsEvents($pageIndex: Int, $pageSize: Int) {
  getVisibleInvestorRelationsEvents(pageIndex: $pageIndex, pageSize: $pageSize) {
    events {
      _id
      title
      description
      dateOfEvent
      endDateOfEvent
    }
    pageIndex
    pageSize
    totalCount
  }
}
    `;
export type GetVisibleInvestorRelationsEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>
    } & TChildProps;
export function withGetVisibleInvestorRelationsEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVisibleInvestorRelationsEventsQuery,
  GetVisibleInvestorRelationsEventsQueryVariables,
  GetVisibleInvestorRelationsEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables, GetVisibleInvestorRelationsEventsProps<TChildProps, TDataName>>(GetVisibleInvestorRelationsEventsDocument, {
      alias: 'getVisibleInvestorRelationsEvents',
      ...operationOptions
    });
};

/**
 * __useGetVisibleInvestorRelationsEventsQuery__
 *
 * To run a query within a React component, call `useGetVisibleInvestorRelationsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleInvestorRelationsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleInvestorRelationsEventsQuery({
 *   variables: {
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetVisibleInvestorRelationsEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>(GetVisibleInvestorRelationsEventsDocument, options);
      }
export function useGetVisibleInvestorRelationsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>(GetVisibleInvestorRelationsEventsDocument, options);
        }
export type GetVisibleInvestorRelationsEventsQueryHookResult = ReturnType<typeof useGetVisibleInvestorRelationsEventsQuery>;
export type GetVisibleInvestorRelationsEventsLazyQueryHookResult = ReturnType<typeof useGetVisibleInvestorRelationsEventsLazyQuery>;
export type GetVisibleInvestorRelationsEventsQueryResult = Apollo.QueryResult<GetVisibleInvestorRelationsEventsQuery, GetVisibleInvestorRelationsEventsQueryVariables>;
export const GetAllInvestorRelationHighlightsDocument = gql`
    query GetAllInvestorRelationHighlights {
  getAllInvestorRelationsHighlights {
    _id
    title
    description
    linkUrl
    dateOfHighlight
  }
}
    `;
export type GetAllInvestorRelationHighlightsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>
    } & TChildProps;
export function withGetAllInvestorRelationHighlights<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllInvestorRelationHighlightsQuery,
  GetAllInvestorRelationHighlightsQueryVariables,
  GetAllInvestorRelationHighlightsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables, GetAllInvestorRelationHighlightsProps<TChildProps, TDataName>>(GetAllInvestorRelationHighlightsDocument, {
      alias: 'getAllInvestorRelationHighlights',
      ...operationOptions
    });
};

/**
 * __useGetAllInvestorRelationHighlightsQuery__
 *
 * To run a query within a React component, call `useGetAllInvestorRelationHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvestorRelationHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvestorRelationHighlightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInvestorRelationHighlightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>(GetAllInvestorRelationHighlightsDocument, options);
      }
export function useGetAllInvestorRelationHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>(GetAllInvestorRelationHighlightsDocument, options);
        }
export type GetAllInvestorRelationHighlightsQueryHookResult = ReturnType<typeof useGetAllInvestorRelationHighlightsQuery>;
export type GetAllInvestorRelationHighlightsLazyQueryHookResult = ReturnType<typeof useGetAllInvestorRelationHighlightsLazyQuery>;
export type GetAllInvestorRelationHighlightsQueryResult = Apollo.QueryResult<GetAllInvestorRelationHighlightsQuery, GetAllInvestorRelationHighlightsQueryVariables>;
export const InterestedCompanyNotificationDocument = gql`
    mutation InterestedCompanyNotification($name: String!, $email: String!, $phone: String!, $country: InterestedCompanyCountryEnum!, $companyName: String!) {
  interestedCompanyNotification(
    name: $name
    email: $email
    phone: $phone
    country: $country
    companyName: $companyName
  )
}
    `;
export type InterestedCompanyNotificationMutationFn = Apollo.MutationFunction<InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables>;
export type InterestedCompanyNotificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables>
    } & TChildProps;
export function withInterestedCompanyNotification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InterestedCompanyNotificationMutation,
  InterestedCompanyNotificationMutationVariables,
  InterestedCompanyNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables, InterestedCompanyNotificationProps<TChildProps, TDataName>>(InterestedCompanyNotificationDocument, {
      alias: 'interestedCompanyNotification',
      ...operationOptions
    });
};

/**
 * __useInterestedCompanyNotificationMutation__
 *
 * To run a mutation, you first call `useInterestedCompanyNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterestedCompanyNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interestedCompanyNotificationMutation, { data, loading, error }] = useInterestedCompanyNotificationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      country: // value for 'country'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useInterestedCompanyNotificationMutation(baseOptions?: Apollo.MutationHookOptions<InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables>(InterestedCompanyNotificationDocument, options);
      }
export type InterestedCompanyNotificationMutationHookResult = ReturnType<typeof useInterestedCompanyNotificationMutation>;
export type InterestedCompanyNotificationMutationResult = Apollo.MutationResult<InterestedCompanyNotificationMutation>;
export type InterestedCompanyNotificationMutationOptions = Apollo.BaseMutationOptions<InterestedCompanyNotificationMutation, InterestedCompanyNotificationMutationVariables>;
export const LivePageReservationsSummarySubscriptionDocument = gql`
    subscription LivePageReservationsSummarySubscription($campaignIds: [ID], $campaignId: ID) {
  reservationsSummaryUpdated(campaignIds: $campaignIds, campaignId: $campaignId) {
    ...ReservationsSummaryForLivePageData
  }
}
    ${ReservationsSummaryForLivePageDataFragmentDoc}`;
export type LivePageReservationsSummarySubscriptionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LivePageReservationsSummarySubscriptionSubscription, LivePageReservationsSummarySubscriptionSubscriptionVariables>
    } & TChildProps;
export function withLivePageReservationsSummarySubscription<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LivePageReservationsSummarySubscriptionSubscription,
  LivePageReservationsSummarySubscriptionSubscriptionVariables,
  LivePageReservationsSummarySubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, LivePageReservationsSummarySubscriptionSubscription, LivePageReservationsSummarySubscriptionSubscriptionVariables, LivePageReservationsSummarySubscriptionProps<TChildProps, TDataName>>(LivePageReservationsSummarySubscriptionDocument, {
      alias: 'livePageReservationsSummarySubscription',
      ...operationOptions
    });
};

/**
 * __useLivePageReservationsSummarySubscriptionSubscription__
 *
 * To run a query within a React component, call `useLivePageReservationsSummarySubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLivePageReservationsSummarySubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePageReservationsSummarySubscriptionSubscription({
 *   variables: {
 *      campaignIds: // value for 'campaignIds'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useLivePageReservationsSummarySubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LivePageReservationsSummarySubscriptionSubscription, LivePageReservationsSummarySubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LivePageReservationsSummarySubscriptionSubscription, LivePageReservationsSummarySubscriptionSubscriptionVariables>(LivePageReservationsSummarySubscriptionDocument, options);
      }
export type LivePageReservationsSummarySubscriptionSubscriptionHookResult = ReturnType<typeof useLivePageReservationsSummarySubscriptionSubscription>;
export type LivePageReservationsSummarySubscriptionSubscriptionResult = Apollo.SubscriptionResult<LivePageReservationsSummarySubscriptionSubscription>;
export const LivePageCampaignDocument = gql`
    subscription LivePageCampaign($campaignId: ID) {
  campaignUpdated(campaignId: $campaignId) {
    _id
    startDate
    closeDate
    raisingAmountMinimum
    raisingAmountMaximum
    title
  }
}
    `;
export type LivePageCampaignProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<LivePageCampaignSubscription, LivePageCampaignSubscriptionVariables>
    } & TChildProps;
export function withLivePageCampaign<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LivePageCampaignSubscription,
  LivePageCampaignSubscriptionVariables,
  LivePageCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, LivePageCampaignSubscription, LivePageCampaignSubscriptionVariables, LivePageCampaignProps<TChildProps, TDataName>>(LivePageCampaignDocument, {
      alias: 'livePageCampaign',
      ...operationOptions
    });
};

/**
 * __useLivePageCampaignSubscription__
 *
 * To run a query within a React component, call `useLivePageCampaignSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLivePageCampaignSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePageCampaignSubscription({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useLivePageCampaignSubscription(baseOptions?: Apollo.SubscriptionHookOptions<LivePageCampaignSubscription, LivePageCampaignSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LivePageCampaignSubscription, LivePageCampaignSubscriptionVariables>(LivePageCampaignDocument, options);
      }
export type LivePageCampaignSubscriptionHookResult = ReturnType<typeof useLivePageCampaignSubscription>;
export type LivePageCampaignSubscriptionResult = Apollo.SubscriptionResult<LivePageCampaignSubscription>;
export const InitialLivePageDataDocument = gql`
    query InitialLivePageData($slug: String!) {
  Campaign(slug: $slug) {
    _id
    startDate
    closeDate
    reservationsSummary {
      ...ReservationsSummaryForLivePageData
    }
    raisingAmountMinimum
    raisingAmountMaximum
    title
  }
}
    ${ReservationsSummaryForLivePageDataFragmentDoc}`;
export type InitialLivePageDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>
    } & TChildProps;
export function withInitialLivePageData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InitialLivePageDataQuery,
  InitialLivePageDataQueryVariables,
  InitialLivePageDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InitialLivePageDataQuery, InitialLivePageDataQueryVariables, InitialLivePageDataProps<TChildProps, TDataName>>(InitialLivePageDataDocument, {
      alias: 'initialLivePageData',
      ...operationOptions
    });
};

/**
 * __useInitialLivePageDataQuery__
 *
 * To run a query within a React component, call `useInitialLivePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialLivePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialLivePageDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useInitialLivePageDataQuery(baseOptions: Apollo.QueryHookOptions<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>(InitialLivePageDataDocument, options);
      }
export function useInitialLivePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>(InitialLivePageDataDocument, options);
        }
export type InitialLivePageDataQueryHookResult = ReturnType<typeof useInitialLivePageDataQuery>;
export type InitialLivePageDataLazyQueryHookResult = ReturnType<typeof useInitialLivePageDataLazyQuery>;
export type InitialLivePageDataQueryResult = Apollo.QueryResult<InitialLivePageDataQuery, InitialLivePageDataQueryVariables>;
export const CampaignPreorderWithVisitorDocument = gql`
    query CampaignPreorderWithVisitor($slug: String) {
  Campaign(slug: $slug) {
    _id
    title
    slug
  }
  visitorSettings(slug: $slug) {
    _id
    approvedForPreorder
  }
}
    `;
export type CampaignPreorderWithVisitorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>
    } & TChildProps;
export function withCampaignPreorderWithVisitor<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignPreorderWithVisitorQuery,
  CampaignPreorderWithVisitorQueryVariables,
  CampaignPreorderWithVisitorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables, CampaignPreorderWithVisitorProps<TChildProps, TDataName>>(CampaignPreorderWithVisitorDocument, {
      alias: 'campaignPreorderWithVisitor',
      ...operationOptions
    });
};

/**
 * __useCampaignPreorderWithVisitorQuery__
 *
 * To run a query within a React component, call `useCampaignPreorderWithVisitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPreorderWithVisitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPreorderWithVisitorQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCampaignPreorderWithVisitorQuery(baseOptions?: Apollo.QueryHookOptions<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>(CampaignPreorderWithVisitorDocument, options);
      }
export function useCampaignPreorderWithVisitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>(CampaignPreorderWithVisitorDocument, options);
        }
export type CampaignPreorderWithVisitorQueryHookResult = ReturnType<typeof useCampaignPreorderWithVisitorQuery>;
export type CampaignPreorderWithVisitorLazyQueryHookResult = ReturnType<typeof useCampaignPreorderWithVisitorLazyQuery>;
export type CampaignPreorderWithVisitorQueryResult = Apollo.QueryResult<CampaignPreorderWithVisitorQuery, CampaignPreorderWithVisitorQueryVariables>;
export const GetAllPressReleasesDocument = gql`
    query GetAllPressReleases {
  getAllPressReleases {
    _id
    title
    description
    imageUrl
    timestamp
    documentUrl
  }
}
    `;
export type GetAllPressReleasesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>
    } & TChildProps;
export function withGetAllPressReleases<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllPressReleasesQuery,
  GetAllPressReleasesQueryVariables,
  GetAllPressReleasesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables, GetAllPressReleasesProps<TChildProps, TDataName>>(GetAllPressReleasesDocument, {
      alias: 'getAllPressReleases',
      ...operationOptions
    });
};

/**
 * __useGetAllPressReleasesQuery__
 *
 * To run a query within a React component, call `useGetAllPressReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPressReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPressReleasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPressReleasesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>(GetAllPressReleasesDocument, options);
      }
export function useGetAllPressReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>(GetAllPressReleasesDocument, options);
        }
export type GetAllPressReleasesQueryHookResult = ReturnType<typeof useGetAllPressReleasesQuery>;
export type GetAllPressReleasesLazyQueryHookResult = ReturnType<typeof useGetAllPressReleasesLazyQuery>;
export type GetAllPressReleasesQueryResult = Apollo.QueryResult<GetAllPressReleasesQuery, GetAllPressReleasesQueryVariables>;
export const GetAllMediaMentionsDocument = gql`
    query GetAllMediaMentions {
  getAllMediaMentions {
    _id
    title
    description
    imageUrl
    timestamp
    documentUrl
  }
}
    `;
export type GetAllMediaMentionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>
    } & TChildProps;
export function withGetAllMediaMentions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllMediaMentionsQuery,
  GetAllMediaMentionsQueryVariables,
  GetAllMediaMentionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables, GetAllMediaMentionsProps<TChildProps, TDataName>>(GetAllMediaMentionsDocument, {
      alias: 'getAllMediaMentions',
      ...operationOptions
    });
};

/**
 * __useGetAllMediaMentionsQuery__
 *
 * To run a query within a React component, call `useGetAllMediaMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMediaMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMediaMentionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMediaMentionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>(GetAllMediaMentionsDocument, options);
      }
export function useGetAllMediaMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>(GetAllMediaMentionsDocument, options);
        }
export type GetAllMediaMentionsQueryHookResult = ReturnType<typeof useGetAllMediaMentionsQuery>;
export type GetAllMediaMentionsLazyQueryHookResult = ReturnType<typeof useGetAllMediaMentionsLazyQuery>;
export type GetAllMediaMentionsQueryResult = Apollo.QueryResult<GetAllMediaMentionsQuery, GetAllMediaMentionsQueryVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!, $token: String!) {
  setPassword(password: $password, resettoken: $token)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;
export type SetPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>
    } & TChildProps;
export function withSetPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetPasswordMutation,
  SetPasswordMutationVariables,
  SetPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetPasswordMutation, SetPasswordMutationVariables, SetPasswordProps<TChildProps, TDataName>>(SetPasswordDocument, {
      alias: 'setPassword',
      ...operationOptions
    });
};

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const GetPublicDocumentsBySectionDocument = gql`
    query GetPublicDocumentsBySection($section: PublicDocumentSection!) {
  getPublicDocumentsBySection(section: $section) {
    ...publicDocumentFragment
  }
}
    ${PublicDocumentFragmentFragmentDoc}`;
export type GetPublicDocumentsBySectionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>
    } & TChildProps;
export function withGetPublicDocumentsBySection<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPublicDocumentsBySectionQuery,
  GetPublicDocumentsBySectionQueryVariables,
  GetPublicDocumentsBySectionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables, GetPublicDocumentsBySectionProps<TChildProps, TDataName>>(GetPublicDocumentsBySectionDocument, {
      alias: 'getPublicDocumentsBySection',
      ...operationOptions
    });
};

/**
 * __useGetPublicDocumentsBySectionQuery__
 *
 * To run a query within a React component, call `useGetPublicDocumentsBySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicDocumentsBySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicDocumentsBySectionQuery({
 *   variables: {
 *      section: // value for 'section'
 *   },
 * });
 */
export function useGetPublicDocumentsBySectionQuery(baseOptions: Apollo.QueryHookOptions<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>(GetPublicDocumentsBySectionDocument, options);
      }
export function useGetPublicDocumentsBySectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>(GetPublicDocumentsBySectionDocument, options);
        }
export type GetPublicDocumentsBySectionQueryHookResult = ReturnType<typeof useGetPublicDocumentsBySectionQuery>;
export type GetPublicDocumentsBySectionLazyQueryHookResult = ReturnType<typeof useGetPublicDocumentsBySectionLazyQuery>;
export type GetPublicDocumentsBySectionQueryResult = Apollo.QueryResult<GetPublicDocumentsBySectionQuery, GetPublicDocumentsBySectionQueryVariables>;
export const GetStatisticsVideosDocument = gql`
    query GetStatisticsVideos {
  getVideosBySection(section: STATISTICS) {
    _id
    description
    highlighted
    thumbnail
    timestamp
    title
    url
  }
}
    `;
export type GetStatisticsVideosProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>
    } & TChildProps;
export function withGetStatisticsVideos<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetStatisticsVideosQuery,
  GetStatisticsVideosQueryVariables,
  GetStatisticsVideosProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables, GetStatisticsVideosProps<TChildProps, TDataName>>(GetStatisticsVideosDocument, {
      alias: 'getStatisticsVideos',
      ...operationOptions
    });
};

/**
 * __useGetStatisticsVideosQuery__
 *
 * To run a query within a React component, call `useGetStatisticsVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticsVideosQuery(baseOptions?: Apollo.QueryHookOptions<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>(GetStatisticsVideosDocument, options);
      }
export function useGetStatisticsVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>(GetStatisticsVideosDocument, options);
        }
export type GetStatisticsVideosQueryHookResult = ReturnType<typeof useGetStatisticsVideosQuery>;
export type GetStatisticsVideosLazyQueryHookResult = ReturnType<typeof useGetStatisticsVideosLazyQuery>;
export type GetStatisticsVideosQueryResult = Apollo.QueryResult<GetStatisticsVideosQuery, GetStatisticsVideosQueryVariables>;
export const MeEmailSettingsDocument = gql`
    query MeEmailSettings {
  me {
    _id
    email
    notifyInterval
    receiveNewsletter
    emailVerified
  }
}
    `;
export type MeEmailSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>
    } & TChildProps;
export function withMeEmailSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MeEmailSettingsQuery,
  MeEmailSettingsQueryVariables,
  MeEmailSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MeEmailSettingsQuery, MeEmailSettingsQueryVariables, MeEmailSettingsProps<TChildProps, TDataName>>(MeEmailSettingsDocument, {
      alias: 'meEmailSettings',
      ...operationOptions
    });
};

/**
 * __useMeEmailSettingsQuery__
 *
 * To run a query within a React component, call `useMeEmailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeEmailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeEmailSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeEmailSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>(MeEmailSettingsDocument, options);
      }
export function useMeEmailSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>(MeEmailSettingsDocument, options);
        }
export type MeEmailSettingsQueryHookResult = ReturnType<typeof useMeEmailSettingsQuery>;
export type MeEmailSettingsLazyQueryHookResult = ReturnType<typeof useMeEmailSettingsLazyQuery>;
export type MeEmailSettingsQueryResult = Apollo.QueryResult<MeEmailSettingsQuery, MeEmailSettingsQueryVariables>;
export const FetchEmailPreferencesDocument = gql`
    query FetchEmailPreferences($token: String) {
  fetchEmailPreferences(token: $token) {
    email
    notifyInterval
    receiveNewsletter
  }
}
    `;
export type FetchEmailPreferencesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>
    } & TChildProps;
export function withFetchEmailPreferences<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchEmailPreferencesQuery,
  FetchEmailPreferencesQueryVariables,
  FetchEmailPreferencesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables, FetchEmailPreferencesProps<TChildProps, TDataName>>(FetchEmailPreferencesDocument, {
      alias: 'fetchEmailPreferences',
      ...operationOptions
    });
};

/**
 * __useFetchEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useFetchEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmailPreferencesQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFetchEmailPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>(FetchEmailPreferencesDocument, options);
      }
export function useFetchEmailPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>(FetchEmailPreferencesDocument, options);
        }
export type FetchEmailPreferencesQueryHookResult = ReturnType<typeof useFetchEmailPreferencesQuery>;
export type FetchEmailPreferencesLazyQueryHookResult = ReturnType<typeof useFetchEmailPreferencesLazyQuery>;
export type FetchEmailPreferencesQueryResult = Apollo.QueryResult<FetchEmailPreferencesQuery, FetchEmailPreferencesQueryVariables>;
export const UpdateProfileMutationDocument = gql`
    mutation UpdateProfileMutation($input: ProfileUpdateInput!) {
  updateProfile(input: $input)
}
    `;
export type UpdateProfileMutationMutationFn = Apollo.MutationFunction<UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables>;
export type UpdateProfileMutationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables>
    } & TChildProps;
export function withUpdateProfileMutation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateProfileMutationMutation,
  UpdateProfileMutationMutationVariables,
  UpdateProfileMutationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables, UpdateProfileMutationProps<TChildProps, TDataName>>(UpdateProfileMutationDocument, {
      alias: 'updateProfileMutation',
      ...operationOptions
    });
};

/**
 * __useUpdateProfileMutationMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutationMutation, { data, loading, error }] = useUpdateProfileMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables>(UpdateProfileMutationDocument, options);
      }
export type UpdateProfileMutationMutationHookResult = ReturnType<typeof useUpdateProfileMutationMutation>;
export type UpdateProfileMutationMutationResult = Apollo.MutationResult<UpdateProfileMutationMutation>;
export type UpdateProfileMutationMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutationMutation, UpdateProfileMutationMutationVariables>;
export const AcceptTermsMutationDocument = gql`
    mutation AcceptTermsMutation($termsVersion: String, $pep: Boolean) {
  acceptTerms(termsVersion: $termsVersion, pep: $pep)
}
    `;
export type AcceptTermsMutationMutationFn = Apollo.MutationFunction<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>;
export type AcceptTermsMutationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>
    } & TChildProps;
export function withAcceptTermsMutation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcceptTermsMutationMutation,
  AcceptTermsMutationMutationVariables,
  AcceptTermsMutationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables, AcceptTermsMutationProps<TChildProps, TDataName>>(AcceptTermsMutationDocument, {
      alias: 'acceptTermsMutation',
      ...operationOptions
    });
};

/**
 * __useAcceptTermsMutationMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutationMutation, { data, loading, error }] = useAcceptTermsMutationMutation({
 *   variables: {
 *      termsVersion: // value for 'termsVersion'
 *      pep: // value for 'pep'
 *   },
 * });
 */
export function useAcceptTermsMutationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>(AcceptTermsMutationDocument, options);
      }
export type AcceptTermsMutationMutationHookResult = ReturnType<typeof useAcceptTermsMutationMutation>;
export type AcceptTermsMutationMutationResult = Apollo.MutationResult<AcceptTermsMutationMutation>;
export type AcceptTermsMutationMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutationMutation, AcceptTermsMutationMutationVariables>;
export const RequestEmailReVerificationDocument = gql`
    mutation RequestEmailReVerification {
  requestEmailReVerification
}
    `;
export type RequestEmailReVerificationMutationFn = Apollo.MutationFunction<RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables>;
export type RequestEmailReVerificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables>
    } & TChildProps;
export function withRequestEmailReVerification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RequestEmailReVerificationMutation,
  RequestEmailReVerificationMutationVariables,
  RequestEmailReVerificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables, RequestEmailReVerificationProps<TChildProps, TDataName>>(RequestEmailReVerificationDocument, {
      alias: 'requestEmailReVerification',
      ...operationOptions
    });
};

/**
 * __useRequestEmailReVerificationMutation__
 *
 * To run a mutation, you first call `useRequestEmailReVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailReVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailReVerificationMutation, { data, loading, error }] = useRequestEmailReVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestEmailReVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables>(RequestEmailReVerificationDocument, options);
      }
export type RequestEmailReVerificationMutationHookResult = ReturnType<typeof useRequestEmailReVerificationMutation>;
export type RequestEmailReVerificationMutationResult = Apollo.MutationResult<RequestEmailReVerificationMutation>;
export type RequestEmailReVerificationMutationOptions = Apollo.BaseMutationOptions<RequestEmailReVerificationMutation, RequestEmailReVerificationMutationVariables>;
export const ApproveUserForPreorderDocument = gql`
    mutation ApproveUserForPreorder($campaignId: ID!) {
  approveUserForPreorder(campaignId: $campaignId)
}
    `;
export type ApproveUserForPreorderMutationFn = Apollo.MutationFunction<ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables>;
export type ApproveUserForPreorderProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables>
    } & TChildProps;
export function withApproveUserForPreorder<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ApproveUserForPreorderMutation,
  ApproveUserForPreorderMutationVariables,
  ApproveUserForPreorderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables, ApproveUserForPreorderProps<TChildProps, TDataName>>(ApproveUserForPreorderDocument, {
      alias: 'approveUserForPreorder',
      ...operationOptions
    });
};

/**
 * __useApproveUserForPreorderMutation__
 *
 * To run a mutation, you first call `useApproveUserForPreorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveUserForPreorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveUserForPreorderMutation, { data, loading, error }] = useApproveUserForPreorderMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useApproveUserForPreorderMutation(baseOptions?: Apollo.MutationHookOptions<ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables>(ApproveUserForPreorderDocument, options);
      }
export type ApproveUserForPreorderMutationHookResult = ReturnType<typeof useApproveUserForPreorderMutation>;
export type ApproveUserForPreorderMutationResult = Apollo.MutationResult<ApproveUserForPreorderMutation>;
export type ApproveUserForPreorderMutationOptions = Apollo.BaseMutationOptions<ApproveUserForPreorderMutation, ApproveUserForPreorderMutationVariables>;
export const VisitorSettingsDocument = gql`
    query VisitorSettings($slug: String, $campaignId: ID) {
  visitorSettings(slug: $slug, campaignId: $campaignId) {
    _id
    isLoggedIn
    showWelcomeDialog
    acceptsPreorderOffers
    approvedForPreorder
    hasEmailReminder
    isOwner
    isContributor
  }
}
    `;
export type VisitorSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<VisitorSettingsQuery, VisitorSettingsQueryVariables>
    } & TChildProps;
export function withVisitorSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  VisitorSettingsQuery,
  VisitorSettingsQueryVariables,
  VisitorSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, VisitorSettingsQuery, VisitorSettingsQueryVariables, VisitorSettingsProps<TChildProps, TDataName>>(VisitorSettingsDocument, {
      alias: 'visitorSettings',
      ...operationOptions
    });
};

/**
 * __useVisitorSettingsQuery__
 *
 * To run a query within a React component, call `useVisitorSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorSettingsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useVisitorSettingsQuery(baseOptions?: Apollo.QueryHookOptions<VisitorSettingsQuery, VisitorSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorSettingsQuery, VisitorSettingsQueryVariables>(VisitorSettingsDocument, options);
      }
export function useVisitorSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorSettingsQuery, VisitorSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorSettingsQuery, VisitorSettingsQueryVariables>(VisitorSettingsDocument, options);
        }
export type VisitorSettingsQueryHookResult = ReturnType<typeof useVisitorSettingsQuery>;
export type VisitorSettingsLazyQueryHookResult = ReturnType<typeof useVisitorSettingsLazyQuery>;
export type VisitorSettingsQueryResult = Apollo.QueryResult<VisitorSettingsQuery, VisitorSettingsQueryVariables>;
export const GetTermsDocument = gql`
    query GetTerms($version: String, $latest: Boolean) {
  getTerms(version: $version, latest: $latest) {
    content
    version
  }
}
    `;
export type GetTermsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTermsQuery, GetTermsQueryVariables>
    } & TChildProps;
export function withGetTerms<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTermsQuery,
  GetTermsQueryVariables,
  GetTermsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTermsQuery, GetTermsQueryVariables, GetTermsProps<TChildProps, TDataName>>(GetTermsDocument, {
      alias: 'getTerms',
      ...operationOptions
    });
};

/**
 * __useGetTermsQuery__
 *
 * To run a query within a React component, call `useGetTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsQuery({
 *   variables: {
 *      version: // value for 'version'
 *      latest: // value for 'latest'
 *   },
 * });
 */
export function useGetTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
      }
export function useGetTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
        }
export type GetTermsQueryHookResult = ReturnType<typeof useGetTermsQuery>;
export type GetTermsLazyQueryHookResult = ReturnType<typeof useGetTermsLazyQuery>;
export type GetTermsQueryResult = Apollo.QueryResult<GetTermsQuery, GetTermsQueryVariables>;
export const FetchCampaignDocument = gql`
    query FetchCampaign($slug: String) {
  Campaign(slug: $slug) {
    ...campaignView
  }
}
    ${CampaignViewFragmentDoc}`;
export type FetchCampaignProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchCampaignQuery, FetchCampaignQueryVariables>
    } & TChildProps;
export function withFetchCampaign<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchCampaignQuery,
  FetchCampaignQueryVariables,
  FetchCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchCampaignQuery, FetchCampaignQueryVariables, FetchCampaignProps<TChildProps, TDataName>>(FetchCampaignDocument, {
      alias: 'fetchCampaign',
      ...operationOptions
    });
};

/**
 * __useFetchCampaignQuery__
 *
 * To run a query within a React component, call `useFetchCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFetchCampaignQuery(baseOptions?: Apollo.QueryHookOptions<FetchCampaignQuery, FetchCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignQuery, FetchCampaignQueryVariables>(FetchCampaignDocument, options);
      }
export function useFetchCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignQuery, FetchCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignQuery, FetchCampaignQueryVariables>(FetchCampaignDocument, options);
        }
export type FetchCampaignQueryHookResult = ReturnType<typeof useFetchCampaignQuery>;
export type FetchCampaignLazyQueryHookResult = ReturnType<typeof useFetchCampaignLazyQuery>;
export type FetchCampaignQueryResult = Apollo.QueryResult<FetchCampaignQuery, FetchCampaignQueryVariables>;
export const EmailAddressInUseDocument = gql`
    query EmailAddressInUse($email: String) {
  emailAddressInUse(email: $email)
}
    `;
export type EmailAddressInUseProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>
    } & TChildProps;
export function withEmailAddressInUse<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EmailAddressInUseQuery,
  EmailAddressInUseQueryVariables,
  EmailAddressInUseProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EmailAddressInUseQuery, EmailAddressInUseQueryVariables, EmailAddressInUseProps<TChildProps, TDataName>>(EmailAddressInUseDocument, {
      alias: 'emailAddressInUse',
      ...operationOptions
    });
};

/**
 * __useEmailAddressInUseQuery__
 *
 * To run a query within a React component, call `useEmailAddressInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAddressInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAddressInUseQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailAddressInUseQuery(baseOptions?: Apollo.QueryHookOptions<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>(EmailAddressInUseDocument, options);
      }
export function useEmailAddressInUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>(EmailAddressInUseDocument, options);
        }
export type EmailAddressInUseQueryHookResult = ReturnType<typeof useEmailAddressInUseQuery>;
export type EmailAddressInUseLazyQueryHookResult = ReturnType<typeof useEmailAddressInUseLazyQuery>;
export type EmailAddressInUseQueryResult = Apollo.QueryResult<EmailAddressInUseQuery, EmailAddressInUseQueryVariables>;
export const MeAllDocument = gql`
    query MeAll {
  me {
    ...me_all
  }
}
    ${Me_AllFragmentDoc}`;
export type MeAllProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MeAllQuery, MeAllQueryVariables>
    } & TChildProps;
export function withMeAll<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MeAllQuery,
  MeAllQueryVariables,
  MeAllProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MeAllQuery, MeAllQueryVariables, MeAllProps<TChildProps, TDataName>>(MeAllDocument, {
      alias: 'meAll',
      ...operationOptions
    });
};

/**
 * __useMeAllQuery__
 *
 * To run a query within a React component, call `useMeAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeAllQuery(baseOptions?: Apollo.QueryHookOptions<MeAllQuery, MeAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeAllQuery, MeAllQueryVariables>(MeAllDocument, options);
      }
export function useMeAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeAllQuery, MeAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeAllQuery, MeAllQueryVariables>(MeAllDocument, options);
        }
export type MeAllQueryHookResult = ReturnType<typeof useMeAllQuery>;
export type MeAllLazyQueryHookResult = ReturnType<typeof useMeAllLazyQuery>;
export type MeAllQueryResult = Apollo.QueryResult<MeAllQuery, MeAllQueryVariables>;
export const ContextUserUpdatedDocument = gql`
    subscription ContextUserUpdated($_id: ID) {
  userUpdated(_id: $_id) {
    ...me_all
  }
}
    ${Me_AllFragmentDoc}`;
export type ContextUserUpdatedProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ContextUserUpdatedSubscription, ContextUserUpdatedSubscriptionVariables>
    } & TChildProps;
export function withContextUserUpdated<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ContextUserUpdatedSubscription,
  ContextUserUpdatedSubscriptionVariables,
  ContextUserUpdatedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withSubscription<TProps, ContextUserUpdatedSubscription, ContextUserUpdatedSubscriptionVariables, ContextUserUpdatedProps<TChildProps, TDataName>>(ContextUserUpdatedDocument, {
      alias: 'contextUserUpdated',
      ...operationOptions
    });
};

/**
 * __useContextUserUpdatedSubscription__
 *
 * To run a query within a React component, call `useContextUserUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useContextUserUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextUserUpdatedSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useContextUserUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ContextUserUpdatedSubscription, ContextUserUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ContextUserUpdatedSubscription, ContextUserUpdatedSubscriptionVariables>(ContextUserUpdatedDocument, options);
      }
export type ContextUserUpdatedSubscriptionHookResult = ReturnType<typeof useContextUserUpdatedSubscription>;
export type ContextUserUpdatedSubscriptionResult = Apollo.SubscriptionResult<ContextUserUpdatedSubscription>;
export const GetServerTimeDocument = gql`
    query GetServerTime {
  getServerTime
}
    `;
export type GetServerTimeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetServerTimeQuery, GetServerTimeQueryVariables>
    } & TChildProps;
export function withGetServerTime<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetServerTimeQuery,
  GetServerTimeQueryVariables,
  GetServerTimeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetServerTimeQuery, GetServerTimeQueryVariables, GetServerTimeProps<TChildProps, TDataName>>(GetServerTimeDocument, {
      alias: 'getServerTime',
      ...operationOptions
    });
};

/**
 * __useGetServerTimeQuery__
 *
 * To run a query within a React component, call `useGetServerTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerTimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServerTimeQuery(baseOptions?: Apollo.QueryHookOptions<GetServerTimeQuery, GetServerTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServerTimeQuery, GetServerTimeQueryVariables>(GetServerTimeDocument, options);
      }
export function useGetServerTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServerTimeQuery, GetServerTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServerTimeQuery, GetServerTimeQueryVariables>(GetServerTimeDocument, options);
        }
export type GetServerTimeQueryHookResult = ReturnType<typeof useGetServerTimeQuery>;
export type GetServerTimeLazyQueryHookResult = ReturnType<typeof useGetServerTimeLazyQuery>;
export type GetServerTimeQueryResult = Apollo.QueryResult<GetServerTimeQuery, GetServerTimeQueryVariables>;